import React, { Component } from "react";
import { connect } from "react-redux";
import { doUpdateClient, doInsertClient, doUpsertOnboardingIntroVideo } from "../../../actions/inserts";
import { doGetWhitelabels, doGetReduxClient, doGetCompanies, doGetCompanyForClient, doGetEntityConfigs } from "../../../actions/lists";
import { EmailActions, ClientActions, UtilActions, CustomBrandActions } from "../../../actions";
import { ComplianceActions } from "../../../actions/ComplianceActions";
import {
    doValidateUpContentAccountId,
    doGetUpContentFilterViews,
    doGetUpContentContentPolicies,
    doGetUpContentFolders,
    doGetMigrationTermCount,
    doMigrateUpContent,
    doGetMigrationStatus,
    doMarkMigrationResultsViewed,
    doDownloadMigrationResultsCSV
} from "../../../actions/UpContentActions";
import { history } from "../../../utils/store";
import {
    preventDefault,
    getRange,
    sortObject,
    getIndustries,
    deepMerge,
    expand,
    isURL
} from "../../../utils/Helpers";
import { Client } from "../../../utils/Models";
import { createAlert, doSetFooterFunctions } from "../../../actions/utils";
import PageHeading from "../../molecules/PageHeading";
import Tooltip from "../../atoms/Tooltip";
import Toggle from "../../atoms/Toggle";
import Select from "../../atoms/Select";
import PermissionSet from "../../molecules/PermissionSet";
import Button from "../../atoms/Button";
import CopyLink from "../../atoms/CopyLink";
import { ConfirmModal } from "../../atoms/Modal";
import { Wrapper, Row } from "../../atoms/Layout";
import { doGetECommunicationMessages, doUpsertECommunicationMessage, doListSeismicApps } from "../../../actions/index";
import Modal from "react-bootstrap-modal";
import { stripGV6Query } from "../../../utils/Helpers";
import ArticleFileUpload from '../../molecules/ArticleFileUpload';
import Link from "../../atoms/Link";
import DomainFilterActionableList from "../../molecules/DomainFilterActionableList.jsx";
class CreateClient extends Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._onFieldUpdate = this._onFieldUpdate.bind(this);
        this._onTagChange = this._onTagChange.bind(this);
        this._onCustomHeaderChange = this._onCustomHeaderChange.bind(this);
        this._onAutoDomainChange = this._onAutoDomainChange.bind(this);
        this._onDelDomainChange = this._onDelDomainChange.bind(this);
        this._removeAutoDomain = this._removeAutoDomain.bind(this);
        this._removeDelDomain = this._removeDelDomain.bind(this);
        this._onChangeTimeout = this._onChangeTimeout.bind(this);
        this._getExtendedTime = this._getExtendedTime.bind(this);
        this._getSharingSettings = this._getSharingSettings.bind(this);
        this._getSMSSettings = this._getSMSSettings.bind(this);
        this._onSharingSettingChange = this._onSharingSettingChange.bind(this);
        this._getSAMLSettings = this._getSAMLSettings.bind(this);
        this._getSeismicSSOSettings = this._getSeismicSSOSettings.bind(this);
        this._getInputLogoDetails = this._getInputLogoDetails.bind(this);
        this._getInputWeeklyLogoDetails = this._getInputWeeklyLogoDetails.bind(this);
        this._triggerUpContentMigration = this._triggerUpContentMigration.bind(this);
        this._downloadMigrationResultsCSV = this._downloadMigrationResultsCSV.bind(this);
        this._loadMigrationResults = this._loadMigrationResults.bind(this);

        let cid = "";
        let insert = true;
        if (props.match.params.cid) {
            cid = props.match.params.cid;
            insert = false;
        }

        this.state = Client({ cid: cid });
        this.state.insert = insert;
        this.state.filterLang = "";
        this.state.extractTextFilter = [];
        this.state.previewModalOpen = false;
        this.state.emailAddress = "";
        this.state.emailType = props.emailType;
        this.state.trueDelegateRid = "";
        this.state.newTrueDelegateRid = "";
        this.state.roles = {};
        this.state.companiesLoaded = false;
        this.state.showSharingPermissionsModal = false;
        this.state.skipModal = false;
        this.state.seismicApps = [];
        this.state.excludeFromWeeklyEmails = false;
        this.state.allowNetworkSuggestedComments = false;

        // UpContent progressive validation state
        this.state.upContentChildClientAccountIdValid = null;
        this.state.upContentChildClientFolderIdValid = null;
        this.state.upContentChildClientFilterViewIdValid = null;
        this.state.upContentChildClientContentPolicyIdValid = null;
        this.state.upContentFilterViewOptions = [];
        this.state.upContentContentPolicyOptions = [];
        this.state.upContentFolderOptions = [];
        this.state.upContentLoading = false;

        // UpContent caching to avoid unnecessary API calls
        this.state.upContentCachedAccountId = null;
        this.state.upContentDataCached = false;

        // UpContent migration tracking
        this.state.migrationInProgress = false;
        this.state.migrationProgress = 0;
        this.state.migrationStatus = '';
        this.state.migrationResultsAvailable = false;
        this.state.migrationResultsLoading = false;
        this.state.migrationResults = null;
        this.state.migrationEstimatedTime = 0;
        this.state.migrationStartTime = null;
        this.state.migrationTotalTerms = 0;

        this.state.beeCustomRowsJson = "";
        this.state._onboardingIntro = {};
        this.state._onboardingIntro["en"] = { videoUploaded: false, videoName: "GettingStartedWithLiveSocial.mp4", videoSrc: "" };
        this.state._onboardingIntro["fr"] = { videoUploaded: false, videoName: "GettingStartedWithLiveSocial.mp4", videoSrc: "" };
        this.state.allowContentAnalysisModal = false;
        this.state.brands = [];

        this.state.uploadedLogoURL = "";
        this.state.uploadedWeeklyEmailURL = "";
        this.state.fileUploadLogo = null;
        this.state.fileUploadWeeklyEmailLogo = null;
        this.state.uploadedFileLogo = false;
        this.state.uploadedFileWeeklyEmailLogo = false;
        this.state.autoDomainType = "regDomains";
        this.state.enableTwitterSocialMetrics = false;
        this.state.editStartTime = new Date();
    }
    async componentDidMount() {
        this.nameInput.focus();
        let self = this;
        if (this.props.location.search.indexOf("ngSuccess") > -1) {
            history.push(this.props.location.pathname);
            const ngSuccess = this.props.location.search.split("ngSuccess=")[1].split("&")[0];
            if (ngSuccess === "false") {
                createAlert("An error occurred while creating Proofpoint compliance settings");
            }
        }
        if (!this.props.readOnly) {
            doSetFooterFunctions(this._onSubmit, null, this.state.insert ? "Create" : "Update");
        }

        const [
            client,
            whitelabels,
            existsReadOnlyContent,
            { items: brands },
            seismicApps
        ] = await Promise.all([
            this.state.cid ? doGetReduxClient(this.state.cid) : {},
            this.props.readOnly ? [] : doGetWhitelabels(),
            this.state.cid ? ClientActions.doGetReadOnlyContent(this.state.cid) : false,
            this.props.readOnly ? { items: [] } : CustomBrandActions.doList(),
            doListSeismicApps()
        ]).catch(() => null);

        if (this.state.configName) {
            const defaultFromEmailAddress = await this.getDefaultEmailAddress(this.state.configName);
            this.setState({ defaultFromEmailAddress });
        }
        this.setState({ seismicApps });

        const data = !("valid" in whitelabels)
            ? {
                whiteLabels: whitelabels,
                configName: whitelabels[0]
            }
            : null;

        if (data && self.state.insert) {
            data.tempVendor = "";
            self.setState(data);
        } else {
            const state = Client(client);
            state.insert = self.state.insert;
            state.tags = sortObject(state.tags);
            if (data) {
                state.whiteLabels = data.whiteLabels;
                if (!state.configName && data.configName) {
                    state.configName = data.configName;
                }
            }
            state.trackingCodeDomains = state.trackingCodeDomains
                ? Array.isArray(state.trackingCodeDomains)
                    ? state.trackingCodeDomains.join(", ")
                    : state.trackingCodeDomains
                : null;
            state.extracted_frontendSessionTimeout = self._getExtendedTime(state.frontendSessionTimeout);
            state.extracted_consoleSessionTimeout = self._getExtendedTime(state.consoleSessionTimeout);
            ComplianceActions.getComplianceSettings(self.state.cid).then(async result => {
                state.vendor = result ? result.complianceVendor : null;
                state.tempVendor = result ? result.complianceVendor : "";
                if (state.vendor == "ng") {
                    const entityConfigs = await doGetEntityConfigs(self.state.cid, true).catch(err => null);
                    state.entityConfigOptions = Object.entries(entityConfigs || {}).map(([k, v]) => {
                        return {
                            label: k,
                            value: entityConfigs[k].split(/(?=INSTALL-)/g).pop()
                        }
                    });
                }
                self.setState(state);
            });
            let rows = "";
            if (state.eCommunication.beeCustomRows) {
                state.eCommunication.beeCustomRows.forEach(row => { rows += row + "\n"; });
            }
            state.beeCustomRowsJson = rows;
            if (self.state.defaultFromEmailAddress && (state.fromEmail === "" || state.fromEmail == null)) {
                state.fromEmail = self.state.defaultFromEmailAddress;
            }

            // Initialize migration results if they exist - but don't load large arrays on page load
            // Results will be loaded on-demand when user requests them

            // Check if migration is completed but don't set results available until user clicks View Results
            if (state.upContentMigrated && state.upContentMigrationCompletedAt) {
                state.migrationInProgress = false;
                state.migrationProgress = 100;

                // Only show status if results haven't been viewed yet
                if (!state.upContentMigrationResultViewed) {
                    state.migrationStatus = 'Migration completed. Click "View Results" to load details.';
                }
            }
            // IMPORTANT: Never read upContentTotalTermsCount/upContentMigratedTermsCount from client collection
            // as these fields are NOT updated during migration - they only exist in the migration collection.
            // Always fetch fresh data from the migration-status endpoint to get real-time progress.
            if (state.upContentMigrationStatus && !state.upContentMigrated) {
                // Migration might be in progress - fetch real-time status from migration collection
                // Set minimal loading state, actual progress will be loaded from migration-status endpoint
                state.migrationInProgress = true;
                state.migrationProgress = 0;
                state.migrationStatus = 'Loading migration status...';
                state.migrationTotalTerms = 0;
            }

            Object.keys(self.state._onboardingIntro).forEach(key => {
                if (state.onboardingIntro[key] && self.state._onboardingIntro[key]) {
                    const intro = state.onboardingIntro[key];
                    self.state._onboardingIntro[key].videoName = intro.videoName;
                    self.state._onboardingIntro[key].videoSrc = intro.videoUrl;
                }
            });

            const shouldCheckMigration = state.upContentMigrationStatus && !state.upContentMigrated;
            // Set state first, then check migration status in the callback
            self.setState(state, async () => {
                // Always initialize UpContent validation after state is set
                if (self.state.upContentChildClientAccountId) {
                    self._initializeUpContentValidation();
                }

                // Check migration status after user logs back in
                if (shouldCheckMigration) {
                    try {
                        const statusData = await doGetMigrationStatus(self.state.cid);

                        if (statusData && statusData.valid) {
                            if (statusData.isComplete) {
                                // Migration completed while user was logged out!
                                const successfulCount = statusData.results?.successfulCount || 0;
                                const failedCount = statusData.results?.failedCount || 0;

                                self.setState({
                                    migrationInProgress: false,
                                    migrationProgress: 100,
                                    migrationStatus: `Migration completed. ${successfulCount} terms migrated, ${failedCount} failed.`,
                                    upContentMigrated: true,
                                    upContentMigrationCompletedAt: statusData.completedAt
                                });

                                createAlert(
                                    `Migration completed! ${successfulCount} terms migrated successfully.`,
                                    failedCount > 0 ? 'warning' : 'success'
                                );
                            } else if (statusData.progress) {
                                // Migration still in progress - continue monitoring
                                const { completed, total, percentage } = statusData.progress;
                                self.setState({
                                    migrationInProgress: true,
                                    migrationProgress: percentage,
                                    migrationStatus: `${statusData.status} (${completed}/${total} terms)`,
                                    migrationTotalTerms: total
                                });

                                // Start regular monitoring
                                self._startProgressMonitoring();
                            }
                        }
                    } catch (error) {
                        console.error('[Migration] Failed to fetch initial status:', error);
                    }
                }
            });
        }

        const { cid } = this.state;
        const { clients } = this.props;
        const roles = clients?.[cid]?.roles || {};
        const autoDomainType = clients?.[cid]?.blockDomains?.length ? "blockDomains" : "regDomains";
        const trueDelegateRid = Object.keys(roles).filter(rid => roles[rid].defaultTrueDelegate)[0];

        // Initialize UpContent auto-population if account ID exists
        if (this.state.upContentChildClientAccountId) {
            this._initializeUpContentValidation();
        }

        this.setState({
            autoDomainType,
            roles,
            existsReadOnlyContent,
            brands: brands.map(brand => brand.brandName).sort(),
            ...(trueDelegateRid ? { newTrueDelegateRid: trueDelegateRid } : null)
        });

        // initialize the default for embeddedClientURL if applicable
        let { seismic } = this.state;
        if (this._canEmbeddedClientUrlDisabled()) {
            this.setState({ embeddedClientURL: seismic.authBaseUrl })
        }
    }

    componentWillUnmount() {
        doSetFooterFunctions(null, null);
        // Clean up progress monitoring interval
        this._stopProgressMonitoring();

        if (this.alertTimeout) {
            clearTimeout(this.alertTimeout);
            this.alertTimeout = null;
        }
        if (this.monitoringTimeout) {
            clearTimeout(this.monitoringTimeout);
            this.monitoringTimeout = null;
        }
    }

    _getExtendedTime(timeout) {
        return {
            day: Math.floor(((timeout * 60) % 31536000) / 86400),
            hour: Math.floor((((timeout * 60) % 31536000) % 86400) / 3600),
            minute: Math.floor(((((timeout * 60) % 31536000) % 86400) % 3600) / 60)
        };
    }

    componentWillReceiveProps(newProps) {
        let companiesLoaded = false;
        if (!newProps.companies.length && !this.state.companiesLoaded) {
            companiesLoaded = true;
            if (this.props.readOnly) {
                doGetCompanyForClient();
            } else {
                doGetCompanies();
            }
        }
        if (!this.state.code && newProps.clients && newProps.clients[this.state.cid]) {
            let client = Client(newProps.clients[this.state.cid]);

            client.extracted_frontendSessionTimeout = this._getExtendedTime(client.frontendSessionTimeout);
            client.extracted_consoleSessionTimeout = this._getExtendedTime(client.consoleSessionTimeout);
            client.trackingCodeDomains = client.trackingCodeDomains
                ? Array.isArray(client.trackingCodeDomains)
                    ? client.trackingCodeDomains.join(", ")
                    : client.trackingCodeDomains
                : null;

            this.setState({ ...client, tags: sortObject(client.tags) });
        }
        if (companiesLoaded) {
            this.setState({ companiesLoaded })
        }
    }

    async getDefaultEmailAddress(configName) {
        const defaultEmailAddress = "notifications@livesocial.seismic.com";
        const emailReg = /\b([^\s]+@[^\s]+)\b/g; // To Extract the email from the sendgrid from as it return name and email
        const whiteLabel = await UtilActions.doGetWhiteLabelSettings(configName);
        // use white label config, if no white label config, use default;
        return whiteLabel?.emailFrom?.match(emailReg)?.[0] || defaultEmailAddress;
    }

    _onEmailLangUpdate(emailType, event) {
        const { customEmails } = this.state;
        const lang = event.target.value || "en";
        // Fill default values for missing email templates to avoid clients without any email template values causing error.
        if (!customEmails[emailType]) {
            customEmails[emailType] = { en: { body: "", subject: "" }, fr: { body: "", subject: "" } };
        } else if (!customEmails[emailType][lang]) {
            customEmails[emailType][lang] = { body: "", subject: "" };
        } else if (!customEmails[emailType][lang]["body"]) {
            customEmails[emailType][lang]["body"] = "";
        } else if (!customEmails[emailType][lang]["subject"]) {
            customEmails[emailType][lang]["subject"] = "";
        }
        this.setState({ customEmails });
        this._onFieldUpdate(`__${emailType}-lang`, event);
    }

    _onFieldUpdate(field, event) {
        let state = {};
        const value = event?.target ? event.target.value : event;
        if (field.indexOf(".") > -1) {
            const obj = expand(field, value); // mutate key into object with value
            const firstKey = Object.keys(obj)[0]; // get the outer most property
            const origValue = { [firstKey]: this.state[firstKey] }; // current value in state
            state = deepMerge(origValue, obj); // merge both values together and push into state
        } else {
            state[field] = value;
        }
        if (field == "hasExtraNetworks" && !value) {
            state.strictExtraNetworks = false;
        }
        if (field == "autoDomainType") {
            if (value == "regDomains") {
                state.blockEmails = [];
            } else if (value == "blockDomains") {
                state.regEmails = [];
            }
        }

        // Progressive validation for UpContent account ID
        if (field === "upContentChildClientAccountId") {
            state.upContentChildClientAccountIdValid = null; // Reset validation state
            state.upContentChildClientFolderIdValid = null;
            state.upContentChildClientFilterViewIdValid = null;
            state.upContentChildClientContentPolicyIdValid = null;
            state.upContentFilterViewOptions = [];
            state.upContentContentPolicyOptions = [];
            state.upContentFolderOptions = [];
            state.upContentChildClientFilterViewId = "";
            state.upContentChildClientContentPolicyId = "";
            state.upContentChildClientFolderId = "";

            // Clear cache when account ID changes
            state.upContentCachedAccountId = null;
            state.upContentDataCached = false;

            // Trigger validation if value is provided
            if (value && value.trim()) {
                this._validateUpContentAccountId(value.trim());
            }
        }

        // Re-enable dropdowns when folder ID changes
        if (field === "upContentChildClientFolderId") {
            // Validate folder ID if provided
            if (value && value.trim()) {
                const isValidFolder = this.state.upContentFolderOptions.find(folder => folder.id === value.trim());
                state.upContentChildClientFolderIdValid = isValidFolder ? true : false;
            } else {
                state.upContentChildClientFolderIdValid = null;
            }

            // If account ID is valid and folder ID changes, reload dropdown options
            if (this.state.upContentChildClientAccountIdValid && this.state.upContentChildClientAccountId) {
                // Clear current selections for filter view and content policy
                state.upContentChildClientFilterViewId = "";
                state.upContentChildClientContentPolicyId = "";
                // Reload dropdown options
                this._loadUpContentDropdownOptions(this.state.upContentChildClientAccountId);
            }
        }

        // Validate filter view ID when it changes
        if (field === "upContentChildClientFilterViewId") {
            if (value && value.trim()) {
                const isValidFilterView = this.state.upContentFilterViewOptions.find(view => view.id === value.trim());
                state.upContentChildClientFilterViewIdValid = isValidFilterView ? true : false;
            } else {
                state.upContentChildClientFilterViewIdValid = null;
            }
        }

        // Validate content policy ID when it changes
        if (field === "upContentChildClientContentPolicyId") {
            if (value && value.trim()) {
                const isValidContentPolicy = this.state.upContentContentPolicyOptions.find(policy => policy.id === value.trim());
                state.upContentChildClientContentPolicyIdValid = isValidContentPolicy ? true : false;
            } else {
                state.upContentChildClientContentPolicyIdValid = null;
            }
        }

        this.setState(state);
    }

    // UpContent progressive validation methods
    async _validateUpContentAccountId(accountId) {
        // Only validate if UpContent is enabled
        if (!this.state.enableUpContent) {
            // If not enabled, skip validation and clear any previous validation state
            this.setState({
                upContentChildClientAccountIdValid: null,
                upContentChildClientFolderIdValid: null,
                upContentChildClientFilterViewIdValid: null,
                upContentChildClientContentPolicyIdValid: null,
                upContentFilterViewOptions: [],
                upContentContentPolicyOptions: [],
                upContentFolderOptions: [],
                upContentCachedAccountId: null,
                upContentDataCached: false,
                upContentLoading: false
            });
            return;
        }

        this.setState({ upContentLoading: true });

        try {
            const result = await doValidateUpContentAccountId(accountId, this.state.cid);

            if (result.valid) {
                this.setState({
                    upContentChildClientAccountIdValid: true
                });
                createAlert("UpContent Account ID validated successfully!", "success");
                // Load dropdown options
                await this._loadUpContentDropdownOptions(accountId);
            } else {
                createAlert("Invalid UpContent Account ID. Please check and try again.", "error");
                this._clearUpContentCache();
                this.setState({
                    upContentChildClientAccountIdValid: false,
                    upContentChildClientFolderIdValid: false,
                    upContentChildClientFilterViewIdValid: false,
                    upContentChildClientContentPolicyIdValid: false,
                    upContentFilterViewOptions: [],
                    upContentContentPolicyOptions: [],
                    upContentFolderOptions: [],
                    upContentCachedAccountId: null,
                    upContentDataCached: false
                });
            }
        } catch (error) {
            console.error('Error validating UpContent account ID:', error);
            createAlert("Error validating UpContent account ID. Please check your connection and try again.", "error");
            this._clearUpContentCache();
            this.setState({
                upContentChildClientAccountIdValid: false,
                upContentChildClientFolderIdValid: false,
                upContentChildClientFilterViewIdValid: false,
                upContentChildClientContentPolicyIdValid: false,
                upContentFilterViewOptions: [],
                upContentContentPolicyOptions: [],
                upContentFolderOptions: [],
                upContentCachedAccountId: null,
                upContentDataCached: false
            });
        } finally {
            this.setState({ upContentLoading: false });
        }
    }
    async _loadUpContentDropdownOptions(accountId) {
        // Only load dropdown options if UpContent is enabled
        if (!this.state.enableUpContent) {
            // If not enabled, do not load or log anything
            return;
        }
        try {
            // Check if data is already cached for this account ID
            if (this.state.upContentCachedAccountId === accountId && this.state.upContentDataCached) {
                createAlert("Using cached UpContent data", "info");
                // Data is already loaded, just validate existing selections
                this._validateExistingUpContentSelections();
                return;
            }
            // Load filter views, content policies, and folders in parallel using standardized actions
            const [filterViewsResult, contentPoliciesResult, foldersResult] = await Promise.all([
                doGetUpContentFilterViews(accountId, this.state.cid),
                doGetUpContentContentPolicies(accountId, this.state.cid),
                doGetUpContentFolders(accountId, this.state.cid)
            ]);

            this.setState({
                upContentFilterViewOptions: filterViewsResult.valid ? filterViewsResult.data : [],
                upContentContentPolicyOptions: contentPoliciesResult.valid ? contentPoliciesResult.data : [],
                upContentFolderOptions: foldersResult.valid ? foldersResult.data : [],
                upContentCachedAccountId: accountId,
                upContentDataCached: true
            });

            // Show success message when data is loaded fresh
            createAlert("UpContent dropdown options loaded successfully!", "success");

            // Validate existing selections after loading new options
            this._validateExistingUpContentSelections();
        } catch (error) {
            console.error('Error loading UpContent dropdown options:', error);
            createAlert("Error loading UpContent dropdown options. Please check your connection and try again.", "error");
            this.setState({
                upContentFilterViewOptions: [],
                upContentContentPolicyOptions: [],
                upContentFolderOptions: [],
                upContentCachedAccountId: null,
                upContentDataCached: false
            });
        }
    }

    // Initialize UpContent validation on component mount
    async _initializeUpContentValidation() {
        const accountId = this.state.upContentChildClientAccountId;
        if (!accountId) return;

        try {
            // First validate the account ID using standardized action
            const result = await doValidateUpContentAccountId(accountId, this.state.cid);

            if (result.valid) {
                this.setState({
                    upContentChildClientAccountIdValid: true
                });

                // Load dropdown options
                await this._loadUpContentDropdownOptions(accountId);

                // After loading options, validate existing selections
                this._validateExistingUpContentSelections();
            } else {
                this.setState({
                    upContentChildClientAccountIdValid: false,
                    upContentChildClientFolderIdValid: false,
                    upContentChildClientFilterViewIdValid: false,
                    upContentChildClientContentPolicyIdValid: false,
                    upContentFilterViewOptions: [],
                    upContentContentPolicyOptions: [],
                    upContentFolderOptions: [],
                    upContentCachedAccountId: null,
                    upContentDataCached: false
                });
            }
        } catch (error) {
            console.error('Error initializing UpContent validation:', error);
            createAlert("Error initializing UpContent validation. Please check your connection and try again.", "error");
            this.setState({
                upContentChildClientAccountIdValid: false,
                upContentChildClientFolderIdValid: false,
                upContentChildClientFilterViewIdValid: false,
                upContentChildClientContentPolicyIdValid: false,
                upContentFilterViewOptions: [],
                upContentContentPolicyOptions: [],
                upContentFolderOptions: [],
                upContentCachedAccountId: null,
                upContentDataCached: false
            });
        }
    }

    // Validate existing UpContent selections after loading dropdown options
    _validateExistingUpContentSelections() {
        const {
            upContentChildClientFolderId,
            upContentChildClientFilterViewId,
            upContentChildClientContentPolicyId,
            upContentFolderOptions,
            upContentFilterViewOptions,
            upContentContentPolicyOptions
        } = this.state;

        const newState = {};

        // Validate folder ID
        if (upContentChildClientFolderId) {
            const isValidFolder = upContentFolderOptions.find(folder => folder.id === upContentChildClientFolderId);
            newState.upContentChildClientFolderIdValid = isValidFolder ? true : false;
        }

        // Validate filter view ID
        if (upContentChildClientFilterViewId) {
            const isValidFilterView = upContentFilterViewOptions.find(view => view.id === upContentChildClientFilterViewId);
            newState.upContentChildClientFilterViewIdValid = isValidFilterView ? true : false;
        }

        // Validate content policy ID
        if (upContentChildClientContentPolicyId) {
            const isValidContentPolicy = upContentContentPolicyOptions.find(policy => policy.id === upContentChildClientContentPolicyId);
            newState.upContentChildClientContentPolicyIdValid = isValidContentPolicy ? true : false;
        }

        // Update state with validation results
        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    }

    // Validate all UpContent IDs before saving the client
    _validateUpContentConfiguration() {
        const {
            upContentChildClientAccountId,
            upContentChildClientFolderId,
            upContentChildClientFilterViewId,
            upContentChildClientContentPolicyId,
            upContentChildClientAccountIdValid,
            upContentFilterViewOptions,
            upContentContentPolicyOptions,
            upContentFolderOptions
        } = this.state;

        // If no UpContent account ID is provided, skip validation (UpContent is optional)
        if (!upContentChildClientAccountId || !upContentChildClientAccountId.trim()) {
            return { valid: true };
        }

        // If account ID is provided, it must be valid
        if (upContentChildClientAccountIdValid !== true) {
            return {
                valid: false,
                error: "UpContent Account ID is invalid. Please enter a valid account ID."
            };
        }

        // If account ID is valid, check if all other required fields are provided and valid
        const requiredFields = [];

        // Check folder ID
        if (!upContentChildClientFolderId || !upContentChildClientFolderId.trim()) {
            requiredFields.push("Folder ID");
        } else if (!upContentFolderOptions.find(folder => folder.id === upContentChildClientFolderId)) {
            return {
                valid: false,
                error: "Selected Folder ID is not valid for this account. Please select a valid folder."
            };
        }

        // Check filter view ID
        if (!upContentChildClientFilterViewId || !upContentChildClientFilterViewId.trim()) {
            requiredFields.push("Filter View ID");
        } else if (!upContentFilterViewOptions.find(view => view.id === upContentChildClientFilterViewId)) {
            return {
                valid: false,
                error: "Selected Filter View ID is not valid for this account. Please select a valid filter view."
            };
        }

        // Check content policy ID
        if (!upContentChildClientContentPolicyId || !upContentChildClientContentPolicyId.trim()) {
            requiredFields.push("Content Policy ID");
        } else if (!upContentContentPolicyOptions.find(policy => policy.id === upContentChildClientContentPolicyId)) {
            return {
                valid: false,
                error: "Selected Content Policy ID is not valid for this account. Please select a valid content policy."
            };
        }

        // If any required fields are missing
        if (requiredFields.length > 0) {
            return {
                valid: false,
                error: `UpContent configuration is incomplete. Please provide: ${requiredFields.join(", ")}.`
            };
        }

        // If hierarchy requires a child folder but none is valid, force parentOnly
        const hierarchy = this.state.upContentInterestSearchHierarchy || "parentOnly";
        if (hierarchy !== "parentOnly" && !this.state.upContentChildClientFolderIdValid) {
            return {
                valid: false,
                error: `Interest Search Hierarchy "${hierarchy}" requires a valid child folder. Please select a valid child folder or switch to "Parent Only".`
            };
        }

        return { valid: true };
    }

    _clearUpContentCache() {
        // Clear cached data when validation fails or account ID changes
        this.setState({
            upContentCachedAccountId: null,
            upContentDataCached: false,
            upContentFilterViewOptions: [],
            upContentContentPolicyOptions: [],
            upContentFolderOptions: []
        });
    }

    // UpContent migration functions
    async _triggerUpContentMigration() {
        const { cid } = this.state;

        if (!cid) {
            createAlert('Client ID is required for migration', 'error');
            return;
        }

        if (!this.state.upContentChildClientAccountId) {
            createAlert('UpContent Account ID is required for migration', 'error');
            return;
        }

        try {
            this.setState({
                migrationInProgress: true,
                migrationProgress: 0,
                migrationStatus: 'Initializing migration...',
                migrationStartTime: new Date()
            });

            // First, get the count of terms to estimate time
            await this._estimateMigrationTime();

            // Start progress monitoring with a slight delay to let backend initialize
            setTimeout(() => {
                if (this.state.migrationInProgress) {
                    this._startProgressMonitoring();
                }
            }, 500);

            // Call the new migration endpoint using standardized action
            const result = await doMigrateUpContent(cid);

            if (result && result.valid) {
                // Migration started successfully in background
                // Continue monitoring progress via the status endpoint
                createAlert('Migration started successfully. Progress will be monitored in real-time.', 'success');

            } else {
                throw new Error(result?.message || 'Migration failed to start');
            }

        } catch (error) {
            this._stopProgressMonitoring();

            // Provide more helpful error message for common issues
            let errorMessage = error.message || 'Unknown error occurred';

            // Check for timeout or network errors
            if (errorMessage.includes('Failed to fetch') || errorMessage.includes('NetworkError')) {
                errorMessage = 'Network error: Unable to connect to server. The migration may be running in the background - check the migration status in a few minutes.';
            } else if (errorMessage.includes('timeout') || errorMessage.includes('504')) {
                errorMessage = 'Request timeout: Migration is taking longer than expected. It may still be running - check console logs or migration status.';
            }

            this.setState({
                migrationInProgress: false,
                migrationStatus: `Migration failed: ${errorMessage}`,
            });
            createAlert(`Migration failed: ${errorMessage}`, 'error');
        }
    }

    _startProgressMonitoring() {
        // For small migrations, check more frequently (every 1.5 seconds)
        // For larger migrations, check every 3 seconds to reduce load
        const pollInterval = this.state.migrationTotalTerms <= 100 ? 1500 : 3000;
        // Check actual migration status using dedicated migration-status endpoint
        this.progressInterval = setInterval(async () => {
            if (this.state.migrationInProgress) {
                try {
                    // Use dedicated migration-status endpoint for structured response
                    const statusData = await doGetMigrationStatus(this.state.cid);

                    if (statusData && statusData.valid) {
                        if (statusData.isComplete) {
                            // Migration completed
                            this._stopProgressMonitoring();

                            const successfulCount = statusData.results?.successfulCount || 0;
                            const failedCount = statusData.results?.failedCount || 0;
                            const successfulTerms = statusData.results?.successfulTerms || [];
                            const failedTerms = statusData.results?.failedTerms || [];

                            let alertType = 'success';
                            let alertMessage = `Migration completed! ${successfulCount} terms migrated successfully.`;

                            this.setState({
                                migrationInProgress: false,
                                migrationProgress: 100,
                                migrationStatus: statusData.status || 'Migration completed',
                                upContentMigrated: true,
                                migrationResults: {
                                    successfulTerms: successfulTerms,
                                    failedTerms: failedTerms,
                                    successfulTermsCount: successfulCount,
                                    failedTermsCount: failedCount
                                }
                            });

                            createAlert(alertMessage, alertType);

                            // Mark results as viewed since user is actively watching
                            doMarkMigrationResultsViewed(this.state.cid).catch(err => {
                                console.error('[Migration] Failed to mark results as viewed:', err);
                            });
                        } else if (statusData.progress) {
                            // Migration still in progress - update status from structured response
                            const { completed, total, percentage } = statusData.progress;

                            this.setState({
                                migrationProgress: percentage,
                                migrationStatus: `${statusData.status} (${completed}/${total} terms)`,
                                migrationTotalTerms: total
                            });
                        }
                    }
                } catch (error) {
                    // Error checking migration status - log but continue polling
                }
            } else {
                this._stopProgressMonitoring();
            }
        }, pollInterval);
    }

    _stopProgressMonitoring() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
            this.progressInterval = null;
        }
    }

    async _checkAndResumeMigration() {
        // Check if there's an in-progress migration for this client
        const { cid, upContentMigrated, upContentMigrationStatus } = this.state;

        if (!cid) {
            return;
        }

        // Look for signs of in-progress migration
        const inProgressIndicators = [
            'Starting migration',
            'Finding users',
            'Extracting',
            'Deduplicating',
            'Migrating terms',
            'batch processing'
        ];

        const mightBeInProgress = upContentMigrationStatus &&
            inProgressIndicators.some(indicator =>
                upContentMigrationStatus.toLowerCase().includes(indicator.toLowerCase())
            );

        if (mightBeInProgress && !upContentMigrated) {
            // Migration appears to be in progress, resume monitoring
            this.setState({
                migrationInProgress: true,
                migrationStatus: upContentMigrationStatus || 'Resuming migration monitoring...'
            });

            this._startProgressMonitoring();
        }
    }

    async _estimateMigrationTime() {
        // Get the REAL term count from the backend instead of fake estimates
        try {
            // Call backend to get actual term count for this client using standardized action
            const result = await doGetMigrationTermCount(this.state.cid);

            if (result && result.valid) {
                const realTermCount = result.termCount || 0;
                const realUserCount = result.userCount || 0;
                // Calculate realistic time based on actual terms
                const CONCURRENT_TERMS = 10; // From migration service
                const RATE_LIMIT_DELAY = 100; // ms
                const batches = Math.ceil(realTermCount / CONCURRENT_TERMS);

                let timePerBatch;
                if (realTermCount < 50) {
                    timePerBatch = 0.5;
                } else if (realTermCount < 200) {
                    timePerBatch = 1.0;
                } else {
                    timePerBatch = 1.5;
                }

                const estimatedTimeSeconds = Math.max(
                    (batches * timePerBatch) + (batches * RATE_LIMIT_DELAY / 1000),
                    10 // Minimum 10 seconds to give backend time to update progress
                );

                this.setState({
                    migrationTotalTerms: realTermCount,
                    migrationEstimatedTime: estimatedTimeSeconds,
                    migrationStatus: `Found ${realTermCount} unique terms from ${realUserCount} users. Estimated time: ${this._formatTime(estimatedTimeSeconds)}`
                });
            } else {
                throw new Error(result?.message || 'Failed to get term count');
            }

        } catch (error) {
            // Fallback to minimal estimation
            this.setState({
                migrationStatus: 'Starting migration...',
                migrationEstimatedTime: 10, // Much shorter fallback
                migrationTotalTerms: 0
            });
        }
    }

    async _fallbackEstimation() {
        // This method is kept for compatibility but simplified
        this.setState({
            migrationStatus: 'Starting migration...',
            migrationEstimatedTime: 30 // Default to 30 seconds
        });
    }

    _formatTime(seconds) {
        if (seconds < 60) {
            return `${seconds} seconds`;
        } else if (seconds < 3600) {
            const minutes = Math.ceil(seconds / 60);
            return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
        } else {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.ceil((seconds % 3600) / 60);
            return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
        }
    }

    _getMigrationProgressPercent() {
        const { migrationStartTime, migrationEstimatedTime, migrationInProgress } = this.state;

        if (!migrationInProgress || !migrationStartTime || !migrationEstimatedTime) {
            return 0;
        }

        const elapsed = (new Date() - migrationStartTime) / 1000; // seconds
        const progress = Math.min((elapsed / migrationEstimatedTime) * 100, 95); // Cap at 95% until completion
        return Math.round(progress);
    }

    async _loadMigrationResults() {
        const { cid } = this.state;

        if (!cid) {
            createAlert('Client ID is required', 'error');
            return;
        }

        this.setState({ migrationResultsLoading: true });

        try {
            const response = await doGetMigrationStatus(cid);

            if (!response.valid) {
                // No migration results found
                createAlert('No migration results found. Please run migration.', 'warning');
                this.setState({
                    migrationResultsLoading: false,
                    migrationResultsAvailable: false,
                    migrationStatus: ''
                });
                return;
            } // Update state with migration results
            this.setState({
                migrationResultsLoading: false,
                migrationResultsAvailable: response.isComplete,
                migrationStatus: response.status,
                migrationProgress: response.progress?.percentage || 0,
                upContentMigrated: response.isComplete,
                upContentMigrationCompletedAt: response.completedAt,
                migrationResults: response.isComplete ? {
                    successfulTerms: response.results.successfulTerms || [],
                    failedTerms: response.results.failedTerms || [],
                    successfulTermsCount: response.results.successfulCount || 0,
                    failedTermsCount: response.results.failedCount || 0
                } : null
            });

            if (response.isComplete) {
                createAlert(`Migration results loaded. ${response.results.successfulCount} successful, ${response.results.failedCount} failed.`, 'success');
            } else {
                // Migration exists but not complete - show status without enabling download
                createAlert(`${response.status}`, 'warning');
            }
        } catch (error) {
            console.error('Error loading migration results:', error);
            createAlert('Failed to load migration results', 'error');
            this.setState({
                migrationResultsLoading: false,
                migrationResultsAvailable: false
            });
        }
    }

    async _downloadMigrationResultsCSV() {
        const { cid } = this.state;

        if (!cid) {
            createAlert('Client ID is required', 'error');
            return;
        }

        try {
            const result = await doDownloadMigrationResultsCSV(cid);

            if (!result.success || !result.blob) {
                createAlert(result.error || 'No migration results found', 'warning');
                return;
            }

            // Create download link and trigger download
            const url = window.URL.createObjectURL(result.blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `upcontent-migration.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            createAlert('Migration results downloaded successfully', 'success');
        } catch (error) {
            console.error('Error downloading migration results:', error);
            createAlert('Failed to download migration results', 'error');
        }
    }

    _onAutoDomainChange(event, domain) {
        const { autoDomainType } = this.state;
        let domainType = autoDomainType == "regDomains" ? "regDomains" : "blockDomains";
        let newDomains = this.state[domainType];
        let value = event.target ? event.target.value : event;
        value.trim().toLowerCase();
        if (value.length == 0) {
            return;
        }
        value = "@" + value.replace(/.*@/, "");
        if (value.indexOf(".") == 0 || value.indexOf(".") < value.indexOf("@")) {
            createAlert("Please provide a domain", "error");
            return;
        }
        if (domainType.indexOf(domain) !== -1) {
            createAlert("You already have this domain listed", "error");
            return;
        } else {
            this.regInput.value = "";
            this.regInput.focus();
            newDomains.push(value);
            this.setState({ addRegEmail: "" });
        }
        this._onFieldUpdate(domainType, newDomains);
    }

    _onDelDomainChange(event, delDomain) {
        const { delegateDomains } = this.state;
        let value = event.target ? event.target.value : event;
        if (value.trim().length == 0) {
            return;
        }
        value = "@" + value.replace(/.*@/, "");
        if (value.trim().indexOf(".") == 0 || value.trim().indexOf(".") < value.trim().indexOf("@")) {
            createAlert("Please provide a domain", "error");
            return;
        }
        if (delegateDomains.indexOf(value) !== -1) {
            createAlert("You already have this domain listed", "error");
            return;
        } else {
            this.delInput.value = "";
            this.delInput.focus();
            delegateDomains.push(value);
            this.setState({ addDomain: "" });
        }
        this._onFieldUpdate("delegateDomains", delegateDomains);
    }

    _removeAutoDomain(event, regDomain) {
        if (event) {
            event.preventDefault();
        }

        let { regDomains, blockDomains, autoDomainType } = this.state;
        if (autoDomainType == "regDomains") {
            regDomains.splice(regDomains.indexOf(regDomain), 1);
            this._onFieldUpdate("regDomains", regDomains);
        } else if (autoDomainType == "blockDomains") {
            blockDomains.splice(blockDomains.indexOf(regDomain), 1);
            this._onFieldUpdate("blockDomains", blockDomains);
        }
        createAlert('Auto domain removed', 'success');
    }
    _removeDelDomain(event, delDomain) {
        if (event) {
            event.preventDefault();
        }

        let { delegateDomains } = this.state;
        delegateDomains.splice(delegateDomains.indexOf(delDomain), 1);
        this._onFieldUpdate("delegateDomains", delegateDomains);
        createAlert('Delegate domain removed', 'success');
    }

    _onSocialChange(socialNetwork, option, event) {
        let networks = this.state.socialNetworks;
        // IG doesn't exist for all clients so far
        if (!networks["IG"]) {
            networks.IG = {
                login: false,
                share: false,
                companyShare: false
            }
        }
        if (event) {
            networks[socialNetwork][option] = event.target.value == 1;
        } else {
            networks[socialNetwork][option] = !networks[socialNetwork][option];
        }
        if (
            option.indexOf("available") == -1 ||
            !(this.state.socialNetworks[socialNetwork]).available
        ) {
            networks[socialNetwork]["login"] = false;
            networks[socialNetwork]["share"] = false;
            networks[socialNetwork]["companyShare"] = false;
        }
        else if (
            option.indexOf("available") !== -1 &&
            (this.state.socialNetworks[socialNetwork]).available
        ) {
            networks[socialNetwork]["login"] = true;
            networks[socialNetwork]["share"] = true;
            networks[socialNetwork]["companyShare"] = true;
        }

        // Instagram relies on Facebook
        if (!networks["Facebook"].available &&
            !networks["Facebook"].login &&
            !networks["Facebook"].share &&
            !networks["Facebook"].companyShare) {
            networks["IG"].available = false;
            networks["IG"].login = false;
            networks["IG"].share = false;
            networks["IG"].companyShare = false;
        }
        this._onSharingSettingChange("socialNetworks", networks);
    }

    _onSharingSettingChange(field, event) {
        this._onFieldUpdate(field, event);
        setTimeout(() => {
            if (this.allowContentSpecificPermissionsLocked()) {
                this.setState({ allowContentSpecificPermissions: false });
            }
        }, 0);
    }

    allowContentSpecificPermissionsLocked() {
        let networks = this.state.socialNetworks;
        if (!(networks.LinkedIn.share ||
            networks.LinkedIn.companyShare ||
            networks.Twitter.share ||
            networks.Twitter.companyShare ||
            networks.Facebook.companyShare) &&
            !(this.state.allowEmail || this.state.allowAppEmail || this.state.allowAppSMS || this.state.smsProvider)) {
            return true;
        }
        return false;
    }

    _onEcommunicationStatusChange(field, event) {
        let eComm = this.state.eCommunication;
        eComm.enable = !eComm.enable;
        this.setState({
            ["eCommunication"]: eComm
        });
    }
    _onECommunicationEngineChange(event) {
        this.setState({
            ["eCommunication"]: event
        });
    }

    _onTagChange(event, tid) {
        const { tags } = this.state;
        let value = event.target ? event.target.value : event;

        // trim off leading and trailing spaces before adding
        value = value.trim();

        // check existing for duplicate
        let filterStrings = [];
        const keys = Object.keys(tags);

        // put the tag values ina an array
        for (const key of keys) {
            const tag = tags[key];
            if (Array.isArray(tag)) {
                filterStrings = filterStrings.concat(tag);
            } else if (tag) {
                filterStrings.push(tag);
            }
        }
        // find new value in the existing tag values matching lower case
        const dup = filterStrings.filter(val => {
            return val.toLowerCase() == value.toLowerCase()
        });
        // if dup found, alert the user and stop tag change
        if (dup && dup.length > 0) {
            createAlert(`Tag already exists.`, `error`);
            return;
        }

        if (tid) {
            tags[tid] = value;
        } else {
            if (!tags[0]) {
                tags[0] = [];
            }
            const existing = [
                ...tags[0],
                ...Object.values(tags)
            ]
            if (existing.indexOf(value) == -1) {
                tags[0].push(value);
                this.tagInput.value = "";
                this.tagInput.focus();
                this.setState({ addTag: "" });
            }
        }
        this._onFieldUpdate("tags", tags);
    }
    _removeTag(event, tid, name) {
        if (event) {
            event.preventDefault();
        }

        let { tags } = this.state;
        if (tid == 0) {
            tags[0].splice(tags[0].indexOf(name), 1);
        } else {
            delete tags[tid];
        }
        this._onFieldUpdate("tags", tags);
        createAlert("Remove tag", 'success')
    }

    _onCustomHeaderChange(eventKey, eventVal, chid, index = -1) {
        let { customHeaders } = this.state.eCommunication.archiveSettings;
        let key = eventKey.target ? eventKey.target.value : eventKey;
        let val = eventVal.target ? eventVal.target.value : eventVal;
        const value = { key, val };
        if (chid) {
            customHeaders[chid] = value;
        } else {
            if (!customHeaders) {
                customHeaders = [];
            }
            if (index > -1) {
                customHeaders[index] = value;
            } else if (customHeaders.indexOf(value) == -1) {
                customHeaders.push(value);
                this.keyInput.value = "";
                this.keyInput.focus();
                this.valInput.value = "";
                this.setState({ addKey: "", addVal: "" });
            }
        }
        this._onFieldUpdate("eCommunication.archiveSettings.customHeaders", customHeaders);
    }
    _removeCustomHeader(event, item) {
        if (event) {
            event.preventDefault();
        }

        let { customHeaders } = this.state.eCommunication.archiveSettings;
        customHeaders.splice(customHeaders.indexOf(item), 1);

        this._onFieldUpdate("eCommunication.archiveSettings.customHeaders", customHeaders);
        createAlert("Remove Custom Header","success")
    }

    async _onSubmit(event, addCompliance, deleteReadOnlyContent = false) {
        const { cid, newTrueDelegateRid, excludeFromWeeklyEmails, allowDelegation, insert, allowContentSpecificPermissions, allowFrontendCompose, composePermissions, existsReadOnlyContent, skipModal, fileUploadLogo, fileUploadWeeklyEmailLogo, allowFeedback, feedbackTo, regDomains, blockDomains, complianceEnabled,
            isEmbeddedClient, embeddedClientURL, embeddedClientAppId, embeddedClientExtensionUniqueId
        } = this.state;
        const { clients } = this.props;
        const roles = clients?.[cid]?.roles || {};
        let validEMVInputs = true;

        if (event) {
            event.preventDefault();
        }
        if (clients?.[cid]?.allowContentSpecificPermissions && !allowContentSpecificPermissions && !skipModal) {
            if (existsReadOnlyContent) {
                this.setState({ showSharingPermissionsModal: true });
                return;
            }
        }

        if (!insert && cid) {
            const existingClient = await ClientActions.doGet(cid);
            if (existingClient && new Date(existingClient.lastUpdatedOn) > this.state.editStartTime) {
                createAlert("This client has been updated since you started editing it. Please make note of your changes and refresh the page to try again.", "error");
                return;
            }
        }

        if (!insert && allowDelegation && !newTrueDelegateRid) {
            createAlert(`You must select a default delegate role under delegation. If your client doesn't have any role, please create one first.`, `error`);
            return;
        }

        if (allowFrontendCompose && allowContentSpecificPermissions && !Object.values(composePermissions).some(perm => perm)) {
            createAlert(`Please select at least one sharing permission for composed content.`, `error`);
            return;
        }

        if (allowFeedback && !feedbackTo.length) {
            createAlert(`"Feedback Emailed to" cannot be blank`, `error`);
            return;
        }

        if (regDomains.length && blockDomains.length) {
            createAlert(`You can not have both Auto registration and Block consumer activation domains. Please remove all domains from one list.`, `error`);
            return;
        }
        if (isEmbeddedClient && embeddedClientURL) {
            const urlregex = new RegExp(/[A-Za-z0-9-]+\.{1}(seismic|seismic-dev|seismic-qa|seismic-uat)\.com(?!\S)(?!\s)/gy);
            if (embeddedClientURL.match(urlregex) === null) {
                createAlert(`Please enter a valid Tenant URL without protocols, ex: example.seismic.com`);
                return;
            }
        }
        if (isEmbeddedClient && (!embeddedClientURL || !embeddedClientAppId || !embeddedClientExtensionUniqueId)) {
            createAlert(`In order to enable Embedded Client. All fields within Embedded Client are required.`, `error`);
            return;
        }

        if (complianceEnabled && !addCompliance && !this.state.vendor) {
            createAlert("Cannot enable compliance directly. Please select a compliance provider and use the Submit button to properly configure compliance settings.", "error");
            return;
        }

        // Validate UpContent configuration before saving
        const upContentValidation = this._validateUpContentConfiguration();
        if (!upContentValidation.valid) {
            createAlert(upContentValidation.error, "error");
            return;
        }

        // Loops through Earned Media Value inputs and validates their values
        $('#emv-inputs').find('input').each(function () {
            const regex = new RegExp(/^\d{1,2}(\.\d\d?)?$/);
            if (this.value.match(regex) === null) {
                createAlert(`Please ensure that Earned Media Value amount "${this.value}" is a number between 0 and 99.99, with a maximum of 2 decimal spaces.`, `error`);
                validEMVInputs = false;
            }
        })

        if (validEMVInputs === false) {
            return;
        }

        if (regDomains.length || blockDomains.length) {
            const genericDomains = ["gmail.com", "outlook.com", "hotmail.com", "yahoo.com"];
            const domains = regDomains.length ? regDomains : blockDomains;
            const autoDomainType = regDomains.length ? "Registration Email" : "Block Consumer Activation Email";
            for (const domain of domains) {
                for (const gDomain of genericDomains) {
                    const domainRegex = new RegExp("^@" + gDomain + "$");
                    if (domainRegex.test(domain)) {
                        createAlert(`You may not have @${gDomain} as a ${autoDomainType}`, `error`);
                        return;
                    }
                }
            }
        }

        if (!this.state.complianceEnabled) {
            // set these to false in case a user turned them on with proofpoint selected and changed
            this.state.hasEntityConfig = this.state.oneApproval = this.state.deactivateComplianceAccount = this.state.allowComplianceNotes = this.state.pumEnabled = this.childConfigsOnly = false;
            this.state.smsPPConfig = "";
        }
        let client = Client(this.state);
        client.imageUploadConsent =
            !client.allowFrontendImageOnly || !client.allowFrontendCompose ? false : client.imageUploadConsent;
        client.allowFrontendImageOnly = client.allowFrontendCompose && client.allowFrontendImageOnly ? true : false;
        delete client["streamTags"];

        // if trailing slashes in the api url...
        if (client.eCommunication && client.eCommunication.engine && client.eCommunication.engine == "GV6" && client.eCommunication.apiUrl) {
            client.eCommunication.apiUrl = client.eCommunication.apiUrl.replace(/\/+$/, "");
        }
        if (client.eCommunication && client.eCommunication.beeCustomRows) {
            const rows = this.state.beeCustomRowsJson.split("\n").filter(row => row != "");
            if (!Array.isArray(rows)) {
                createAlert(`Bee Editor Custom Row entry appears to be invalid. Please check the value and try again.`, `error`);
                return;
            }
            client.eCommunication.beeCustomRows = rows;

            if (client.eCommunication.beeDefaultTemplateUrl && !isURL(client.eCommunication.beeDefaultTemplateUrl)) {
                createAlert(`Bee Editor Default template appears to be invalid. It needs to be a valid URL. Please check the value and try again.`, `error`);
                return;
            }

            if (client.eCommunication.beeCustomRowsDomain && !isURL(client.eCommunication.beeCustomRowsDomain)) {
                createAlert(`Bee Editor Custom Row JSON Object Domain appears to be invalid. It needs to be a valid domain. Please check the value and try again.`, `error`);
                return;
            }

            if (client.eCommunication.beeCustomRowsUrlOverride && !isURL(client.eCommunication.beeCustomRowsUrlOverride)) {
                // we can set this one to empty as this is not a required field.
                client.eCommunication.beeCustomRowsUrlOverride = "";
            }
        }

        // upload new onboarding intro video, for each language...
        for (const key of Object.keys(this.state._onboardingIntro)) {
            // look in the staged intro vid data
            const _intro = this.state._onboardingIntro[key];
            // if updated and the video file exists...
            if (_intro.videoUploaded && this["fileUpload_" + key]) {
                const fileUpload = this["fileUpload_" + key];
                // pulled the client intro vid object
                const intro = (client.onboardingIntro && client.onboardingIntro[key]) ? client.onboardingIntro[key] : null;
                // upload intro vid to S3, retrieve S3 url, capture the S3 link and filename into the client intro vid object
                if (fileUpload && fileUpload.files && fileUpload.files.length && fileUpload.files.length == 1 && intro) {
                    var formData = new FormData();
                    formData.append("file", fileUpload.files[0]);
                    const videoUrl = await doUpsertOnboardingIntroVideo(formData);
                    if (videoUrl && videoUrl.url && videoUrl.url != "") {
                        intro.videoUrl = videoUrl.url;
                        intro.videoName = _intro.videoName;
                    } else {
                        createAlert(`Unable to upload onboarding intro video file. Please try again.`, `error`);
                        return;
                    }
                }
            }
        }

        if (!insert && allowDelegation && newTrueDelegateRid) {
            for (const rid in roles) {
                roles[rid].defaultTrueDelegate = roles[rid].rid == newTrueDelegateRid || false;
            };
            client.roles = roles;
        }

        client.trackingCodeDomains = client.trackingCodeDomains && client.trackingCodeDomains.trim() ? client.trackingCodeDomains.split(",").map(t => t.trim()) : null;

        if (clients?.[cid] && clients[cid].configName != client.configName) {
            const oldWhiteLabelSettings = await UtilActions.doGetWhiteLabelSettings(clients[cid].configName);
            const newWhiteLabelSettings = await UtilActions.doGetWhiteLabelSettings(client.configName);

            for (const stream in client.streams) {
                if (client.streams[stream].bgColor && client.streams[stream].bgColor != "#FFFFFF" && client.streams[stream].bgColor != "#EEEEEE") {
                    if (client.streams[stream].bgColor == oldWhiteLabelSettings.primaryColor) {
                        client.streams[stream].bgColor = newWhiteLabelSettings.primaryColor;
                    } else if (client.streams[stream].bgColor == oldWhiteLabelSettings.secondaryColor) {
                        client.streams[stream].bgColor = newWhiteLabelSettings.secondaryColor;
                    }
                }
            }
        }

        if (client.allowSeismicStreams && client.seismic) {
            if (!client.seismic.tenant) {
                createAlert(`Missing required field: Seismic Settings > Tenant`, `error`);
                return;
            }
            if (!client.seismic.authEnv) {
                createAlert(`Missing required field: Seismic Settings > Tenant Environment`, `error`);
                return;
            }
            // trim additional blank spaces in Seismic SSO tenant field
            client.seismic.tenant = client.seismic.tenant.trim();
        }
        if (client.adminSSO?.method === "SAML2") {
            if (!client.adminSSO.SAML2.idpIssuer || !client.adminSSO.SAML2.entryPoint || !client.adminSSO.SAML2.cert?.length) {
                createAlert("Please fill out all mandatory Admin SSO fields");
                return;
            }
        }
        if (client.appSSO?.method === "SAML2") {
            if (!client.appSSO.SAML2.idpIssuer || !client.appSSO.SAML2.entryPoint || !client.appSSO.SAML2.cert?.length) {
                createAlert("Please fill out all mandatory User SSO fields");
                return;
            }
        }

        if (insert) {
            let tags = {};
            if (client.tags) {
                Object.keys(client.tags).forEach(key => {
                    let tag = client.tags[key];
                    tag.forEach(t => {
                        tags[t] = 0;
                    });
                });
                client.tags = tags;
            }

            return doInsertClient(client, fileUploadLogo, fileUploadWeeklyEmailLogo).then(data => {
                if (data && data["cid"] && !addCompliance) {
                    doGetReduxClient(data["cid"], true);
                    if (this.props.user.isSuperClientAdmin) {
                        this._addArticleMediaTemplate(this.state.cid, this.state.allowECommunication);
                        setTimeout(() => {
                            history.push("/reports/engagement");
                        }, 0);
                    } else {
                        setTimeout(() => {
                            history.push("/clients");
                        }, 0);
                    }
                }
            });
        } else {
            return doUpdateClient(client, true, deleteReadOnlyContent, fileUploadLogo, fileUploadWeeklyEmailLogo).then(data => {
                if (data.valid && !addCompliance) {
                    if (this.props.user.isSuperClientAdmin) {
                        this._addArticleMediaTemplate(this.state.cid, this.state.allowECommunication);
                        doGetReduxClient(this.state.cid, true);
                        setTimeout(() => {
                            history.push("/reports/engagement");
                        }, 0);
                    } else {
                        setTimeout(() => {
                            history.push("/clients");
                        }, 0);
                    }
                }
            });
        }
    }

    _onChangeTimeout(event, mainType, type) {
        let time = this.state[`extracted_${mainType}`];

        // init session timeout if it is empty
        if (!time) {
            switch (mainType) {
                case "frontendSessionTimeout":
                    time = { day: 365, hour: 0, minute: 0 };
                    break;
                case "consoleSessionTimeout":
                    time = { day: 0, hour: 0, minute: 20 };
                    break;
                default:
                    throw new Error('unknown session timeout type!');
            }
        }

        time[type] = parseInt(event.target.value);

        let timeout = 0;
        timeout += time.day * 24 * 60;
        timeout += time.hour * 60;
        timeout += time.minute;
        if (timeout < 10) {
            timeout = 10;
        }
        this.setState({
            [mainType]: parseInt(timeout),
            [`extracted_${mainType}`]: time
        });
    }

    doesStreamExist(sid) {
        let { streams } = this.state;
        return Object.keys(streams).some(key => {
            if (sid == key) {
                return true;
            }
        });
    }

    isOrphandedTag(tid) {
        let { streamTags, streams } = this.state;
        if (streams) {
            return Object.keys(streams).some(sid => {
                if (streamTags && streamTags[sid] && streamTags[sid].indexOf(tid) !== -1) {
                    return false;
                }
            });
        }
        return true;
    }

    _getSettings(section, sections = 2) {
        let permissions = {
            isActive: {
                label: "Active",
                value: this.state.isActive,
                description: "Enables the client"
            },
            allowPublish: {
                label: "Allow Content",
                value: this.state.allowPublish,
                description: "Enables users to see and share content"
            },
            allowProspect: {
                label: "Allow Prospects",
                value: this.state.allowProspect,
                description: "Enables users in this client to access our prospects lead generation"
            },
            allowEngage: {
                label: "Allow Chrome Extension",
                value: this.state.allowEngage,
                description: "Enables users to use the chrome extension"
            },
            autoActivationReminder: {
                label: "Send Re-engagement Reminders",
                value: this.state.autoActivationReminder,
                description: "Enables sending automated re-engagement reminder emails to users"
            },
            isTCChecked: {
                label: "T&C Checked",
                value: this.state.isTCChecked,
                description: "Enables articles to be pulled from our index if we meet their T&C"
            },
            allowRss: {
                label: "Allow RSS Feeds",
                value: this.state.allowRss,
                description: "Enables the user to add RSS Feeds"
            },
            allowSuggest: {
                label: "Allow Suggesting",
                value: this.state.allowSuggest,
                description: "Enables users to suggest articles to share to other users"
            },
            allowAppSearch: {
                label: "Allow Search",
                value: this.state.allowAppSearch,
                description: "Enables users to search articles in app"
            },
            allowMoreLikeThis: {
                label: "Allow Related Content in the App",
                value: this.state.allowMoreLikeThis,
                description: "Enables users to view and share related content in the app."
            },
            allowCustomEdit: {
                label: "Allow Custom Editing",
                value: this.state.allowCustomEdit,
                description: "Enables admins to upload images and write content only articles",
                onChange: value => {
                    if (!value) {
                        this.setState({
                            allowCustomEdit: false,
                            allowVideoCuration: false,
                            allowPdfCuration: false
                        });
                    } else {
                        this.setState({
                            allowCustomEdit: true
                        });
                    }
                }
            },
            allowVideoCuration: {
                label: "Allow Admins to Curate Video Content",
                value: this.state.allowVideoCuration,
                description:
                    "Allow admin to upload a .mp4 file into a curated stream. Allow Custom Editing must be enabled. Video will not be checked by compliance.",
                onChange: value => {
                    if (value && this.state.allowCustomEdit) {
                        this.setState({
                            allowVideoCuration: true
                        });
                    } else {
                        this.setState({
                            allowVideoCuration: false
                        });
                    }
                }
            },
            allowPdfCuration: {
                label: "Allow Admins to Curate PDF Content",
                value: this.state.allowPdfCuration,
                description: "Allow admin to upload a .pdf file into a curated stream. Allow Custom Editing must be enabled. .PDF files will require manual compliance review.",
                onChange: value => {
                    if (value && this.state.allowCustomEdit) {
                        this.setState({
                            allowPdfCuration: true
                        });
                    } else {
                        if (!this.state.allowFrontendPdfCompose) {
                            this.setState({
                                allowPdfCuration: false,
                                allowContentAnalysis: false
                            });
                        }
                        else {
                            this.setState({
                                allowPdfCuration: false
                            });
                        }
                    }
                }
            },
            allowContentAnalysis: {
                label: "Enable Advanced Content Analytics",
                value: this.state.allowContentAnalysis,
                description: "Allows admins and app users to see advanced analytics (e.g. time on document, view per page) for shared PDF documents. \nFor admins, this will be from the Article Performance report. For users, this will be from the History page.",
                onChange: value => {
                    if (value && (this.state.allowFrontendPdfCompose || this.state.allowPdfCuration)) {
                        this.setState({
                            allowContentAnalysisModal: true,
                            allowContentAnalysis: true
                        });
                    } else {
                        this.setState({
                            allowContentAnalysis: false
                        });
                    }
                }
            },
            allowAutopost: {
                label: "Allow Stream Subscription",
                value: this.state.allowAutopost,
                description: "Enables admins to configure stream subscription stream"
            },
            allowFrontendCompose: {
                label: "Allow Compose In App",
                value: this.state.allowFrontendCompose,
                description: "Enables users to compose articles from the app",
                onChange: value => {
                    this.setState({
                        ...(!value ? {
                            allowFrontendCompose: false,
                            imageUploadConsent: false,
                            allowFrontendImageOnly: false,
                            allowFrontendVideoCompose: false,
                            allowFrontendShareVideoFromKaltura: false,
                            allowFrontendPdfCompose: false
                        } : {
                            allowFrontendCompose: true
                        })
                    });
                }
            },
            allowFrontendImageOnly: {
                label: "Allow Users to Upload Images",
                value: this.state.allowFrontendImageOnly,
                description:
                    "Enables users to add 1-4 images to their post, with a size limit of 5MB per image. Allow Compose in App must be ON for this toggle to be enabled",
                onChange: value => {
                    if (!value) {
                        this.setState({
                            imageUploadConsent: false,
                            allowFrontendImageOnly: false,
                            allowFrontendVideoCompose: false,
                            allowFrontendShareVideoFromKaltura: false
                        });
                    } else {
                        if (this.state.allowFrontendCompose) {
                            this.setState({ allowFrontendImageOnly: true });
                        } else {
                            this.setState({ allowFrontendImageOnly: false });
                        }
                    }
                }
            },
            allowFrontendPdfCompose: {
                label: "Allow Users to Upload PDF",
                value: this.state.allowFrontendPdfCompose,
                description:
                    "Allows users to add an .pdf file in Compose, with a size limit of 8MB.\nAllow Compose in App must be enabled. PDF content will require manual compliance review.\nOnly 1 PDF can be uploaded per share.",
                onChange: value => {
                    if (!value) {
                        if (!this.state.allowPdfCuration) {
                            this.setState({
                                allowFrontendPdfCompose: false,
                                allowContentAnalysis: false
                            });
                        }
                        else {
                            this.setState({
                                allowFrontendPdfCompose: false
                            });
                        }
                    } else {
                        if (this.state.allowFrontendCompose) {
                            this.setState({ allowFrontendPdfCompose: value });
                        }
                        else if (!this.state.allowPdfCuration) {
                            this.setState({
                                allowFrontendPdfCompose: false,
                                allowContentAnalysis: false
                            });
                        }
                        else {
                            this.setState({ allowFrontendPdfCompose: false });
                        }
                    }
                }
            },
            allowFrontendVideoCompose: {
                label: "Allow Users to Upload Video",
                value: this.state.allowFrontendVideoCompose,
                description:
                    "Allows users to add an .mp4/m4v file when Composing\n\"Allow Compose in App\" and \"Allow Users to Upload Images\" must be enabled\nVideo maximum file size is 100MB to 650MB, depending on social network\nVideo maximum duration is 60 seconds to 10 minutes, depending on social network \nVideo content will not be scanned by compliance",
                onChange: value => {

                    if (value === true && this.state.allowFrontendCompose && this.state.allowFrontendImageOnly) {
                        this.setState({ allowFrontendVideoCompose: true });
                    } else {
                        this.setState({ allowFrontendVideoCompose: false });
                    }
                }
            },
            allowFrontendShareVideoFromKaltura: {
                label: "Allow Users to Share Videos from Kaltura",
                value: this.state.allowFrontendShareVideoFromKaltura,
                description:
                    "Feature for BAML",
                onChange: value => {
                    if (value === true && this.state.allowFrontendCompose && this.state.allowFrontendImageOnly) {
                        this.setState({ allowFrontendShareVideoFromKaltura: true });
                    } else {
                        this.setState({ allowFrontendShareVideoFromKaltura: false });
                    }
                },
                dropdown: [
                    <div className="flex__row--center">{this._getListofAllowableVideoExtractionDomains()}</div>
                ]
            },
            imageUploadConsent: {
                label: "Require Consent for User Uploaded Images",
                value: this.state.imageUploadConsent,
                description: `When a user adds an image in Compose, ask them to confirm whether they have consent to share the image publicly. Must have "Allow Compose" and "Allow Image Only Posts in App" enabled`,
                onChange: value => {
                    if (value && this.state.allowFrontendImageOnly && this.state.allowFrontendCompose) {
                        this.setState({
                            imageUploadConsent: true
                        });
                    } else {
                        this.setState({ imageUploadConsent: false });
                    }
                }
            },
            allowSocialStreams: {
                label: "Allow Social Streams",
                value: this.state.allowSocialStreams,
                description: "Enables admins to configure streams to pull from social networks"
            },
            allowOffers: {
                label: "Allow Offers",
                value: this.state.allowOffers,
                description: "Enables offers for advisors of this client"
            },
            allowLeaderboards: {
                label: "Allow Leaderboards",
                value: this.state.allowLeaderboards,
                description: "Enables Leaderboards for this client",
                onChange: value => {
                    if (value) {
                        this.setState({
                            allowLeaderboards: true
                        });
                    } else {
                        this.setState({
                            allowLeaderboards: false,
                            allowLeaderBoardGroupFilter: false
                        });
                    }
                }
            },
            allowLeaderBoardGroupFilter: {
                label: "Filter Leaderboards by Group",
                value: this.state.allowLeaderBoardGroupFilter,
                description:
                    "Allows the end user to filter their leaderboard by the group they are in. Allow Leaderboards must be enabled and the client must have at least one group that is not composed of users that are excluded from reported, deleted or disabled",
                onChange: value => {
                    if (
                        value &&
                        this.state.allowLeaderboards &&
                        this.state.groups &&
                        Object.keys(this.state.groups).length > 0
                    ) {
                        this.setState({
                            allowLeaderBoardGroupFilter: true
                        });
                    } else {
                        this.setState({ allowLeaderBoardGroupFilter: false });
                    }
                }
            },
            allowCommentsEditable: {
                label: "Comments Editable",
                value: this.state.allowCommentsEditable,
                description: "Enables Editing Comments for this client"
            },
            experimentalMode: {
                label: "Experimental Mode",
                value: this.state.experimentalMode,
                description: "Enables features that are still in development"
            },
            allowProfSearches: {
                label: "Allow Professional Searches",
                value: this.state.allowProfSearches,
                description: "Enables professional streams and searches"
            },
            allowPersSearches: {
                label: "Allow Personal Searches",
                value: this.state.allowPersSearches,
                description: "Enables personal streams and searches"
            },
            allowNotifications: {
                label: "Allow Notifications",
                value: this.state.allowNotifications,
                description: "Allows admins to configure notifications and send notifications to their users"
            },
            allowFeedback: {
                label: "Enable in-App Feedback",
                value: this.state.allowFeedback,
                description: "Enables users to submit feedback about the App"
            },
            aiGeneratedUserComments: {
                label: "Generate Comments for Users using Text Ranking",
                value: this.state.aiGeneratedUserComments,
                description: "Suggests potential comments for the User in the App (fka AI Comment Starters)",
            },
            aiGeneratedUserCommentsWithChatGPT: {
                label: "AI Generated Comments for Users with Aura",
                value: this.state.aiGeneratedUserCommentsWithChatGPT, // ? this.state.aiGeneratedUserComments ? true : false : false,
                description: "Suggests potential LLM powered comments for the User in the App using Aura AI",
                onChange: value => {
                    if (value) {
                        this.setState({
                            aiGeneratedUserCommentsWithChatGPT: true,
                            useOldShareModal: false
                        });
                    } else {
                        this.setState({
                            aiGeneratedUserCommentsWithChatGPT: false
                        });
                    }
                }
            },
            aiGeneratedAdminSuggestions: {
                label: "Generate Suggestions for Admins using Text Ranking",
                value: this.state.aiGeneratedAdminSuggestions,
                description: "Suggests potential comments for the Admin when curating articles (fka AI Comment Starters)",
            },
            aiGeneratedAdminSuggestionsWithChatGPT: {
                label: "AI Generated Suggestions for Admins with Aura",
                value: this.state.aiGeneratedAdminSuggestionsWithChatGPT,
                description: "Suggests potential LLM powered comments for the Admin when curating articles with Aura AI",
            },
            allowYearInReview: {
                label: "Enable Year in Review",
                value: this.state.allowYearInReview,
                description: "Turns on a link that allows users to navigate to their Year in Review"
            },
            allowSectionView: {
                label: "Enable Section View",
                value: this.state.allowSectionView,
                description: "When enabled, users will see each stream of content sectioned together"
            },
            crmEnabled: {
                label: "CRM Enabled",
                hidden: !this.state.configName || this.state.configName.toLowerCase() !== "ubs",
                value: this.state.crmEnabled,
                description: "Sync leads to CRM"
            },
            allowNetworkSuggestedComments: {
                label: "Suggest Comment By Social Networks",
                value: this.state.allowNetworkSuggestedComments,
                description: "Allow marketer to specify comment for each enabled social networks",
                onChange: value => this.setState({ allowNetworkSuggestedComments: value })
            },
            excludeFromWeeklyEmails: {
                label: "Exclude from Weekly Email",
                value: this.state.excludeFromWeeklyEmails,
                description: "Exclude Client from Weekly User Email",
                onChange: value => {
                    this.setState({ excludeFromWeeklyEmails: value })
                }
            },
            excludeComposedFromTrendingContent: {
                label: "Exclude Composed content from Trending Reports",
                value: this.state.excludeComposedFromTrendingContent,
                description: "Composed content is excluded from trending content report (App) and weekly emails\nNote: A user's composed content will appear only for themselves on Trending Content",
                onChange: value => this.setState({ excludeComposedFromTrendingContent: value })
            },
            sendEngagementDataToEventBus: {
                label: "Send Engagement Data to Event Bus",
                value: this.state.sendEngagementDataToEventBus,
                description: "LiveSocial will send Engagement Data picked up from LinkedIn via daily cronjob over to Seismic Event Bus",
                onChange: value => this.setState({ sendEngagementDataToEventBus: value })
            },
            enableTwitterSocialMetrics: {
                label: "Enable X (Twitter) Social Metrics",
                value: this.state.enableTwitterSocialMetrics,
                description: "Enables X (Twitter) Social Metrics for this client",
                onChange: value => {
                    if (value) {
                        this.setState({
                            enableTwitterSocialMetricsModal: true,
                            enableTwitterSocialMetrics: true
                        });
                    } else {
                        this.setState({
                            enableTwitterSocialMetrics: false
                        });
                    }
                }
                // onChange: value => this.setState({ enableTwitterSocialMetrics: value })
            },
            enableLinkedInMentions: {
                label: "Enable LinkedIn Mentions",
                value: this.state.enableLinkedInMentions,
                description: "Enables LinkedIn Mentions",
                onChange: value => this.setState({ enableLinkedInMentions: value })
            },
            composeBlockedTerms: {
                label: "Apply Global Blocked Terms to Composed Posts",
                value: this.state.composeBlockedTerms,
                description: "When enabled, the global blocked terms list will be applied to composed posts",
                onChange: value => this.setState({ composeBlockedTerms: value })
            },
            useOldShareModal: {
                label: "Use Old Share Modal",
                value: this.state.useOldShareModal,
                disabled: this.state.aiGeneratedUserCommentsWithChatGPT,
                description: "When enabled, the old share modal will be used instead of the new one. Aura AI comments for Users must be disabled",
                onChange: value => this.setState({ useOldShareModal: value })
            },
            enforceMFA: {
               label: "Enforce Multi-Factor Authentication (MFA)",
               value: this.state.enforceMFA,
               description: "Require users of this client to use Multi-Factor Authentication (MFA) when logging in.",
               onChange: value => this.setState({ enforceMFA: value })
           }
        };
        let i = 0;
        const obj = {};
        for (const k in permissions) {
            if (
                Math.ceil(Object.keys(permissions).length / sections) * section <= i &&
                i < Math.ceil(Object.keys(permissions).length / sections) * (section + 1)
            ) {
                obj[k] = permissions[k];
            }
            i++;
        }
        return obj;
    }

    _getListofAllowableVideoExtractionDomains(){
        return (
            <div className="form__group">
            <label htmlFor="name" className="form__label">List of Allowable Video Extraction Domains:</label>
            <input
                id="listofAllowableVideoExtractionDomainsId"
                type="text"
                className="form__value"
                onChange={event => this._onFieldUpdate("listofAllowableVideoExtractionDomains", event)}
                value={this.state.listofAllowableVideoExtractionDomains || ""}
            />
        </div>
        )
    }

    /***** Onboarding Intro functions *****/
    _getOnboardingIntroSettings() {
        const { allowOnboardingIntro } = this.state;
        return {
            allowExtendedOnboarding: {
                label: "Enable Share-Assisted Onboarding",
                value: this.state.allowExtendedOnboarding,
                description: "ON - When Onboarding, users will be presented with 6 suggested ’trending’ articles. \n\t The selected articles will have an impact on the user’s professional interests. If \n\t multiple articles are selected, the user will be prompted to share the top article \n\t from that list. Users have the ability to skip at any point in the process. \nOFF - No suggested articles will be displayed to user at the time of onboarding\nNote: this feature is unavailable if the client has Proofpoint as their compliance provider and “Force Compliance in Onboarding” disabled",
                onChange: value => {
                    //  Share-Assisted Onboarding is not available if the client uses proofpoint and does not have force compliance enabled
                    if (value && this.state.complianceEnabled && this.state.tempVendor === "ng" && !this.state.forceCompliance) {
                        this.setState({ allowExtendedOnboarding: false });
                    } else {
                        this.setState({ allowExtendedOnboarding: value });
                    }
                }
            },
            allowOnboardingIntro: {
                label: "Enable Welcome Screen",
                value: allowOnboardingIntro,
                description: "ON - An introduction video and note will be displayed to the user during onboarding \nOFF - No introduction video and note is displayed to the user during onboarding",
                dropdown: [
                    <div className="flex__row--center">{this._renderOnboardingIntroContent()}</div>
                ]
            }
        };
    }
    _getUpContentSettings() {
        const { allowOnboardingIntro } = this.state;
        return {
            enableUpContent: {
                label: "Enable UpContent",
                value: this.state.enableUpContent,
                description: "When enabled, UpContent features can be enabled to change the 3rd Party Content provider",
                onChange: value => {
                    if (!value) {
                        // If UpContent is disabled, also disable all dependent features
                        this.setState({
                            enableUpContent: false,
                            thirdPartyInterestSharing: false,
                            enableUpContentSearch: false,
                            enableAutomaticCurationFromUpContent: false
                        });
                    } else {
                        // Enabling UpContent
                        this.setState({ enableUpContent: value });
                    }
                },
            },
            thirdPartyInterestSharing: {
                label: "3rd Party Interest Sharing",
                value: this.state.thirdPartyInterestSharing,
                description: "When enabled, UpContent will be used for providing content for 3rd Party Streams",
                onChange: value => this.setState({ thirdPartyInterestSharing: value }),
                hidden: !this.state.enableUpContent
            },
            enableUpContentSearch: {
                label: "Enable UpContent for Search",
                value: this.state.enableUpContentSearch,
                description: "When enabled, UpContent will be used to power search functionality",
                onChange: value => this.setState({ enableUpContentSearch: value }),
                hidden: !this.state.enableUpContent
            },
            enableAutomaticCurationFromUpContent: {
                label: "Enable Automatic Curation from UpContent",
                value: this.state.enableAutomaticCurationFromUpContent,
                description: "When enabled, UpContent will automatically curate content based on the client's selected interests",
                onChange: value => this.setState({ enableAutomaticCurationFromUpContent: value }),
                hidden: !this.state.enableUpContent
            },

        };
    }
    _renderOnboardingIntroContent() {
        const lang = this.state[`__onboardingIntro-lang`] || "en";
        return (
            <div className="form__row">
                <div className="form__group form__group--full" style={{ paddingBottom: "0px" }}>
                    <span
                        className="form__label"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            textTransform: "capitalize"
                        }}
                    >
                        Introduction Note:
                        <div
                            className="select__wrapper"
                            style={{
                                marginLeft: "auto",
                                minWidth: "150px",
                                maxWidth: "150px"
                            }}
                        >
                            <select value={lang} onChange={event => this._onOnboardingIntroLangUpdate(event)} aria-label={lang}>
                                <option value="en">English</option>
                                <option value="fr">French</option>
                            </select>
                        </div>
                    </span>
                    <textarea
                        key={`onboarding-body-${lang}`}
                        placeholder="Onboarding intro page content"
                        className="form__value"
                        onChange={event => this._onOnboardingIntroContentUpdate("body", lang, event)}
                        style={{ minHeight: "250px" }}
                        maxLength={400}
                        value={
                            this.state.onboardingIntro[lang]
                                ? this.state.onboardingIntro[lang]["body"]
                                : ""
                        }
                    />
                    <div style={{ marginTop: "10px", position: "relative" }}>
                        <span className="permission__label" style={{ padding: "10px 0px" }}>
                            Video <Tooltip>File must be .mp4, under 60MB in size and under 2 minutes and 20 seconds in length</Tooltip>
                        </span>
                        <input
                            id={`onboardingIntroVideoUpload_${lang}`}
                            visibility="hidden"
                            style={{ display: "none" }}
                            ref={input => {
                                this["fileUpload_" + lang] = input;
                            }}
                            accept="video/mp4"
                            type="file"
                            onChange={e => {
                                const { type: fileType, size: fileSize, name: fileName } = this["fileUpload_" + lang].files[0];
                                if (fileType.includes("video")) {
                                    if (fileType !== "video/mp4" || fileName.split(".").pop() !== "mp4") {
                                        // fileType check doesn't catch m4v files.
                                        createAlert("Invalid file type, please upload an mp4");
                                        this._resetVideoUploaded(lang);
                                        return;
                                    }
                                    if (fileSize > 60 * 1024 * 1024) {
                                        createAlert(`Please upload a video file under 60MB`);
                                        this._resetVideoUploaded(lang);
                                        return;
                                    }
                                    const video = document.createElement("video");
                                    video.preload = "metadata";
                                    video.onloadedmetadata = () => {
                                        window.URL.revokeObjectURL(video.src);
                                        if (video.duration > 140) {
                                            createAlert("Please upload a video under 2 minutes and 20 seconds");
                                            this._resetVideoUploaded(lang);
                                            return;
                                        }
                                    };
                                    video.addEventListener('error', function (event) {
                                        let error = event;
                                        // Chrome v60
                                        if (event.path && event.path[0]) {
                                            error = event.path[0].error;
                                        }
                                        // Firefox v55
                                        if (event.originalTarget) {
                                            error = error.originalTarget.error;
                                        }
                                        createAlert("File \"" + fileName + "\" is not supported. Please try another video.");
                                        this._resetVideoUploaded(lang);
                                        return;
                                    }, true);
                                    video.src = URL.createObjectURL(this["fileUpload_" + lang].files[0]);
                                    const { _onboardingIntro } = this.state;
                                    _onboardingIntro[lang] = { videoUploaded: true, videoName: fileName, videoSrc: "pending" };
                                    this.setState({ _onboardingIntro });
                                }
                            }}
                        />{" "}
                        <span style={{ color: "#55059c" }}>{this._truncateVideoFileName(this.state._onboardingIntro[lang]["videoName"])}</span>
                        <Button style={{ position: "absolute", right: "0px" }}
                            onClick={e => {
                                e.preventDefault();
                                this._openOnboardingIntroVideoUpload(e, lang);
                            }}
                        >Change video</Button>
                    </div>
                </div>
            </div>
        );
    }
    _truncateVideoFileName(filename) {
        return (filename && typeof filename === "string" && filename.length > 50) ? `${filename.substring(0, 49)}...` : filename;
    }
    _resetVideoUploaded(lang) {
        const { _onboardingIntro } = this.state;
        _onboardingIntro[lang] = { videoUploaded: false, videoSrc: "" };
        this.setState({ _onboardingIntro });
    }
    _openOnboardingIntroVideoUpload(event, lang) {
        if (document) {
            event.preventDefault();
            $("#onboardingIntroVideoUpload_" + lang).trigger("click");
        }
    }
    _onOnboardingIntroLangUpdate(event) {
        const { onboardingIntro } = this.state;
        const lang = event.target.value || "en";
        // Fill default values for missing onboarding email content.
        if (!onboardingIntro) {
            onboardingIntro = { en: { body: "", videoName: "", videoUrl: "" }, fr: { body: "", videoName: "", videoUrl: "" } };
        } else if (!onboardingIntro[lang]) {
            onboardingIntro[lang] = { body: "", videoName: "", videoUrl: "" };
        } else if (!onboardingIntro[lang]["body"]) {
            onboardingIntro[lang]["body"] = "";
        } else if (!onboardingIntro[lang]["videoUrl"]) {
            onboardingIntro[lang]["videoUrl"] = "";
        }
        this.setState({ onboardingIntro });
        this._onFieldUpdate(`__onboardingIntro-lang`, event);
    }
    _onOnboardingIntroContentUpdate(key, lang, event) {
        let onboardingIntro = this.state.onboardingIntro || {};
        if (!onboardingIntro[lang]) {
            onboardingIntro[lang] = {};
        }
        onboardingIntro[lang][key] = event.target ? event.target.value : event;
        this._onFieldUpdate("onboardingIntro", onboardingIntro);
    }

    _getSocialInteractionCaptureSettings() {
        return {
            allowSocialInteractionCapture: {
                label: "Capture social interaction insights",
                value: this.state.allowSocialInteractionCapture,
                type: "toggle",
                description: "ON - Social interactions insights on content shared via the app are collected and available to admins and sellers/advisors. \nSocial interactions are not collected on content shared outside of the app. \nFor privacy purposes, sellers/advisors should have the ability to opt-out. \n\nOFF - No social interaction insights are collected. \n\nNote: Aggregate social interactions data is collected and presented regardless. This includes total number of likes, etc.",
                onChange: value => {
                    this.setState({ allowSocialInteractionCapture: value })
                }
            },
            enableSocialInteractionLeads: {
                label: "Enable social interaction insights leads",
                value: this.state.enableSocialInteractionLeads,
                type: "toggle",
                hidden: !this.state.allowSocialInteractionCapture,
                description: "Make social interactions insights on content shared via the app available to sellers/advisors.",
                onChange: value => {
                    this.setState({ enableSocialInteractionLeads: value })
                }
            }
        }
    }

    _getSharingSettings() {
        const sharePermissions = [];
        if (
            this.state.socialNetworks.LinkedIn.share ||
            this.state.socialNetworks.LinkedIn.companyShare ||
            this.state.socialNetworks.Twitter.share ||
            this.state.socialNetworks.Twitter.companyShare ||
            this.state.socialNetworks.Facebook.companyShare
        ) {
            sharePermissions.push("Social");
        }

        if (this.state.allowEmail || this.state.allowAppEmail) {
            sharePermissions.push("Email");
        }

        if (this.state.allowAppSMS || this.state.smsProvider) {
            sharePermissions.push("SMS");
        }

        return {
            allowCopyLink: {
                label: "Allow Generate Article Short URL",
                value: this.state.allowCopyLink,
                description: "Enables users to generate article short url",
            },
            replaceCorporateArticlesWithUserWebsite: {
                label: "Replace corporate articles with user’s website",
                value: this.state.replaceCorporateArticlesWithUserWebsite,
                description: "Articles from a specific corporate website path will be swapped to direct to the article on a user’s website. The corporate path can be set by contacting LiveSocial"
            },
            allowContentSpecificPermissions: {
                label: "Allow Content Specific Sharing Permissions",
                value: this.state.allowContentSpecificPermissions,
                description: "Allow sharing settings to be configurable on the content level. Must have sharing enabled for at least one social network or external channel (e.g. Email, SMS)",
                disabled: this.allowContentSpecificPermissionsLocked(),
                canChange: () => !!sharePermissions.length,
                onChange: (value) => {
                    this.setState({
                        allowContentSpecificPermissions: value,
                        ...(value === false && { allowNetworkRestrictions: false })
                    })
                },
                dropdown: this.state.allowFrontendCompose ? [
                    <div className={"permission array"} style={{ width: "100%", border: "none" }}>
                        <span className="permission__label">
                            Sharing permissions for composed content
                        </span>
                        <div className={"permission__switch multi"}>
                            <Select
                                multi={true}
                                options={sharePermissions.map(perm => ({ label: perm, value: perm.toLowerCase(), selected: this.state.composePermissions[perm.toLowerCase()] }))}
                                menuPortalTarget={document.body}
                                onChange={value => this._onFieldUpdate("composePermissions", Object.assign({}, ...["social", "email", "sms"].map(perm => ({ [perm]: value.includes(perm) }))))}
                                disabled={this.props.readOnly}
                            />
                        </div>
                    </div>
                ] : undefined
            },
            allowNetworkRestrictions: {
                label: "Allow Content Social Network Restrictions",
                value: this.state.allowNetworkRestrictions,
                disabled: !this.state.allowContentSpecificPermissions,
                description: "When enabled, users will only be able to post content to the social networks allowed",
            },
        };
    }

    // For updating ExtractTextFilter
    _updateExtractTextFilter(val) {
        if (val && val.length) {
            if (val[0].length > 50) {
                createAlert(`Maximum allowed character limit is 50`, "error");
                return false;
            }
            const filters = val.filter(i => i.match(/^\/\/|^.*?:(\/\/)?/));
            if (filters && filters.length) {
                createAlert(`You cannot include protocols such as ${filters[0]} in your filter`, "error");
                return false;
            }
            const trailing = val.filter(i => i[i.length - 1] == "/");
            if (trailing && trailing.length) {
                createAlert(`You cannot include a domain ending in '/'`, "error");
                return false;
            }
            const validDomains = val.filter(i => i.match(/[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/));
            const whitespace = val.filter(i => i.match(/\s/));
            if ((Array.isArray(validDomains) && (validDomains.length != val.length)) || (whitespace && whitespace.length)) {
                createAlert(`Formatting error in domain filter, please review`, "error");
                return false;
            }
        }
        this.setState({ extractTextFilter: val });
        return true;
    }

    _getAdvancedSettings() {
        const { insert, roles, newTrueDelegateRid, allowDelegation } = this.state;
        return {
            allowDelegation: {
                label: "Allow Delegation",
                value: allowDelegation,
                description: "Enables users to assign/request delegates",
                dropdown: [
                    <div className="flex__row--center">
                        <div className="flex__column--center">
                            <div className={`form__group`} style={{ border: "none" }}>
                                <span className="permission__label" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>
                                    Default Delegate Role:
                                    <Tooltip style={{ marginLeft: "5px", whiteSpace: "pre-line" }}>
                                        {`Default role for Level 1 delegates. You can assign a default delegate role only when\nediting a client or from the Roles page. Please create roles if your client doesn't\nhave any before assigning one.`}
                                    </Tooltip>
                                </span>
                                <div className="select__wrapper">
                                <select
                                    value={newTrueDelegateRid}
                                    onChange={event => this._onFieldUpdate("newTrueDelegateRid", event)}
                                    disabled={insert}
                                    aria-label="Select role"
                                >
                                    <option value="">Select...</option>
                                    {
                                        Object.keys(roles).map(rid => <option key={rid} value={rid}>{roles[rid].name}</option>)
                                    }
                                </select>
                                </div>
                            </div>
                            <Toggle
                                label="Allow Content Delegation"
                                name="allowContentDelegation"
                                value={this.state.allowContentDelegation}
                                onToggle={event =>
                                    this._onFieldUpdate("allowContentDelegation", !this.state.allowContentDelegation)
                                }
                            />
                            {this.state.complianceEnabled && (
                                <Toggle
                                    label="Allow Profile Delegation"
                                    name="allowProfileDelegation"
                                    value={this.state.allowProfileDelegation}
                                    onToggle={event =>
                                        this._onFieldUpdate(
                                            "allowProfileDelegation",
                                            !this.state.allowProfileDelegation
                                        )
                                    }
                                />
                            )}
                            {this.state.complianceEnabled && this.state.allowProfileDelegation && this.state.allowSuperPublisher && (
                                <Toggle
                                    label="Restrict to Super Publisher"
                                    name="restrictToSuperPublisher"
                                    value={this.state.restrictToSuperPublisher}
                                    onToggle={event =>
                                        this._onFieldUpdate(
                                            "restrictToSuperPublisher",
                                            !this.state.restrictToSuperPublisher
                                        )
                                    }
                                />
                            )}
                        </div>
                        <div className="flex__column--center">
                            <Toggle
                                label="Restrict Delegates to Known Users"
                                name="delegationUserRestriction"
                                value={this.state.delegationUserRestriction}
                                description="Publishers can only request existing users with access and that have activated to be a delegate"
                                onToggle={event => {
                                    this.setState({
                                        delegationUserRestriction: !this.state.delegationUserRestriction,
                                        ...(!this.state.delegationUserRestriction ? { autoDelegationApproval: false } : null)
                                    });
                                }}
                            />
                            <Toggle
                                label="Enable Automatic Delegation Approval"
                                name="autoDelegationApproval"
                                value={this.state.autoDelegationApproval}
                                description="Admin approval is skipped when requesting a user without an account to be a delegate"
                                onToggle={event => {
                                    this.setState({
                                        autoDelegationApproval: !this.state.autoDelegationApproval,
                                        ...(!this.state.autoDelegationApproval ? { delegationUserRestriction: false } : null)
                                    });
                                }}
                            />
                            <Toggle
                                label="Allow Super Publisher"
                                name="allowSuperPublisher"
                                value={this.state.allowSuperPublisher}
                                onToggle={event =>
                                    this._onFieldUpdate("allowSuperPublisher", !this.state.allowSuperPublisher)
                                }
                            />
                        </div>
                    </div>,
                    <div style={{ width: "100%", marginTop: "20px" }}>
                        <label className="form__label">Allowed Delegation Emails:</label>
                        <ul className="form__value form__value--centered">
                            {this.state.delegateDomains &&
                                this.state.delegateDomains.map((domain, index) => {
                                    return (
                                        <li key={`${domain}-${index}`}>
                                            <input type="text" value={domain ? domain : ""} disabled={true} />
                                            <Button onClick={event => this._removeDelDomain(event, domain)}>
                                                Remove
                                            </Button>
                                        </li>
                                    );
                                })}
                            <li>
                                <input
                                    type="text"
                                    ref={input => {
                                        this.delInput = input;
                                    }}
                                    onChange={event => this.setState({ addDomain: event.target.value })}
                                    placeholder="Add new allowed delegation domain"
                                />
                                <Button
                                    onClick={event => this._onDelDomainChange(this.delInput.value)}
                                    disabled={!this.state.addDomain || !this.state.addDomain.length}
                                >
                                    Add
                                </Button>
                            </li>
                        </ul>
                    </div>,
                    <div className="flex__row--center">{this._renderEmailSection("notifyNewDelegate")}</div>
                ]
            },
            complianceEnabled: {
                label: "Allow Compliance",
                value: this.state.complianceEnabled,
                description: "Enables articles shared to run though custom compliance settings",
                dropdown: [
                    <div className="flex__row--center">
                        <span style={{ maxWidth: "223px" }}>
                            <h4>Provider:</h4>
                            <div className={!!this.state.vendor ? "" : "select__wrapper"}>
                                <select disabled={!!this.state.vendor} value={this.state.tempVendor} onChange={event => this.setState({ tempVendor: event.target.value })}>
                                    <option value="" disabled hidden>Please select a provider</option>
                                    <option value="ng">Proofpoint</option>
                                </select>
                            </div>
                        </span>
                        <span style={{ marginLeft: "12px", marginTop: "auto" }}>
                            {!this.state.vendor && this.state.tempVendor && (
                                <Button
                                    onClick={event => {
                                        if (this.state.tempVendor === "ng") {
                                            const cid = this.state.cid;
                                            this._onSubmit(event, true).then(() => {
                                                ComplianceActions.doNGAuthorize(cid);
                                            });
                                        }
                                    }}
                                    style={{ maxWidth: "100px" }}
                                >
                                    Submit
                                </Button>
                            )}
                            {!!this.state.vendor && <h4 style={{ color: "green" }}>Approved</h4>}
                            {this.props.user.isSuper && !!this.state.vendor && (
                                <h4 style={{ marginBottom: "0px" }}>
                                    <span
                                        style={{ color: "red", cursor: "pointer" }}
                                        onClick={event => {
                                            if (confirm("This will remove the compliance settings for this client. Are you sure you want to proceed?")) {
                                                this.setState({ vendor: null });
                                                ComplianceActions.removeCompliance(this.state.cid);
                                            }
                                        }}
                                    >
                                        Reset
                                    </span>
                                </h4>
                            )}
                        </span>
                    </div>,
                    ...(this.state.tempVendor === "ng" ? [
                            <div>
                                <div style={{ width: "100%", marginTop: "20px" }}>
                                    <div className="flex__row--center">
                                        <Toggle
                                            label="Force Compliance in Onboarding"
                                            name="forceCompliance"
                                            value={this.state.forceCompliance}
                                            description="Must have Uses Entity Config enabled"
                                            onToggle={event => {
                                                this.state.hasEntityConfig &&
                                                    this._onFieldUpdate("forceCompliance", !this.state.forceCompliance)
                                                this.state.allowExtendedOnboarding = false;
                                            }}
                                        />
                                        <Toggle
                                            label="Profile Approval Required"
                                            name="profileApprovalRequired"
                                            value={this.state.profileApprovalRequired}
                                            onToggle={event =>
                                                this._onFieldUpdate(
                                                    "profileApprovalRequired",
                                                    !this.state.profileApprovalRequired
                                                )
                                            }
                                        />
                                        <Toggle
                                            label="Deprovision Users"
                                            name="deactivateComplianceAccount"
                                            value={this.state.deactivateComplianceAccount}
                                            onToggle={event => {
                                                this._onFieldUpdate("deactivateComplianceAccount", !this.state.deactivateComplianceAccount);
                                            }}
                                        />
                                        <Toggle
                                            label="Uses Entity Config"
                                            name="hasEntityConfig"
                                            value={this.state.hasEntityConfig}
                                            onToggle={event => {
                                                this._onFieldUpdate("hasEntityConfig", !this.state.hasEntityConfig);
                                                this.state.forceCompliance = false;
                                            }}
                                        />
                                        <Toggle
                                            label="Scan Full Article Text"
                                            name="scanFullArticleText"
                                            value={this.state.scanFullArticleText}
                                            onToggle={event => {
                                                this._onFieldUpdate("scanFullArticleText", !this.state.scanFullArticleText);
                                            }}
                                        />
                                        <Toggle
                                            label="Multi-share, Single approval"
                                            name="oneApproval"
                                            value={this.state.oneApproval}
                                            description="Allows single approval for same share to multiple networks"
                                            onToggle={event => {
                                                this._onFieldUpdate("oneApproval", !this.state.oneApproval);
                                            }}
                                        />
                                        <Toggle
                                            label="Allow Compliance Notes"
                                            name="allowComplianceNotes"
                                            value={this.state.allowComplianceNotes}
                                            description="Allows users to add notes that will be submitted to compliance when composing"
                                            onToggle={event => {
                                                this._onFieldUpdate("allowComplianceNotes", !this.state.allowComplianceNotes);
                                            }}
                                        />
                                        <Toggle
                                            label="Proofpoint User Management"
                                            name="pumEnabled"
                                            value={this.state.pumEnabled}
                                            description="Users will be added to Proofpoint's user management system"
                                            onToggle={event => {
                                                this._onFieldUpdate("pumEnabled", !this.state.pumEnabled);
                                            }}
                                        />
                                        <Toggle
                                            label="Return only Child Tenant Configurations"
                                            name="childConfigsOnly"
                                            value={this.state.childConfigsOnly}
                                            description="If enabled, only child tenant configurations will be returned."
                                            onToggle={event => {
                                                this._onFieldUpdate("childConfigsOnly", !this.state.childConfigsOnly);
                                            }}
                                        />
                                        <Toggle
                                            label="Enable Compliance Pre-checks for Comment Starters"
                                            name="enableCompliancePreCheck"
                                            value={this.state.enableCompliancePreCheck}
                                            description="Allows users to check if their comments are compliant before submitting a post."
                                            onToggle={event => {
                                                this._onFieldUpdate("enableCompliancePreCheck", !this.state.enableCompliancePreCheck);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ] : []),
                    ...(this.state.scanFullArticleText ? [
                        <div className="flex__row--center">
                            <label htmlFor="extractTextFilter" className="form__label">Domains excluded from scanning Full Article Text:</label>
                            <DomainFilterActionableList
                                updateAction={v => this._updateExtractTextFilter(v)
                                }
                                id="extractTextFilter"
                                lang={this.state.filterLang}
                                items={
                                    this.state.extractTextFilter
                                }
                            />
                        </div>
                    ]
                        : []),
                    <div className="flex__row--center">
                        {this.state.profileApprovalRequired && this._renderEmailSection("profileApproved")}
                    </div>,
                    ...(this.state.smsProvider && this.state.tempVendor === "ng" ? [
                        <div style={{ width: "100%" }}>
                            <div className="form__row flex__row--center">
                                <label className="form__label">SMS:</label>
                            </div>
                            <div style={{ border: "1px solid #ccc" }}>
                                <div style={{ display: "flex", margin: "15px" }}>
                                    <div className="form__group">
                                        <label htmlFor="preCheckPolicyId" className="form__label">Pre-check Policy Id:</label>
                                        <input
                                            id="preCheckPolicyId"
                                            type="text"
                                            className="form__value"
                                            onChange={event => this._onFieldUpdate("smsPPConfig", event)}
                                            value={this.state.smsPPConfig || ""}
                                        />
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="entityConfig" className="form__label">Entity Config:</label>
                                        <div className="select__wrapper">
                                            <select
                                                id="entityConfig"
                                                value={this.state.smsPPEntityConfig}
                                                onChange={event => this._onFieldUpdate("smsPPEntityConfig", event)}
                                            >
                                                <option value="">Please select an entity config</option>
                                                {(this.state.entityConfigOptions || []).map(option => <option value={option.value}>{option.label}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ] : [])
                ],
                onChange: value => this.setState({ complianceEnabled: value })
            },
            embeddedClientEnabled: {
                label: "Embedded Client (Requires Seismic tenant)",
                value: this.state.isEmbeddedClient,
                description: "Embedded Clients use the LiveSocial iFrame within Seismic. This can also be used in a hybrid setup. ",
                dropdown: [
                    <div className="flex__row--center">
                        <div className="flex__column--center">
                            <div className={`form__group`} style={{ border: "none" }}>
                                <div>
                                    <span className="permission__label" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>
                                        Seismic Tenant URL:
                                    </span>
                                    <input
                                        type="text"
                                        className="form__value"
                                        disabled={this._canEmbeddedClientUrlDisabled()}
                                        onChange={event => this._onFieldUpdate("embeddedClientURL", event)}
                                        value={this._canEmbeddedClientUrlDisabled() ? this.state.seismic.authBaseUrl : this.state.embeddedClientURL || ""}
                                    />
                                </div>
                                <div style={{ paddingTop: "10px" }}>
                                    <span className="permission__label" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>
                                        LiveSocial app ID:
                                    </span>
                                    <input
                                        type="text"
                                        className="form__value"
                                        onChange={event => this._onFieldUpdate("embeddedClientAppId", event)}
                                        value={this.state.embeddedClientAppId || ""}
                                    />
                                </div>
                                <div style={{ paddingTop: "10px" }}>
                                    <span className="permission__label" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>
                                        LiveSocial app extensionUniqueId:
                                    </span>
                                    <input
                                        type="text"
                                        className="form__value"
                                        onChange={event => this._onFieldUpdate("embeddedClientExtensionUniqueId", event)}
                                        value={this.state.embeddedClientExtensionUniqueId || ""}
                                    />
                                </div>
                                <div style={{ paddingTop: "10px" }}>
                                    <i className="fa fa-exclamation-circle" /> These IDs should remain static as long as the Seismic Extension is not Removed/Recreated. The Extension IDs can currently only be found using the Browser Tools to inspect the call to capture the extension ID.
                                </div>
                            </div>
                        </div>
                    </div>
                ],
                onChange: value => this.setState({ isEmbeddedClient: value })
            }
        };
    }

    _getSAMLSettings(key) {
        return {
            [`${key}.SAML2.idpIssuer`]: {
                label: "IDP Issuer",
                type: "text",
                required: true,
                value: this.state[key]?.SAML2?.idpIssuer ? this.state[key].SAML2.idpIssuer : ""
            },
            [`${key}.SAML2.entryPoint`]: {
                label: "Entry Point",
                type: "text",
                required: true,
                value: this.state[key]?.SAML2?.entryPoint ? this.state[key].SAML2.entryPoint : ""
            },
            [`${key}.SAML2.issuer`]: {
                label: "Issuer",
                type: "text",
                value: this.state[key]?.SAML2?.issuer ? this.state[key].SAML2.issuer : ""
            },
            [`${key}.SAML2.callbackUrl`]: {
                label: "Callback URL",
                type: "text",
                value: this.state[key]?.SAML2?.callbackUrl ? this.state[key].SAML2.callbackUrl : ""
            },
            [`${key}.SAML2.authnRequestBinding`]: {
                label: "Authentication Request Binder",
                type: "select",
                disabled: !!this.props.readOnly,
                values: [
                    { value: "HTTP-POST", label: "HTTP-POST" },
                    { value: "HTTP-Redirect", label: "HTTP-Redirect" }
                ],
                value: this.state[key]?.SAML2?.authnRequestBinding ? this.state[key].SAML2.authnRequestBinding : ""
            },
            [`${key}.SAML2.signatureAlgorithm`]: {
                label: "Signature Algorithm",
                type: "select",
                disabled: !!this.props.readOnly,
                values: [
                    { value: "", label: "None" },
                    { value: "sha1", label: "sha1" },
                    { value: "sha256", label: "sha256" },
                    { value: "sha512", label: "sha512" }
                ],
                value: this.state[key]?.SAML2?.signatureAlgorithm ? this.state[key].SAML2.signatureAlgorithm : ""
            }
        }
    }

    _getSeismicSSOSettings() {
        return {
            [`seismic.tenant`]: {
                label: "Tenant",
                type: "text",
                required: true,
                value: this.state.seismic?.tenant ? this.state.seismic.tenant : ""

            },
            [`seismic.authEnv`]: {
                label: "Tenant Environment",
                type: "select",
                required: true,
                values: this.state.seismicApps.map(app => ({ value: app.authEnv, label: app.name })),
                value: this.state.seismic?.authEnv ? this.state.seismic.authEnv : ""

            },
            [`dl`]: {
                label: "Distribution Link",
                type: "copyLink",
                disabled: true,
                value: this.state.seismic && this.state.seismic.authEnv
                    ? (this.state.seismicApps.find(a => a.authEnv == this.state.seismic.authEnv) || {}).distributionLink
                    : ""

            },
            [`appSSO.SEISMIC.userSyncMethod`]: {
                label: "User Synchronization",
                type: "select",
                required: true,
                values: [
                    { value: "none", label: "None" },
                    { value: "basic", label: "Basic" },
                    { value: "managed", label: "Managed" }
                ],
                value: this.state.appSSO.SEISMIC?.userSyncMethod ? this.state.appSSO.SEISMIC?.userSyncMethod : "none",
                description: <span>If enabled, users are automatically created in this client when signing in via the tenant.
                    <ul>
                        <li>None - users will not be synchronized between the Seismic tenant and LiveSocial</li>
                        <li>Basic - all tenant users will be autoprovisioned from the Seismic tenant into LiveSocial using the default role on their first login.  Updates will not be managed.</li>
                        <li>Managed - full user information will be synced from the Seismic tenant into LiveSocial.  User access and information is managed in the tenant user.</li>
                    </ul></span>
            },
            allowWelcomeEmails: {
                label: "Allow Welcome Emails for Synced Users",
                type: "toggle",
                value: this.state.allowWelcomeEmails,
                description: "When enabled, users that are synced to the app will receive a welcome email",
                hidden: this.state.appSSO.SEISMIC?.userSyncMethod === "none",
                onChange: (value) => this.setState({ allowWelcomeEmails: value })
            },
            [`appSSO.SEISMIC.notifyEmail`]: {
                label: "Sync error notification Email",
                type: "email",
                required: false,
                value: this.state.appSSO.SEISMIC?.notifyEmail ? this.state.appSSO.SEISMIC?.notifyEmail : "",
                description: "Email address to notify when user synchronization errors occur."
            },
            allowSFContactAccess: {
                label: "Allow Seismic SalesForce Contact Access",
                type: "boolean",
                required: true,
                hidden: !this.state.smsProvider,
                value: this.state.allowSFContactAccess,
                description: "If enabled, LiveSocial Text will access SalesForce contacts via Seismic contact picker API."
            }
        }
    }

    _removeCert(event, index, key) {
        if (event) {
            event.preventDefault();
        }

        let { cert } = this.state[key]?.SAML2;
        cert.splice(index, 1);
        this._onFieldUpdate(`${key}.SAML2.cert`, cert);
        createAlert('Certificate removed', 'success');
    }

    _getCertSetting(key) {
        return <div className="form__group" style={{ width: "100%" }}>
            <label className="form__label">Certificates *:</label>
            <ul id="ContentTags" className="form__value form__value--centered">
                {(this.state[key]?.SAML2?.cert || []).map(
                    (cert, index) => {
                        return (
                            <li key={`cert-${index}`}>
                                <input
                                    type="text"
                                    value={cert}
                                    disabled={true}
                                />{" "}
                                <Button
                                    onClick={event =>
                                        this._removeCert(event.target.value, index, key)
                                    }
                                >
                                    Remove{" "}
                                </Button>
                            </li>
                        );
                    }
                )}
                <li>
                    <input
                        onChange={event =>
                            this.setState({ addCert: event.target.value })
                        }
                        value={this.state.addCert}
                        placeholder="Add new certificate"
                    />
                    <Button
                        onClick={event => {
                            this._onFieldUpdate(`${key}.SAML2.cert`, [...(this.state[key]?.SAML2?.cert || []), this.state.addCert]);
                            this.setState({ addCert: "" });
                        }}
                        disabled={!this.state.addCert?.length}
                    >
                        Add
                    </Button>
                </li>
            </ul>
        </div>
    }

    _getSSOSettings() {
        return {
            adminSSO: {
                label: "Enable Admin SSO",
                value: !!this.state.adminSSO?.method,
                type: "toggle",
                description: "Allow admins to log in to the console using SAML SSO",
                onChange: event => this._onFieldUpdate("adminSSO", {
                    ...this.state.adminSSO,
                    method: event ? "SAML2" : "",
                    ...(!this.state.adminSSO?.SAML2 ? { SAML2: { authnRequestBinding: "HTTP-POST" } } : null)
                }),
                dropdown: [
                    <div style={{ marginRight: "auto", fontWeight: "bold", fontSize: "14px" }}>
                        Note: When enabling SSO for Admins, please ensure that all admins that will be signing in with SSO (Curator, Reports, User and external Client Admins) have an SSO ID assigned.
                    </div>,
                    <br />,
                    <PermissionSet
                        permissions={this._getSAMLSettings("adminSSO")}
                        _onChange={this._onFieldUpdate}
                        setNumber={"51"}
                        style={{ width: "100%" }}
                    />,
                    <br />,
                    this._getCertSetting("adminSSO")
                ]
            },
            appSSO: {
                label: "Enable User SSO",
                value: !!this.state.appSSO?.method,
                type: "toggle",
                description: "Allow users to log in to the app using SAML SSO or Seismic SSO",
                onChange: event => {
                    this._onFieldUpdate("appSSO", {
                        ...this.state.appSSO,
                        method: event ? "SAML2" : "",
                        ...(!this.state.appSSO?.SAML2 ? { SAML2: { authnRequestBinding: "HTTP-POST" } } : null)
                    });
                    this.setState({ allowSeismicStreams: false })
                },
                dropdown: [
                    <div style={{ marginRight: "auto", fontWeight: "bold", fontSize: "14px" }}>
                        Note: When enabling SSO for Users, please ensure that all users have an SSO ID assigned. Users without an SSO ID will not be able to log into the app. If you have users that have already activated but are missing an SSO ID, please speak to a developer to have an SSO ID assigned.
                    </div>,
                    <br />,
                    <div className="form__row">
                        <div className="form__group">
                            <label htmlFor="ssoMechanism" className="form__label">SSO Mechanism:</label>
                            <div className="select__wrapper">
                                <select
                                    id="ssoMechanism"
                                    value={this.state.appSSO?.method}
                                    onChange={event => {
                                        const appSSO = {
                                            SAML2: { authnRequestBinding: "HTTP-POST" },
                                            SEISMIC: { userSyncMethod: "none", notifyEmail: "" },
                                            ...this.state.appSSO,
                                            method: event.target.value
                                        };
                                        this.setState({
                                            allowSeismicStreams: event.target.value === "SEISMIC",
                                            appSSO
                                        })
                                    }}
                                >
                                    <option value="SAML2">SAML 2.0</option>
                                    <option value="SEISMIC">Seismic</option>
                                </select>
                            </div>
                        </div>
                    </div>,
                    <br />,
                    ...(this.state.appSSO?.method === "SEISMIC"
                        ? [
                            <div>The settings below will enable both Seismic SSO and importing content from Seismic into a stream.</div>,
                            <PermissionSet
                                permissions={this._getSeismicSSOSettings()}
                                _onChange={this._onFieldUpdate}
                                setNumber={"52"}
                                style={{ width: "100%" }}
                            />]
                        : []
                    ),
                    ...(this.state.appSSO?.method === "SAML2"
                        ? [
                            <PermissionSet
                                permissions={this._getSAMLSettings("appSSO")}
                                _onChange={this._onFieldUpdate}
                                setNumber={"52"}
                                style={{ width: "100%" }}
                            />,
                            <br />,
                            this._getCertSetting("appSSO")
                        ]
                        : [])
                ]
            }
        };
    }

    /* ---------- seismic settings and helper functions ---------- */
    _getSMSSettings() {
        return {
            smsProvider: {
                label: "SMS Service Provider",
                value: this.state.smsProvider,
                values: [
                    { value: "", label: "None (Disabled)" },
                    { value: "aerialink", label: "AeriaLink" },
                    { value: "infobip", label: "Infobip" },
                    { value: "telnyx", label: "Telnyx" },
                    { value: "twilio", label: "Twilio" },
                    { value: "celltrust", label: "CellTrust" },
                    { value: "usbank", label: "US Bank" },
                    { value: "smsLoadTest", label: "SMS Test Provider (DO NOT USE)" },
                ],
                type: "select",
                placeholder: "None (Disabled)",
                description: "Enables users to share content with the LiveSocial Text product, using the selected provider",
                disabled: this.props.readOnly,
                dropdown: [
                    this.state.smsProvider == "twilio"
                        ? <div className="form__row flex__row--center">
                            <div className="form__group">
                                <label htmlFor="twilioSID" className="form__label">Twilio SMS Account SID:</label>
                                <input
                                    id="twilioSID"
                                    type="text"
                                    className="form__value"
                                    value={
                                        this.state.twilio && this.state.twilio.accountSid
                                            ? this.state.twilio.accountSid
                                            : ""
                                    }
                                    onChange={event =>
                                        this._onFieldUpdate("twilio", {
                                            ...this.state.twilio,
                                            accountSid: event.target.value
                                        })
                                    }
                                />
                            </div>
                            <div className="form__group">
                                <label htmlFor="twilioAuthToken" className="form__label">Twilio SMS Authentication Token:</label>
                                <input
                                    id="twilioAuthToken"
                                    type="password"
                                    className="form__value"
                                    value={
                                        this.state.twilio && this.state.twilio.authToken
                                            ? this.state.twilio.authToken
                                            : ""
                                    }
                                    onChange={event =>
                                        this._onFieldUpdate("twilio", {
                                            ...this.state.twilio,
                                            authToken: event.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                        : this.state.smsProvider == "infobip"
                            ? <div className="form__row flex__row--center">
                                <div className="form__group">
                                    <label htmlFor="infobipBaseUrl" className="form__label">Infobip SMS API base url:</label>
                                    <input
                                        id="infobipBaseUrl"
                                        type="text"
                                        className="form__value"
                                        value={
                                            this.state.infobip && this.state.infobip.baseUrl
                                                ? this.state.infobip.baseUrl
                                                : ""
                                        }
                                        onChange={event =>
                                            this._onFieldUpdate("infobip", {
                                                ...this.state.infobip,
                                                baseUrl: event.target.value
                                            })
                                        }
                                    />
                                </div>
                                <div className="form__group">
                                    <label htmlFor="infobipAuthToken" className="form__label">Infobip SMS Authentication Token:</label>
                                    <input
                                        id="infobipAuthToken"
                                        type="password"
                                        className="form__value"
                                        value={
                                            this.state.infobip && this.state.infobip.authorization
                                                ? this.state.infobip.authorization
                                                : ""
                                        }
                                        onChange={event =>
                                            this._onFieldUpdate("infobip", {
                                                ...this.state.infobip,
                                                authorization: event.target.value
                                            })
                                        }
                                    />
                                </div>
                            </div>
                            : this.state.smsProvider == "telnyx"
                                ? <div className="form__row flex__row--center">
                                    <div className="form__group">
                                        <label htmlFor="billingGroupId" className="form__label">Billing Group ID:</label>
                                        <input
                                            id="billingGroupId"
                                            type="text"
                                            className="form__value"
                                            value={
                                                this.state.telnyx && this.state.telnyx.billing_group_id
                                                    ? this.state.telnyx.billing_group_id
                                                    : ""
                                            }
                                            onChange={event =>
                                                this._onFieldUpdate("telnyx", {
                                                    ...this.state.telnyx,
                                                    billing_group_id: event.target.value
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                                : null
                ]
            },
            smsArchiveEmail: {
                label: "SMS Archive Email Address",
                description: <div>
                    <p>SMS message records will be sent to the specified email address for archiving.</p>
                    <p>This email address should be linked to your archive system.</p>
                    <p>If no email address is entered, the client will not be enabled for SMS archiving by email.</p>
                </div>,
                placeholder: "Add new archive email address",
                type: "text",
                hidden: !this.state.smsProvider || this.state.smsProvider === "celltrust",
                value: this.state.smsArchiveEmail || ""
            },
            optInFlow: {
                label: "Opt-In Flow",
                disabled: this.props.readOnly,
                hidden: !this.state.smsProvider,
                value: this.state.smsOptDefault,
                values: [
                    { value: "OUT", label: "Default Opted Out" },
                    { value: "IN", label: "Default Opted In" },
                    { value: "NONE", label: "No Opt-In/Out" }
                ],
                type: "select",
                onChange: event => this._onFieldUpdate("smsOptDefault", event),
                placeholder: "Default Opted Out",
                description: "Determines if sms contacts recieve an opt-in or opt-out message when they are first contacted."
            }
        };
    }

    /* ---------- embedded seismic client app settings ---------- */
    // determine can the Seismic Tenant URL pull from User SSO settings
    _canEmbeddedClientUrlDisabled() {
        let { appSSO, seismic } = this.state;
        return appSSO?.method === "SEISMIC" && seismic?.authBaseUrl;
    }

    /* ---------- e-Communication settings and helper functions ---------- */
    _getECommunicationSettings() {
        return {
            allowECommunication: {
                label: "Enable e-Communication",
                value: this.state.allowECommunication || false,
                description: "Enables users to access the e-Communication section",
                dropdown: [
                    <div className="flex__row--center">
                        <div className="flex__column--center">
                            <div className="form__row">
                                <div className="form__group">
                                    <label className="form__label">
                                        Additional Settings:
                                        <span
                                            style={{
                                                float: "right",
                                                marginRight: "15px"
                                            }}
                                        >
                                            Off/On
                                        </span>
                                    </label>
                                    <div className="permission">
                                        <span className="permission__label">
                                            Allow Group Inboxes{" "}
                                            <Tooltip>
                                                If enabled, group inboxes will be available when scheduling emails
                                            </Tooltip>
                                        </span>
                                        <Toggle
                                            name="eCommunicationAllowGroupInboxes"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.allowGroupInboxes
                                                    ? this.state.eCommunication.allowGroupInboxes
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    allowGroupInboxes: !this.state.eCommunication.allowGroupInboxes
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Allow Contact Driven{" "}
                                            <Tooltip>
                                                If enabled, create subscriptions frequency will contain contact driven options
                                            </Tooltip>
                                        </span>
                                        <Toggle
                                            name="eCommunicationAllowContactDriven"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.allowContactDriven
                                                    ? this.state.eCommunication.allowContactDriven
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    allowContactDriven: !this.state.eCommunication.allowContactDriven
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Allow Save Draft{" "}
                                            <Tooltip>
                                                If enabled, users will be able to save email drafts when composing emails in e-Communication
                                            </Tooltip>
                                        </span>
                                        <Toggle
                                            name="eCommunicationAllowSaveDraft"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.allowSaveDraft
                                                    ? this.state.eCommunication.allowSaveDraft
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    allowSaveDraft: !this.state.eCommunication.allowSaveDraft
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Force Onboarding Workflow{" "}
                                            <Tooltip>
                                                Force new user to complete the e-communicaiton onboarding process to
                                                provide user information
                                            </Tooltip>
                                        </span>
                                        <Toggle
                                            name="eCommunicationRequiredUserSetup"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.requiredUserSetup
                                                    ? this.state.eCommunication.requiredUserSetup
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    requiredUserSetup: !this.state.eCommunication.requiredUserSetup
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Sync Social Accounts{" "}
                                            <Tooltip>
                                                Synchronize signed in social accounts into e-communication profile for email signature purposes.
                                            </Tooltip>
                                        </span>
                                        <Toggle
                                            name="eCommunicationSyncSocialAccountToProfile"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.syncSocialAccountToProfile
                                                    ? this.state.eCommunication.syncSocialAccountToProfile
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    syncSocialAccountToProfile: !this.state.eCommunication.syncSocialAccountToProfile
                                                })
                                            }
                                        />
                                    </div>
                                    {this.state.eCommunication &&
                                        this.state.eCommunication.syncSocialAccountToProfile == true && (
                                            <div className="permission no-borders">
                                                <span className="permission__label">
                                                    Sync Social Accounts from Entity Config{" "}
                                                    <Tooltip>
                                                        Synchronize social accounts into e-communication profile with entity config for email signature purposes everytime the user logs in.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="eCommunicationsyncSocialAccountEntityConfig"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.syncSocialAccountEntityConfig
                                                            ? this.state.eCommunication.syncSocialAccountEntityConfig
                                                            : false
                                                    }
                                                    onToggle={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            syncSocialAccountEntityConfig: !this.state.eCommunication.syncSocialAccountEntityConfig
                                                        })
                                                    }
                                                />
                                            </div>
                                        )
                                    }
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Show Profile Sync on User Profile{" "}
                                        </span>
                                        <Toggle
                                            name="eCommunicationShowProfileSync"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.showProfileSync
                                                    ? this.state.eCommunication.showProfileSync
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    showProfileSync: !this.state.eCommunication.showProfileSync
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Show Profile Sync on User Contacts{" "}
                                        </span>
                                        <Toggle
                                            name="eCommunicationShowContactSync"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.showContactSync
                                                    ? this.state.eCommunication.showContactSync
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    showContactSync: !this.state.eCommunication.showContactSync
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Show Leading Comma with Signature Designations{" "}
                                        </span>
                                        <Toggle
                                            name="eCommunicationprependCommaDesignation"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.prependCommaDesignation
                                                    ? this.state.eCommunication.prependCommaDesignation
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    prependCommaDesignation: !this.state.eCommunication.prependCommaDesignation
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Show Duplicate Email{" "}
                                        </span>
                                        <Toggle
                                            name="eCommunicationshowDuplicateEmail"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.showDuplicateEmail
                                                    ? this.state.eCommunication.showDuplicateEmail
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    showDuplicateEmail: !this.state.eCommunication.showDuplicateEmail
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            Sync CRM Contacts (for RJ US){" "}
                                        </span>
                                        <Toggle
                                            name="syncCRMContacts"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.syncCRMContacts
                                                    ? this.state.eCommunication.syncCRMContacts
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    syncCRMContacts: !this.state.eCommunication.syncCRMContacts
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="permission no-borders">
                                        <span className="permission__label">
                                            User Email Content Customization{" "}
                                            <Tooltip>
                                                Allow app users to customize the content of the email where marketer designed email templates with special merge tags
                                            </Tooltip>
                                        </span>
                                        <Toggle
                                            name="eCommunicationAdvisorEditing"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.advisorEditing
                                                    ? this.state.eCommunication.advisorEditing
                                                    : false
                                            }
                                            onToggle={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    advisorEditing: !this.state.eCommunication.advisorEditing
                                                })
                                            }
                                        />
                                    </div>
                                    {this.state.eCommunication &&
                                        this.state.eCommunication.advisorEditing == true && (
                                            <div className="form__group no-borders" style={{ padding: "10px 0px" }}>
                                                <label htmlFor="reviewProvider" className="form__label" style={{ fontWeight: "normal" }}>
                                                    User Email Content Customization - Review Provider{" "}
                                                    <Tooltip>
                                                        Allow app users to customized content to be reviewed by a compliance provider<br /><br />
                                                        Note: If None is selected, then bypassing the review workflow
                                                    </Tooltip>
                                                </label>
                                                <div className="select__wrapper">
                                                    <select
                                                        id="reviewProvider"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.advisorEditingReviewEngine
                                                                ? this.state.eCommunication.advisorEditingReviewEngine
                                                                : "none"
                                                        }
                                                        onChange={event =>
                                                            this._onECommunicationEngineChange({
                                                                ...this.state.eCommunication,
                                                                advisorEditingReviewEngine: event.target.value,
                                                                advisorEditingReviewMinimumRecipients: event.target.value === "proofpoint" ? 1 : this.state.eCommunication.advisorEditingReviewMinimumRecipients
                                                            })
                                                        }
                                                    >
                                                        <option value="none">None</option>
                                                        <option value="adtrax">Adtrax</option>
                                                        <option value="rjcsp">RJ CSP</option>
                                                        <option value="proofpoint">Proofpoint</option>
                                                    </select>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {this.state.eCommunication &&
                                        this.state.eCommunication.advisorEditing == true && this.state.eCommunication.advisorEditingReviewEngine != null &&
                                        this.state.eCommunication.advisorEditingReviewEngine !== 'none' && (
                                            <div className="form__group no-borders" style={{ padding: "10px 0" }}>
                                                <label htmlFor="minRecipients" className="form__label">
                                                    Minimum number of recipients threshold:&nbsp;
                                                    <Tooltip>
                                                        Minimum recipients to submit a review request.
                                                        This allows the admin to define a threshold to omit the reviewing process. Use 0 to submit all requests.
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    id="minRecipients"
                                                    type="number"
                                                    min={this.state.eCommunication && this.state.eCommunication.advisorEditingReviewEngine === "proofpoint" ? 1 : 0}
                                                    max={365 * 5}
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.advisorEditingReviewEngine === "proofpoint"
                                                            ? 1
                                                            : this.state.eCommunication.advisorEditingReviewMinimumRecipients || 25
                                                    }
                                                    onChange={event => {
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            advisorEditingReviewMinimumRecipients: Number(event.target.value)
                                                        });
                                                    }}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="form__group">
                                    <div style={{ padding: "0px 20px" }}>
                                        <label htmlFor="defaultExpiryDays" className="form__label">
                                            Default Message Expiry (in days):&nbsp;
                                            <Tooltip>
                                                When creating a new message, the default number of days to expiration date
                                                from the creation day
                                            </Tooltip>
                                        </label>
                                        <input
                                            id="defaultExpiryDays"
                                            type="number"
                                            min={1}
                                            max={365 * 5}
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.expiryDefault
                                                    ? this.state.eCommunication.expiryDefault
                                                    : 1
                                            }
                                            onChange={event =>
                                                this._onFieldUpdate("eCommunication", {
                                                    ...this.state.eCommunication,
                                                    expiryDefault: Number(event.target.value)
                                                })
                                            }
                                        />
                                    </div>
                                    <div style={{ padding: "10px 20px 0px" }}>
                                        <label htmlFor="panel" className="form__label">
                                            Default Dashboard Content Library Panel:&nbsp;
                                            <Tooltip>
                                            </Tooltip>
                                        </label>
                                        <div className="select__wrapper">
                                            <select
                                                id="panel"
                                                value={
                                                    this.state.eCommunication && this.state.eCommunication.defaultDashboardLibraryPanel
                                                        ? this.state.eCommunication.defaultDashboardLibraryPanel
                                                        : "none"
                                                }
                                                onChange={event =>
                                                    this._onECommunicationEngineChange({
                                                        ...this.state.eCommunication,
                                                        defaultDashboardLibraryPanel: event.target.value
                                                    })
                                                }
                                            >
                                                <option value="subscribe">Subscription</option>
                                                <option value="schedule">One-Time</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form__row flex__row--center">
                                <div className="form__group">
                                    <label htmlFor="emailPlatformEngine" className="form__label">Email Platform Engine:</label>
                                    <div className="select__wrapper">
                                        <select
                                            id="emailPlatformEngine"
                                            value={
                                                this.state.eCommunication && this.state.eCommunication.engine
                                                    ? this.state.eCommunication.engine
                                                    : ""
                                            }
                                            onChange={event =>
                                                this._onECommunicationEngineChange({
                                                    ...this.state.eCommunication,
                                                    engine: event.target.value
                                                })
                                            }
                                        >
                                            <option value="">Please Select One</option>
                                            <option value="GV6">LiveSocial</option>
                                            <option value="apigee">Apigee</option>
                                            <option value="SFP">SalesForce Push</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {this.state.eCommunication &&
                                this.state.eCommunication.engine &&
                                this.state.eCommunication.engine == "GV6" && (
                                    <div className="eCommunicationEngine_gv6">
                                        <div className="form__row flex__row--center">
                                            <label className="form__label">LiveSocial Engine Settings:</label>
                                        </div>
                                        <div style={{ border: "1px solid #ccc" }}>
                                            <div className="form__row flex__row--center" style={{ padding: "15px 20px 0px" }}>
                                                <div className="form__group" style={{ marginTop: "10px" }}>
                                                    <label htmlFor="apiUrl" className="form__label">API URL:&nbsp;
                                                        <Tooltip>
                                                            Domain for the API endpoint. <br />
                                                            eg: http://emkt.gv6test.com<br /><br />
                                                            NOTE: Please ensure no trailing slashes
                                                        </Tooltip>
                                                    </label>
                                                    <input
                                                        id="apiUrl"
                                                        type="text"
                                                        className="form__value"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.apiUrl
                                                                ? this.state.eCommunication.apiUrl
                                                                : ""
                                                        }
                                                        onChange={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                apiUrl: event.target.value
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__row" style={{ padding: "0px 20px 5px" }}>
                                                <div className="form__group">
                                                    <label htmlFor="apiAdminUsername" className="form__label">API Administrator Username:</label>
                                                    <input
                                                        id="apiAdminUsername"
                                                        type="text"
                                                        className="form__value"
                                                        onChange={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                engineUser: event.target.value
                                                            })
                                                        }
                                                        value={
                                                            this.state.eCommunication &&
                                                                this.state.eCommunication.engineUser
                                                                ? this.state.eCommunication.engineUser
                                                                : ""
                                                        }
                                                    />
                                                </div>
                                                <div className="form__group">
                                                    <label htmlFor="apiAdminPass" className="form__label">API Administrator Password:</label>
                                                    <input
                                                        id="apiAdminPass"
                                                        type="password"
                                                        className="form__value"
                                                        onChange={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                enginePassword: event.target.value
                                                            })
                                                        }
                                                        value={
                                                            this.state.eCommunication &&
                                                                this.state.eCommunication.enginePassword
                                                                ? this.state.eCommunication.enginePassword
                                                                : ""
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            {this.state.eCommunication &&
                                this.state.eCommunication.engine &&
                                this.state.eCommunication.engine == "apigee" && (
                                    <div className="eCommunicationEngine_apigee">
                                    </div>
                                )}
                            {this.state.eCommunication &&
                                this.state.eCommunication.engine &&
                                this.state.eCommunication.engine == "SFP" && (
                                    <div className="eCommunicationEngine_sfp">
                                        <div className="form__row flex__row--center">
                                            <label className="form__label">SalesForce Push Settings:</label>
                                        </div>
                                        <div style={{ border: "1px solid #ccc" }}>
                                            <div className="form__row" style={{ padding: "0px 20px 5px" }}>
                                                <div className="form__group">
                                                    <label className="form__label">
                                                        <span
                                                            style={{
                                                                float: "right",
                                                                marginRight: "15px",
                                                                paddingTop: "10px"
                                                            }}
                                                        >Off/On
                                                        </span>
                                                    </label>
                                                    <div className="permission">
                                                        <span className="permission__label">
                                                            Access to Contact List Toggle{" "}
                                                            <Tooltip>
                                                                If enabled, LiveSocial will have access to individual contact information and users will be able to send e-communications to individual contacts
                                                            </Tooltip>
                                                        </span>
                                                        <Toggle
                                                            name="sfpAccessToContacts"
                                                            value={
                                                                this.state.eCommunication && this.state.eCommunication.sfpAccessToContacts
                                                                    ? this.state.eCommunication.sfpAccessToContacts
                                                                    : false
                                                            }
                                                            onToggle={event =>
                                                                this._onFieldUpdate("eCommunication", {
                                                                    ...this.state.eCommunication,
                                                                    sfpAccessToContacts: !this.state.eCommunication.sfpAccessToContacts
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            <div className="eCommunicationConfig" style={{ paddingTop: "15px" }}>
                                <div className="form__row flex__row--center">
                                    <label className="form__label">Platform Contacts/Mailing List Settings:</label>
                                </div>
                                <div style={{ border: "1px solid #ccc" }}>
                                    <div className="form__row" style={{ padding: "0px 20px 5px" }}>
                                        <div className="form__group">
                                            <label className="form__label">
                                                <span
                                                    style={{
                                                        float: "right",
                                                        marginRight: "15px",
                                                        paddingTop: "10px"
                                                    }}
                                                >Off/On
                                                </span>
                                            </label>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user manage contacts{" "}
                                                    <Tooltip>
                                                        If enabled, individual contacts will be available for contact management and recipient selection.<br /><br />
                                                        Note: At least one of manage contacts or manage mailing list has to be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformManageContacts"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformManageContacts
                                                            ? this.state.eCommunication.platformManageContacts
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        let platformManageMailingList = this.state.eCommunication.platformManageMailingList;
                                                        let platformCreateContacts = this.state.eCommunication.platformCreateContacts;
                                                        let platformUpdateContacts = this.state.eCommunication.platformUpdateContacts;
                                                        let platformImportContacts = this.state.eCommunication.platformImportContacts;
                                                        if (this.state.eCommunication.platformManageContacts) {
                                                            platformCreateContacts = false;
                                                            platformUpdateContacts = false;
                                                            platformImportContacts = false;
                                                            if (!platformManageMailingList) {
                                                                platformManageMailingList = true;
                                                            }
                                                        }
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            platformManageMailingList,
                                                            platformCreateContacts,
                                                            platformUpdateContacts,
                                                            platformImportContacts,
                                                            platformManageContacts: !this.state.eCommunication.platformManageContacts
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user create contacts{" "}
                                                    <Tooltip>
                                                        If enabled, individual can create contacts in contact management.<br /><br />
                                                        Note: Manage contacts must be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformCreateContacts"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformCreateContacts
                                                            ? this.state.eCommunication.platformCreateContacts
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        if (this.state.eCommunication.platformManageContacts) {
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                platformCreateContacts: !this.state.eCommunication.platformCreateContacts
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user update contacts{" "}
                                                    <Tooltip>
                                                        If enabled, individual can update contacts in contact management.<br /><br />
                                                        Note: Manage contacts must be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformUpdateContacts"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformUpdateContacts
                                                            ? this.state.eCommunication.platformUpdateContacts
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        if (this.state.eCommunication.platformManageContacts) {
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                platformUpdateContacts: !this.state.eCommunication.platformUpdateContacts
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user import contacts{" "}
                                                    <Tooltip>
                                                        If enabled, individual can import contacts in contact management.<br /><br />
                                                        Note: Manage contacts must be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformImportContacts"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformImportContacts
                                                            ? this.state.eCommunication.platformImportContacts
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        if (this.state.eCommunication.platformManageContacts) {
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                platformImportContacts: !this.state.eCommunication.platformImportContacts
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__group">
                                            <label className="form__label">
                                                <span
                                                    style={{
                                                        float: "right",
                                                        marginRight: "15px",
                                                        paddingTop: "10px"
                                                    }}
                                                >Off/On
                                                </span>
                                            </label>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user manage mailing list{" "}
                                                    <Tooltip>
                                                        If enabled, mailing list will be available for contact management and recipient selection.<br /><br />
                                                        Note: At least one of manage contacts or manage mailing list has to be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformManageMailingList"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformManageMailingList
                                                            ? this.state.eCommunication.platformManageMailingList
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        let platformManageContacts = this.state.eCommunication.platformManageContacts;
                                                        let platformCreateMailingList = this.state.eCommunication.platformCreateMailingList;
                                                        let platformUpdateMailingList = this.state.eCommunication.platformUpdateMailingList;
                                                        let platformImportMailingList = this.state.eCommunication.platformImportMailingList;
                                                        if (this.state.eCommunication.platformManageMailingList) {
                                                            platformCreateMailingList = false;
                                                            platformUpdateMailingList = false;
                                                            platformImportMailingList = false;
                                                            if (!platformManageContacts) {
                                                                platformManageContacts = true;
                                                            }
                                                        }
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            platformManageContacts,
                                                            platformCreateMailingList,
                                                            platformUpdateMailingList,
                                                            platformImportMailingList,
                                                            platformManageMailingList: !this.state.eCommunication.platformManageMailingList
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user create mailing list{" "}
                                                    <Tooltip>
                                                        If enabled, mailing list can be created in mailing list management.<br /><br />
                                                        Note: Manage mailing list must be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformCreateMailingList"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformCreateMailingList
                                                            ? this.state.eCommunication.platformCreateMailingList
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        if (this.state.eCommunication.platformManageMailingList) {
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                platformCreateMailingList: !this.state.eCommunication.platformCreateMailingList
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user update mailing list{" "}
                                                    <Tooltip>
                                                        If enabled, mailing list can be updated in mailing list management.<br /><br />
                                                        Note: Manage mailing list must be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformUpdateMailingList"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformUpdateMailingList
                                                            ? this.state.eCommunication.platformUpdateMailingList
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        if (this.state.eCommunication.platformManageMailingList) {
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                platformUpdateMailingList: !this.state.eCommunication.platformUpdateMailingList
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="permission">
                                                <span className="permission__label">
                                                    Allow user import mailing list{" "}
                                                    <Tooltip>
                                                        If enabled, mailing list can be imported in mailing list management.<br /><br />
                                                        Note: Manage mailing list must be enabled.
                                                    </Tooltip>
                                                </span>
                                                <Toggle
                                                    name="platformImportMailingList"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.platformImportMailingList
                                                            ? this.state.eCommunication.platformImportMailingList
                                                            : false
                                                    }
                                                    onToggle={event => {
                                                        if (this.state.eCommunication.platformManageMailingList) {
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                platformImportMailingList: !this.state.eCommunication.platformImportMailingList
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="eCommunicationMessage" style={{ paddingTop: "15px" }}>
                                <div className="form__row flex__row--center">
                                    <label className="form__label">Message Settings:</label>
                                </div>
                                <div style={{ border: "1px solid #ccc" }}>
                                    <div className="form__row flex__row--center" style={{ padding: "5px 0px 0px" }}>
                                        <div className="form__row" style={{ padding: "0px 20px 5px" }}>
                                            <div className="form__group">
                                                <label className="form__label">
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px",
                                                            paddingTop: "10px"
                                                        }}
                                                    >Off/On
                                                    </span>
                                                </label>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enable Compliance{" "}
                                                        <Tooltip>
                                                            Enable the compliance block in the e-Communication message configuration
                                                        </Tooltip>
                                                    </span>
                                                    <Toggle
                                                        name="messageCompliance"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.messageCompliance
                                                                ? this.state.eCommunication.messageCompliance
                                                                : false
                                                        }
                                                        onToggle={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                messageCompliance: !this.state.eCommunication.messageCompliance,
                                                                messageComplianceEnforced: false,
                                                                messageComplianceWorkflow: false,
                                                            })
                                                        }
                                                    />
                                                </div>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enforce Compliance Logic{" "}
                                                        <Tooltip>
                                                            Enforce the e-Communication compliance validation prior activate the message. The checks include following:<br /><br />
                                                            <ul>
                                                                <li>Compliance approval number must be set</li>
                                                                <li>Compliance expiry date must be set and must be after the message expiration date</li>
                                                                <li>For subscription messages, the delivery date must be set before compliance expiry date</li>
                                                            </ul>
                                                            e-Communication compliance needs to be enabled for this feature.
                                                        </Tooltip>
                                                    </span>
                                                    <Toggle
                                                        name="messageComplianceEnforced"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.messageComplianceEnforced
                                                                ? this.state.eCommunication.messageComplianceEnforced
                                                                : false
                                                        }
                                                        onToggle={event => {
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                messageComplianceEnforced: (
                                                                    this.state.eCommunication.messageCompliance
                                                                        ? !this.state.eCommunication.messageComplianceEnforced
                                                                        : false
                                                                )
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enable Compliance Workflow{" "}
                                                    </span>
                                                    <Toggle
                                                        name="messageComplianceWorkflow"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.messageComplianceWorkflow
                                                                ? this.state.eCommunication.messageComplianceWorkflow
                                                                : false
                                                        }
                                                        onToggle={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                messageComplianceWorkflow: (
                                                                    this.state.eCommunication.messageCompliance
                                                                        ? !this.state.eCommunication.messageComplianceWorkflow
                                                                        : false
                                                                )
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__group">
                                                <label className="form__label">
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px",
                                                            paddingTop: "10px"
                                                        }}
                                                    >Off/On
                                                    </span>
                                                </label>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enable Editable Type Filtering{" "}
                                                        <Tooltip>
                                                            Enable editable type filtering on one time messages, give the message are configured
                                                        </Tooltip>
                                                    </span>
                                                    <Toggle
                                                        name="enableOneTimeEditableType"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.enableOneTimeEditableType
                                                                ? this.state.eCommunication.enableOneTimeEditableType
                                                                : false
                                                        }
                                                        onToggle={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                enableOneTimeEditableType: !this.state.eCommunication.enableOneTimeEditableType
                                                            })
                                                        }
                                                    />
                                                </div>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enable Message Bookmarking{" "}
                                                        <Tooltip>
                                                            Enable bookmarking on one time messages.
                                                        </Tooltip>
                                                    </span>
                                                    <Toggle
                                                        name="enableOneTimeBookmarking"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.enableOneTimeBookmarking
                                                                ? this.state.eCommunication.enableOneTimeBookmarking
                                                                : false
                                                        }
                                                        onToggle={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                enableOneTimeBookmarking: !this.state.eCommunication.enableOneTimeBookmarking
                                                            })
                                                        }
                                                    />
                                                </div>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enable BEE Editor{" "}
                                                        <Tooltip>
                                                            Enables BEE Editor (WYSIWYG) to configure the body of e-communication messages. <br />
                                                            If disabled, messages must be configured in raw HTML.<br /><br />
                                                            Note that if enabled, any existing messages in raw HTML will not be <br />
                                                            automatically converted to display in the BEE Editor.
                                                        </Tooltip>
                                                    </span>
                                                    <Toggle
                                                        name="beeEditorEnabled"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.beeEditorEnabled
                                                                ? this.state.eCommunication.beeEditorEnabled
                                                                : false
                                                        }
                                                        onToggle={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                beeEditorEnabled: !this.state.eCommunication.beeEditorEnabled
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form__row flex__row--center" style={{ padding: "0px 20px" }}>
                                        <div className="form__group" style={{ marginTop: "10px" }}>
                                            <label htmlFor="linkedinSignature" className="form__label"
                                                style={{ display: "flex", alignItems: "center" }}>
                                                LinkedIn Signature Icon Template:&nbsp;
                                                <Tooltip>
                                                    The HTML to be used in text substitution for "[linkedin]" as LinkedIn social icons in the message, <br />
                                                    typically shows up in the footer of the message. <br />
                                                    The markup should contain "[linkedinLink]" for the email sender's LinkedIn profile URL.<br />
                                                </Tooltip>
                                            </label>
                                            <textarea
                                                id="linkedinSignature"
                                                placeholder="LinkedIn Signature Icon Template HTML"
                                                className="form__value"
                                                onChange={event =>
                                                    this._onFieldUpdate("eCommunication", {
                                                        ...this.state.eCommunication,
                                                        templateLinkedin: event.target.value
                                                    })
                                                }
                                                style={{ minHeight: "250px" }}
                                                value={this.state.eCommunication.templateLinkedin ? this.state.eCommunication.templateLinkedin : ""}
                                            />
                                        </div>
                                        <div className="form__group" style={{ marginTop: "10px" }}>
                                            <label htmlFor="twitterSignature" className="form__label"
                                                style={{ display: "flex", alignItems: "center" }}>
                                                X (Twitter) Signature Icon Template:&nbsp;
                                                <Tooltip>
                                                    The HTML to be used in text substitution for "[x(twitter)]" as X (Twitter) social icons in the message, <br />
                                                    typically shows up in the footer of the message. <br />
                                                    The markup should contain "[x(twitter)Link]" for the email sender's X (Twitter) stream URL.<br />
                                                </Tooltip>
                                            </label>
                                            <textarea
                                                id="twitterSignature"
                                                placeholder="X (Twitter) Signature Icon Template HTML"
                                                className="form__value"
                                                onChange={event =>
                                                    this._onFieldUpdate("eCommunication", {
                                                        ...this.state.eCommunication,
                                                        templateTwitter: event.target.value
                                                    })
                                                }
                                                style={{ minHeight: "250px" }}
                                                value={this.state.eCommunication.templateTwitter ? this.state.eCommunication.templateTwitter : ""}
                                            />
                                        </div>
                                        <div className="form__group" style={{ marginTop: "10px" }}>
                                            <label
                                                htmlFor="facebookSignature"
                                                className="form__label"
                                                style={{ display: "flex", alignItems: "center" }}
                                            >
                                                Facebook Signature Icon Template:&nbsp;
                                                <Tooltip>
                                                    The HTML to be used in text substitution for "[facebook]" as Facebook social icons in the message, <br />
                                                    typically shows up in the footer of the message. <br />
                                                    The markup should contain "[facebookLink]" for the email sender's Facebook feed URL.<br />
                                                </Tooltip>
                                            </label>
                                            <textarea
                                                id="facebookSignature"
                                                placeholder="Facebook Signature Icon Template HTML"
                                                className="form__value"
                                                onChange={event =>
                                                    this._onFieldUpdate("eCommunication", {
                                                        ...this.state.eCommunication,
                                                        templateFacebook: event.target.value
                                                    })
                                                }
                                                style={{ minHeight: "250px" }}
                                                value={this.state.eCommunication.templateFacebook ? this.state.eCommunication.templateFacebook : ""}
                                            />
                                        </div>
                                        <div className="form__group" style={{ marginTop: "10px" }}>
                                            <label
                                                htmlFor="instagramSignature"
                                                className="form__label"
                                                style={{ display: "flex", alignItems: "center" }}
                                            >
                                                Instagram Signature Icon Template:&nbsp;
                                                <Tooltip>
                                                    The HTML to be used in text substitution for "[instagram]" as Instagram social icons in the message, <br />
                                                    typically shows up in the footer of the message. <br />
                                                    The markup should contain "[instagramLink]" for the email sender's Instagram feed URL.<br />
                                                </Tooltip>
                                            </label>
                                            <textarea
                                                id="instagramSignature"
                                                placeholder="Instagram Signature Icon Template HTML"
                                                className="form__value"
                                                onChange={event =>
                                                    this._onFieldUpdate("eCommunication", {
                                                        ...this.state.eCommunication,
                                                        templateInstagram: event.target.value
                                                    })
                                                }
                                                style={{ minHeight: "250px" }}
                                                value={this.state.eCommunication.templateInstagram ? this.state.eCommunication.templateInstagram : ""}
                                            />
                                        </div>
                                    </div>
                                    <div className="form__row flex__row--center" style={{ padding: "5px 0px 0px" }}>
                                        <div className="form__row" style={{ padding: "0px 20px 5px" }}>
                                            <div className="form__group">
                                                <label className="form__label">
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px",
                                                            paddingTop: "10px"
                                                        }}
                                                    >Off/On
                                                    </span>
                                                </label>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enable Team Signature{" "}
                                                        <Tooltip>
                                                            Enable the use of team signature
                                                        </Tooltip>
                                                    </span>
                                                    <Toggle
                                                        name="messageCompliance"
                                                        value={
                                                            this.state.eCommunication && this.state.eCommunication.enableTeamSignature
                                                                ? this.state.eCommunication.enableTeamSignature
                                                                : false
                                                        }
                                                        onToggle={event =>
                                                            this._onFieldUpdate("eCommunication", {
                                                                ...this.state.eCommunication,
                                                                enableTeamSignature: !this.state.eCommunication.enableTeamSignature
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__group">
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.eCommunication && this.state.eCommunication.enableTeamSignature && (
                                        <div className="form__row flex__row--center" style={{ padding: "0px 20px" }}>
                                            <div className="form__group" style={{ marginTop: "10px" }}>
                                                <label htmlFor="teamSignature" className="form__label"
                                                    style={{ display: "flex", alignItems: "center" }}>
                                                    Team Member Signature Template:&nbsp;
                                                    <Tooltip>
                                                        The HTML to be used in text substitution for "[teamMembers]" <br />
                                                    </Tooltip>
                                                </label>
                                                <textarea
                                                    id="teamSignature"
                                                    placeholder="Team Member Signature Icon Template HTML"
                                                    className="form__value"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            templateTeamMember: event.target.value
                                                        })
                                                    }
                                                    style={{ minHeight: "250px" }}
                                                    value={this.state.eCommunication.templateTeamMember ? this.state.eCommunication.templateTeamMember : ""}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {this.state.eCommunication && this.state.eCommunication.beeEditorEnabled && (
                                <div className="eCommunicationBee" style={{ paddingTop: "15px" }}>
                                    <div className="form__row flex__row--center">
                                        <label className="form__label">BEE (Email Editor) Settings:&nbsp;
                                            <Tooltip>
                                                BEE stands for "Best Email Editor". https://beefree.io/
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div style={{ border: "1px solid #ccc" }}>
                                        <div className="form__row flex__row--center" style={{ padding: "15px 20px 0px" }}>
                                            <div className="form__group" style={{ marginTop: "10px" }}>
                                                <label htmlFor="authServiceUrl" className="form__label">Authorization Service URL:&nbsp;
                                                    <Tooltip>
                                                        Authorization Service Endpoint. Use https://auth.getbee.io/loginV2 for all BEE Editor authentication as of September 2025. The legacy endpoint is deprecated and must not be used.
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    id="authServiceUrl"
                                                    type="text"
                                                    className="form__value"
                                                    value={
                                                        this.state.eCommunication && this.state.eCommunication.beeAuthEndpoint
                                                            ? this.state.eCommunication.beeAuthEndpoint
                                                            : ""
                                                    }
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeAuthEndpoint: event.target.value
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="userId" className="form__label">User ID:&nbsp;
                                                    <Tooltip>
                                                        An alphanumeric string that identifies the user and allows the plugin to load resources for that user.<br /><br />
                                                        Requirement:<br />
                                                        <ul>
                                                            <li>Mininum 3 characters;</li>
                                                            <li>Can contain letters from a to z (uppercase or lowercase), numbers and the special characters _ (underscore) and – (dash);</li>
                                                            <li>This is a string and not a numeric value.</li>
                                                        </ul>
                                                        The User ID uniquely identifies a user of the Plugin. It means that:<br />
                                                        <ul>
                                                            <li>It will be counted as a unique user for monthly billing purposes.</li>
                                                            <li>Images (and other files) used by the user when creating and editing messages will be associated with it and not visible to other users (when using the default storage).</li>
                                                        </ul>
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    id="userId"
                                                    type="text"
                                                    className="form__value"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeUserId: event.target.value
                                                        })
                                                    }
                                                    value={
                                                        this.state.eCommunication &&
                                                            this.state.eCommunication.beeUserId
                                                            ? this.state.eCommunication.beeUserId
                                                            : ""
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px" }}>
                                            <div className="form__group">
                                                <label htmlFor="clientId" className="form__label">
                                                    Client ID:&nbsp;
                                                    <Tooltip>
                                                        Found in the Bee dev portal, under the application details.
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    id="clientId"
                                                    type="text"
                                                    className="form__value"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeClientId: event.target.value
                                                        })
                                                    }
                                                    value={
                                                        this.state.eCommunication &&
                                                            this.state.eCommunication.beeClientId
                                                            ? this.state.eCommunication.beeClientId
                                                            : ""
                                                    }
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="clientSecretKey" className="form__label">
                                                    Client Secret Key:&nbsp;
                                                    <Tooltip>
                                                        Found in the Bee dev portal, under the application details.
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    id="clientSecretKey"
                                                    type="password"
                                                    className="form__value"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeClientSecret: event.target.value
                                                        })
                                                    }
                                                    value={
                                                        this.state.eCommunication &&
                                                            this.state.eCommunication.beeClientSecret
                                                            ? this.state.eCommunication.beeClientSecret
                                                            : ""
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center" style={{ padding: "0px 20px" }}>
                                            <div className="form__group" style={{ padding: "0px", borderBottom: "solid 1px #ccc" }}>
                                                <label className="form__label" style={{ textTransform: "uppercase" }}>Default Template&nbsp;</label>
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px", paddingBottom: "20px" }}>
                                            <div className="form__group" style={{ marginTop: "10px", paddingBottom: "0px" }}>
                                                <label htmlFor="templateJsonString" className="form__label">Template JSON string:&nbsp;
                                                    <Tooltip>
                                                        The JSON string with the template structure to be loaded when creating a new message.
                                                    </Tooltip>
                                                </label>
                                                <textarea
                                                    id="templateJsonString"
                                                    placeholder='eg: {"page":{"body":{"container":{"style":...'
                                                    className="form__value"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeDefaultTemplateJson: event.target.value
                                                        })
                                                    }
                                                    style={{ minHeight: "200px" }}
                                                    value={this.state.eCommunication.beeDefaultTemplateJson ? this.state.eCommunication.beeDefaultTemplateJson : ""}
                                                />
                                            </div>
                                            <div className="form__group" style={{ paddingTop: "0px" }}>
                                                <label htmlFor="beeDefaultTemplateUrl" className="form__label" style={{ marginTop: "10px" }}>Template URL:&nbsp;
                                                    <Tooltip>
                                                        The URL contains the JSON string with the template structure to be loaded when creating a new message. <br />
                                                        This will be used if the default JSON template string above is empty.
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form__value"
                                                    autocomplete="off"
                                                    id="beeDefaultTemplateUrl"
                                                    name="beeDefaultTemplateUrl"
                                                    value={
                                                        this.state.eCommunication &&
                                                            this.state.eCommunication.beeDefaultTemplateUrl
                                                            ? this.state.eCommunication.beeDefaultTemplateUrl
                                                            : ""
                                                    }
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeDefaultTemplateUrl: event.target.value
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center" style={{ padding: "0px 20px" }}>
                                            <div className="form__group" style={{ padding: "0px", borderBottom: "solid 1px #ccc" }}>
                                                <label className="form__label" style={{ textTransform: "uppercase" }}>Custom Rows&nbsp;</label>
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px" }}>
                                            <div className="form__group" style={{ marginTop: "10px", marginBottom: "20px", paddingBottom: "0px" }}>
                                                <label htmlFor="collectionJson" className="form__label">Collection JSON:&nbsp;
                                                    <Tooltip>
                                                        The JSON string feeds to Bee Editor for the custom rows. Each row is separated by carriage return.
                                                    </Tooltip>
                                                </label>
                                                <textarea
                                                    id="collectionJson"
                                                    placeholder='eg: {"columns":[{"grid-columns":12,"modules":[{"descriptor":...'
                                                    className="form__value"
                                                    onChange={event => this.setState({ beeCustomRowsJson: event.target.value })}
                                                    style={{ minHeight: "150px" }}
                                                    value={this.state.beeCustomRowsJson}
                                                />
                                            </div>
                                            <div className="form__group" style={{ paddingTop: "10px" }}>
                                                <label htmlFor="beeCustomRowsDropdownTitle" className="form__label">
                                                    Dropdown Group Label:&nbsp;
                                                    <Tooltip>
                                                        the text displayed in the Rows drop-down. eg: Saved Rows
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form__value"
                                                    autocomplete="off"
                                                    id="beeCustomRowsDropdownTitle"
                                                    name="beeCustomRowsDropdownTitle"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeCustomRowsDropdownTitle: event.target.value
                                                        })
                                                    }
                                                    value={
                                                        this.state.eCommunication &&
                                                            this.state.eCommunication.beeCustomRowsDropdownTitle
                                                            ? this.state.eCommunication.beeCustomRowsDropdownTitle
                                                            : ""
                                                    }
                                                />
                                                <label htmlFor="beeCustomRowsDomain" className="form__label" style={{ paddingTop: "10px" }}>
                                                    Dropdown Group JSON Object Domain:&nbsp;
                                                    <Tooltip>
                                                        Domain to the URL that will be called by the editor when the user selects the corresponding name in the drop-down. <br />
                                                        This usually is the full qualify domain for the application.
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form__value"
                                                    autocomplete="off"
                                                    id="beeCustomRowsDomain"
                                                    name="beeCustomRowsDomain"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeCustomRowsDomain: event.target.value
                                                        })
                                                    }
                                                    value={
                                                        this.state.eCommunication &&
                                                            this.state.eCommunication.beeCustomRowsDomain
                                                            ? this.state.eCommunication.beeCustomRowsDomain
                                                            : ""
                                                    }
                                                />
                                                <label htmlFor="beeCustomRowsUrlOverride" className="form__label" style={{ paddingTop: "10px" }}>
                                                    Dropdown Group JSON Object URL override:&nbsp;
                                                    <Tooltip>
                                                        The static URL contains the JSON object of the custom rows. This will get used to override the URL generated dynamically based on cid. <br />
                                                        Leave it blank if no override is required.
                                                    </Tooltip>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form__value"
                                                    id="beeCustomRowsUrlOverride"
                                                    name="beeCustomRowsUrlOverride"
                                                    autocomplete="off"
                                                    value={
                                                        this.state.eCommunication &&
                                                            this.state.eCommunication.beeCustomRowsUrlOverride
                                                            ? this.state.eCommunication.beeCustomRowsUrlOverride
                                                            : ""
                                                    }
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeCustomRowsUrlOverride: event.target.value
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center" style={{ padding: "0px 20px" }}>
                                            <div className="form__group" style={{ padding: "0px", borderBottom: "solid 1px #ccc" }}>
                                                <label className="form__label" style={{ textTransform: "uppercase" }}>Font Management&nbsp;</label>
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px" }}>
                                            <div className="form__group" style={{ marginTop: "10px", marginBottom: "20px", paddingBottom: "0px" }}>
                                                <label htmlFor="editorFontsJson" className="form__label">Editor Fonts JSON:&nbsp;
                                                    <Tooltip>
                                                        Font Management can customize the list of fonts available in the editor’s text toolbar and the BODY settings panel. - https://docs.beefree.io/font-management/
                                                    </Tooltip>
                                                </label>
                                                <textarea
                                                    id="editorFontsJson"
                                                    placeholder='eg: {"showDefaultFonts": true,"customFonts": [{name: "...",fontFamily: "...",url: "https://..."}]}'
                                                    className="form__value"
                                                    onChange={event =>
                                                        this._onFieldUpdate("eCommunication", {
                                                            ...this.state.eCommunication,
                                                            beeEditorFonts: event.target.value
                                                        })
                                                    }
                                                    style={{ minHeight: "200px" }}
                                                    value={this.state.eCommunication.beeEditorFonts}
                                                />
                                            </div>
                                            <div className="form__group" style={{ paddingTop: "10px" }}>&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="eCommunicationProfile" style={{ paddingTop: "15px" }}>
                                <div className="form__row flex__row--center">
                                    <label className="form__label">Profile Settings:</label>
                                </div>
                                <div style={{ border: "1px solid #ccc" }}>
                                    <div className="form__row flex__row--center" style={{ padding: "0px 20px" }}>
                                        <div className="form__group" style={{ marginTop: "10px" }}>
                                            <label htmlFor="transformationMapping" className="form__label"
                                                style={{ display: "flex", alignItems: "center" }}>
                                                Profile Data Transformation Mapping:&nbsp;
                                                <Tooltip>
                                                    The JSON document use to apply to transform profile data from client to LiveSocial e-Communication profile.
                                                </Tooltip>
                                            </label>
                                            <textarea
                                                id="transformationMapping"
                                                placeholder='{
                                                    list: "profiles",
                                                    item: {
                                                        branchNumber: "branchNumber",
                                                        ...
                                                    },
                                                    each(item) {
                                                        item.linkedinShow = item.linkedinLink && item.linkedinLink.length > 0;
                                                        ...
                                                        return item;
                                                    }'
                                                className="form__value"
                                                onChange={event => this._onFieldUpdate("eCommunication", { ...this.state.eCommunication, profileDataTransformMap: event.target.value })}
                                                style={{ minHeight: "450px" }}
                                                value={this.state.eCommunication.profileDataTransformMap ? this.state.eCommunication.profileDataTransformMap : ""}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form__row" style={{ paddingTop: "15px" }}>
                                <div className="form__group form__group--full">
                                    <label className="form__label">
                                        Email Archive Settings:
                                        <span
                                            style={{
                                                float: "right",
                                                marginRight: "15px"
                                            }}
                                        >
                                            Off/On
                                        </span>
                                    </label>
                                    <PermissionSet
                                        permissions={this._getEmailArchiveSettings()}
                                        _onChange={event => this._onFieldUpdate("eCommunication", { ...this.state.eCommunication, enabledArchive: !this.state.eCommunication.enabledArchive })}
                                        setNumber={"24"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ]
            }
        };
    }
    _getEmailArchiveSettings() {
        return {
            enabledArchive: {
                label: "Enable Email Archive",
                value: this.state.eCommunication.enabledArchive || false,
                description: "Enables client to enable the email archive",
                dropdown: [
                    <div className="flex__row--center">
                        <div className="flex__column--center">
                            <div className="form__row">
                                <div className="form__group form__group--full">
                                    <label htmlFor="inboxEmail" className="form__label">Inbox Email Address:</label>
                                    <input
                                        id="inboxEmail"
                                        type="text"
                                        className="form__value"
                                        onChange={event =>
                                            this._onFieldUpdate("eCommunication.archiveSettings", {
                                                ...this.state.eCommunication.archiveSettings,
                                                inboxEmail: event.target.value
                                            })
                                        }
                                        value={
                                            this.state.eCommunication.archiveSettings &&
                                                this.state.eCommunication.archiveSettings.inboxEmail
                                                ? this.state.eCommunication.archiveSettings.inboxEmail
                                                : ""
                                        }
                                    />

                                    <div style={{ width: "100%", marginTop: "20px" }}>
                                        <label className="form__label">Custom Headers:&nbsp;
                                            <Tooltip>
                                                X-Headers to the archive email can be set here. Any static value can be set directly onto the value field.<br />
                                                Dynamic values such as information for sender and email, please place the constant keys listed below into the value field.
                                                <br /><br />
                                                The following are constant keys for archiving email specific value substitution:
                                                <br />
                                                [Sender] : Name of the email sender
                                                <br />
                                                [SenderEmail] : Email address of the email sender
                                                <br />
                                                [BranchNumber] : Branch number of the advisor
                                                <br />
                                                [ComplianceCode] : Compliance code of the sent email
                                                <br />
                                                [Recipient] : Name of the email recipient
                                                <br />
                                                [RecipientEmail] : Email address of the email recipient
                                                <br />
                                                [DateTimeSent] : Date and time of the email sent in yyyy-mm-dd HH:MM:ss format
                                                <br />
                                                [SenderGroup] : Group name of the email sender
                                                <br />
                                                [SenderRole] : Role name of the email sender
                                            </Tooltip>
                                        </label>
                                        <ul className="form__value form__value--centered">
                                            {this.state.eCommunication && this.state.eCommunication.archiveSettings
                                                && this.state.eCommunication.archiveSettings.customHeaders
                                                && this.state.eCommunication.archiveSettings.customHeaders.map(
                                                    function (header, index) {
                                                        return (
                                                            <li key={header}>
                                                                <input
                                                                    type="text"
                                                                    value={header ? header.key : ""}
                                                                    disabled={true}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    value={header ? header.val : ""}
                                                                    disabled={true}
                                                                />
                                                                <Button
                                                                    onClick={event =>
                                                                        this._removeCustomHeader(event, header)
                                                                    }
                                                                >
                                                                    Remove
                                                                </Button>
                                                            </li>
                                                        );
                                                    }.bind(this)
                                                )}
                                            <li>
                                                <input
                                                    type="text"
                                                    ref={input => {
                                                        this.keyInput = input;
                                                    }}
                                                    onChange={event => this.setState({ addKey: event.target.value })}
                                                    placeholder="Custom Header Key"
                                                />
                                                <input
                                                    type="text"
                                                    ref={input => {
                                                        this.valInput = input;
                                                    }}
                                                    onChange={event => this.setState({ addVal: event.target.value })}
                                                    placeholder="Custom Header Value"
                                                />
                                                <Button
                                                    onClick={event =>
                                                        this._onCustomHeaderChange(
                                                            this.keyInput.value,
                                                            this.valInput.value,
                                                            0
                                                        )
                                                    }
                                                    disabled={
                                                        !this.state.addKey ||
                                                        !this.state.addVal ||
                                                        !this.state.addKey.length ||
                                                        !this.state.addVal.length
                                                    }
                                                >
                                                    Add
                                                </Button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ]
            }
        };
    }
    async _addArticleMediaTemplate(cid, allowECommunication) {
        if (allowECommunication) {
            doGetECommunicationMessages(
                cid,
                "article"
            ).then(data => {
                if (data && data.count == 0) {
                    // let's add a article template with default values
                    let postObj = {
                        cid,
                        Title: "Mailing List Template",
                        Subject: "I thought you’d be interested in this",
                        Content: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
                        <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

                        <head>
                            <!--[if gte mso 9]><xml><o:OfficeDocumentSettings><o:AllowPNG/><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
                            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                            <meta name="viewport" content="width=device-width">
                            <!--[if !mso]><!-->
                            <meta http-equiv="X-UA-Compatible" content="IE=edge">
                            <!--<![endif]-->
                            <title></title>
                            <!--[if !mso]><!-->
                            <!--<![endif]-->
                            <style type="text/css">
                                body {
                                    margin: 0;
                                    padding: 0;
                                }

                                table,
                                td,
                                tr {
                                    vertical-align: top;
                                    border-collapse: collapse;
                                }

                                * {
                                    line-height: inherit;
                                }

                                a[x-apple-data-detectors=true] {
                                    color: inherit !important;
                                    text-decoration: none !important;
                                }
                            </style>
                            <style type="text/css" id="media-query">
                                @media (max-width: 660px) {

                                    .block-grid,
                                    .col {
                                        min-width: 320px !important;
                                        max-width: 100% !important;
                                        display: block !important;
                                    }

                                    .block-grid {
                                        width: 100% !important;
                                    }

                                    .col {
                                        width: 100% !important;
                                    }

                                    .col>div {
                                        margin: 0 auto;
                                    }

                                    img.fullwidth,
                                    img.fullwidthOnMobile {
                                        max-width: 100% !important;
                                    }

                                    .no-stack .col {
                                        min-width: 0 !important;
                                        display: table-cell !important;
                                    }

                                    .no-stack.two-up .col {
                                        width: 50% !important;
                                    }

                                    .no-stack .col.num4 {
                                        width: 33% !important;
                                    }

                                    .no-stack .col.num8 {
                                        width: 66% !important;
                                    }

                                    .no-stack .col.num4 {
                                        width: 33% !important;
                                    }

                                    .no-stack .col.num3 {
                                        width: 25% !important;
                                    }

                                    .no-stack .col.num6 {
                                        width: 50% !important;
                                    }

                                    .no-stack .col.num9 {
                                        width: 75% !important;
                                    }

                                    .video-block {
                                        max-width: none !important;
                                    }

                                    .mobile_hide {
                                        min-height: 0px;
                                        max-height: 0px;
                                        max-width: 0px;
                                        display: none;
                                        overflow: hidden;
                                        font-size: 0px;
                                    }

                                    .desktop_hide {
                                        display: block !important;
                                        max-height: none !important;
                                    }
                                }
                            </style>
                        </head>

                        <body class="clean-body" style="margin: 0; padding: 0; -webkit-text-size-adjust: 100%; background-color: #FFFFFF;">
                            <!--[if IE]><div class="ie-browser"><![endif]-->
                            <table class="nl-container" style="table-layout: fixed; vertical-align: top; min-width: 320px; Margin: 0 auto; border-spacing: 0; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #FFFFFF; width: 100%;" cellpadding="0" cellspacing="0" role="presentation" width="100%" bgcolor="#FFFFFF" valign="top">
                                <tbody>
                                    <tr style="vertical-align: top;" valign="top">
                                        <td style="word-break: break-word; vertical-align: top;" valign="top">
                                            <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color:#FFFFFF"><![endif]-->
                                            <div style="background-color:#ffffff;">
                                                <div class="block-grid " style="Margin: 0 auto; min-width: 320px; max-width: 640px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: #ffffff;">
                                                    <div style="border-collapse: collapse;display: table;width: 100%;background-color:#ffffff;">
                                                        <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#ffffff;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:640px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                                                        <!--[if (mso)|(IE)]><td align="center" width="640" style="background-color:#ffffff;width:640px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:0px; padding-bottom:0px;"><![endif]-->
                                                        <div class="col num12" style="min-width: 320px; max-width: 640px; display: table-cell; vertical-align: top; width: 640px;">
                                                            <div style="width:100% !important;">
                                                                <!--[if (!mso)&(!IE)]><!-->
                                                                <div style="border-top:0px solid transparent; border-left:0px solid transparent; border-bottom:0px solid transparent; border-right:0px solid transparent; padding-top:0px; padding-bottom:0px; padding-right: 0px; padding-left: 0px;">
                                                                    <!--<![endif]-->
                                                                    <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Arial, sans-serif"><![endif]-->
                                                                    <div style="color:#555555;font-family:Arial, Helvetica Neue, Helvetica, sans-serif;line-height:1.2;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;">
                                                                        <div style="font-size: 14px; line-height: 1.2; color: #555555; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 17px;">
                                                                            <p style="font-size: 14px; line-height: 1.2; word-break: break-word; mso-line-height-alt: 17px; margin: 0;">[contentComment]<br>[contentTitle]</p>
                                                                            <p style="font-size: 14px; line-height: 1.2; word-break: break-word; mso-line-height-alt: 17px; margin: 0;">[contentURL]</p>
                                                                            <p style="font-size: 14px; line-height: 1.2; word-break: break-word; mso-line-height-alt: 17px; margin: 0;">[contentImage]</p>
                                                                        </div>
                                                                    </div>
                                                                    <!--[if mso]></td></tr></table><![endif]-->
                                                                    <!--[if (!mso)&(!IE)]><!-->
                                                                </div>
                                                                <!--<![endif]-->
                                                            </div>
                                                        </div>
                                                        <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                                                        <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="background-color:#ffffff;">
                                                <div class="block-grid " style="Margin: 0 auto; min-width: 320px; max-width: 640px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: #ffffff;">
                                                    <div style="border-collapse: collapse;display: table;width: 100%;background-color:#ffffff;">
                                                        <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#ffffff;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:640px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                                                        <!--[if (mso)|(IE)]><td align="center" width="640" style="background-color:#ffffff;width:640px; border-top: none; border-left: 0px solid transparent; border-bottom: none; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr bgcolor='#F9F9F9'><td colspan='1' style='font-size:7px;line-height:15px'>&nbsp;</td></tr><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                                                        <div class="col num12" style="min-width: 320px; max-width: 640px; display: table-cell; vertical-align: top; width: 640px;">
                                                            <div style="width:100% !important;">
                                                                <!--[if (!mso)&(!IE)]><!-->
                                                                <div style="border-top:15px solid #F9F9F9; border-left:0px solid transparent; border-bottom:15px solid #F9F9F9; border-right:0px solid transparent; padding-top:5px; padding-bottom:5px; padding-right: 0px; padding-left: 0px;">
                                                                    <!--<![endif]-->
                                                                    <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Arial, sans-serif"><![endif]-->
                                                                    <div style="color:#555555;font-family:Arial, Helvetica Neue, Helvetica, sans-serif;line-height:1.2;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;">
                                                                        <div style="font-size: 14px; line-height: 1.2; color: #555555; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 17px;">
                                                                            <p style="font-size: 14px; line-height: 1.2; word-break: break-word; mso-line-height-alt: 17px; margin: 0;">[preferredName]<br>[jobTitle]</p>
                                                                        </div>
                                                                    </div>
                                                                    <!--[if mso]></td></tr></table><![endif]-->
                                                                    <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Arial, sans-serif"><![endif]-->
                                                                    <div style="color:#555555;font-family:Arial, Helvetica Neue, Helvetica, sans-serif;line-height:1.2;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;">
                                                                        <div style="line-height: 1.2; font-size: 12px; color: #555555; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 14px;">
                                                                            <p style="line-height: 1.2; word-break: break-word; mso-line-height-alt: 14px; margin: 0;">[phone]</p>
                                                                            <p style="line-height: 1.2; word-break: break-word; mso-line-height-alt: 14px; margin: 0;">&nbsp;</p>
                                                                            <p style="line-height: 1.2; word-break: break-word; mso-line-height-alt: 14px; margin: 0;">[address]</p>
                                                                        </div>
                                                                    </div>
                                                                    <!--[if mso]></td></tr></table><![endif]-->
                                                                    <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Arial, sans-serif"><![endif]-->
                                                                    <div style="color:#555555;font-family:Arial, Helvetica Neue, Helvetica, sans-serif;line-height:1.2;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;">
                                                                        <div style="font-size: 14px; line-height: 1.2; color: #555555; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; mso-line-height-alt: 17px;">
                                                                            <p style="font-size: 14px; line-height: 1.2; word-break: break-word; mso-line-height-alt: 17px; margin: 0;">[linkedin] [twitter] [facebook]</p>
                                                                        </div>
                                                                    </div>
                                                                    <!--[if mso]></td></tr></table><![endif]-->
                                                                    <!--[if (!mso)&(!IE)]><!-->
                                                                </div>
                                                                <!--<![endif]-->
                                                            </div>
                                                        </div>
                                                        <!--[if (mso)|(IE)]></td></tr><tr bgcolor='#F9F9F9'><td colspan='1' style='font-size:7px;line-height:15px'>&nbsp;</td></tr></table><![endif]-->
                                                        <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="background-color:#ffffff;">
                                                <div class="block-grid " style="Margin: 0 auto; min-width: 320px; max-width: 640px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: #002949;">
                                                    <div style="border-collapse: collapse;display: table;width: 100%;background-color:#002949;">
                                                        <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#ffffff;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:640px"><tr class="layout-full-width" style="background-color:#002949"><![endif]-->
                                                        <!--[if (mso)|(IE)]><td align="center" width="640" style="background-color:#002949;width:640px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 1px solid #494949; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:0px; padding-bottom:0px;"><![endif]-->
                                                        <div class="col num12" style="min-width: 320px; max-width: 640px; display: table-cell; vertical-align: top; width: 640px;">
                                                            <div style="width:100% !important;">
                                                                <!--[if (!mso)&(!IE)]><!-->
                                                                <div style="border-top:0px solid transparent; border-left:0px solid transparent; border-bottom:1px solid #494949; border-right:0px solid transparent; padding-top:0px; padding-bottom:0px; padding-right: 0px; padding-left: 0px;">
                                                                    <!--<![endif]-->
                                                                    <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 30px; padding-left: 30px; padding-top: 30px; padding-bottom: 30px; font-family: Tahoma, Verdana, sans-serif"><![endif]-->
                                                                    <div style="color:#ffffff;font-family:'Lato', Tahoma, Verdana, Segoe, sans-serif;line-height:1.5;padding-top:30px;padding-right:30px;padding-bottom:30px;padding-left:30px;">
                                                                        <div style="line-height: 1.5; font-size: 12px; color: #ffffff; font-family: 'Lato', Tahoma, Verdana, Segoe, sans-serif; mso-line-height-alt: 18px;">
                                                                            <p style="line-height: 1.5; word-break: break-word; mso-line-height-alt: 18px; margin: 0;">[disclosure]</p>
                                                                        </div>
                                                                    </div>
                                                                    <!--[if mso]></td></tr></table><![endif]-->
                                                                    <!--[if (!mso)&(!IE)]><!-->
                                                                </div>
                                                                <!--<![endif]-->
                                                            </div>
                                                        </div>
                                                        <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                                                        <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="background-color:#ffffff;">
                                                <div class="block-grid " style="Margin: 0 auto; min-width: 320px; max-width: 640px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: #002949;">
                                                    <div style="border-collapse: collapse;display: table;width: 100%;background-color:#002949;">
                                                        <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#ffffff;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:640px"><tr class="layout-full-width" style="background-color:#002949"><![endif]-->
                                                        <!--[if (mso)|(IE)]><td align="center" width="640" style="background-color:#002949;width:640px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 1px solid #494949; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 15px; padding-left: 15px; padding-top:15px; padding-bottom:15px;"><![endif]-->
                                                        <div class="col num12" style="min-width: 320px; max-width: 640px; display: table-cell; vertical-align: top; width: 640px;">
                                                            <div style="width:100% !important;">
                                                                <!--[if (!mso)&(!IE)]><!-->
                                                                <div style="border-top:0px solid transparent; border-left:0px solid transparent; border-bottom:1px solid #494949; border-right:0px solid transparent; padding-top:15px; padding-bottom:15px; padding-right: 15px; padding-left: 15px;">
                                                                    <!--<![endif]-->
                                                                    <div style="font-size:16px;text-align:center;font-family:Arial, Helvetica Neue, Helvetica, sans-serif">
                                                                        <p style="color:#ffffff; font-size:12px;">Click here to
                                                                            <a href="{unsubscribe_url}" target="_blank">Unsubscribe</a>
                                                                            from this email communication
                                                                        </p>
                                                                    </div>
                                                                    <!--[if (!mso)&(!IE)]><!-->
                                                                </div>
                                                                <!--<![endif]-->
                                                            </div>
                                                        </div>
                                                        <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                                                        <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                                                    </div>
                                                </div>
                                            </div>
                                            <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!--[if (IE)]></div><![endif]-->
                        </body>

                        </html>`,
                        beeEditorContentJson: `{"page":{"body":{"container":{"style":{"background-color":"#FFFFFF"}},"content":{"computedStyle":{"linkColor":"#0068A5","messageBackgroundColor":"transparent","messageWidth":"640px"},"style":{"color":"#000000","font-family":"Arial, Helvetica Neue, Helvetica, sans-serif"}},"type":"mailup-bee-page-properties","webFonts":[]},"description":"","rows":[{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px"},"text":{"computedStyle":{"linkColor":"#0068A5"},"html":"<div class='txtTinyMce-wrapper' style='font-size: 14px; line-height: 16px;' data-mce-style='font-size: 14px; line-height: 16px;'><p style='font-size: 14px; line-height: 16px; word-break: break-word;' data-mce-style='font-size: 14px; line-height: 16px; word-break: break-word;'>[contentComment]<br>[contentTitle]</p><p style='font-size: 14px; line-height: 16px; word-break: break-word;' data-mce-style='font-size: 14px; line-height: 16px; word-break: break-word;'>[contentURL]</p><p style='font-size: 14px; line-height: 16px; word-break: break-word;' data-mce-style='font-size: 14px; line-height: 16px; word-break: break-word;'>[contentImage]</p></div>","style":{"color":"#555555","font-family":"inherit","line-height":"120%"}}},"locked":false,"type":"mailup-bee-newsletter-modules-text"}],"style":{"background-color":"transparent","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"0px","padding-left":"0px","padding-right":"0px","padding-top":"0px"}}],"container":{"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true},"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat","color":"#000000","width":"640px"}},"locked":false,"metadata":{"category":"My Saved Rows","dateCreated":"2020-02-03T19:36:20.396895Z","dateModified":"2020-02-03T19:36:21.877241Z","description":"Test Description","idParent":null,"name":"RJ Header","slug":"rj-header","uuid":"a852768b-e7ca-40e5-8715-630a4bab92d5"},"type":"row-1-columns-12"},{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px"},"text":{"computedStyle":{"linkColor":"#0068A5"},"html":"<div class='txtTinyMce-wrapper' style='font-size: 14px; line-height: 16px;' data-mce-style='font-size: 14px; line-height: 16px;'><p style='font-size: 14px; line-height: 16px; word-break: break-word;' data-mce-style='font-size: 14px; line-height: 16px; word-break: break-word;'>[preferredName]<br>[jobTitle]</p></div>","style":{"color":"#555555","font-family":"inherit","line-height":"120%"}}},"locked":false,"type":"mailup-bee-newsletter-modules-text"},{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px"},"text":{"computedStyle":{"linkColor":"#0068A5"},"html":"<div class='txtTinyMce-wrapper' style='line-height: 14px; font-size: 12px;' data-mce-style='line-height: 14px; font-size: 12px;'><p style='line-height: 14px; word-break: break-word;' data-mce-style='line-height: 14px; word-break: break-word;'>[phone]</p><p style='line-height: 14px; word-break: break-word;' data-mce-style='line-height: 14px; word-break: break-word;'> </p><p style='line-height: 14px; word-break: break-word;' data-mce-style='line-height: 14px; word-break: break-word;'>[address]</p></div>","style":{"color":"#555555","font-family":"inherit","line-height":"120%"}}},"locked":false,"type":"mailup-bee-newsletter-modules-text"},{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px"},"text":{"computedStyle":{"linkColor":"#0068A5"},"html":"<div class='txtTinyMce-wrapper' style='font-size: 14px; line-height: 16px;' data-mce-style='font-size: 14px; line-height: 16px;'><p style='font-size: 14px; line-height: 16px; word-break: break-word;' data-mce-style='font-size: 14px; line-height: 16px; word-break: break-word;'>[linkedin] [twitter] [facebook]</p></div>","style":{"color":"#555555","font-family":"inherit","line-height":"120%"}}},"locked":false,"type":"mailup-bee-newsletter-modules-text"}],"style":{"background-color":"transparent","border-bottom":"15px solid #F9F9F9","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"15px solid #F9F9F9","padding-bottom":"5px","padding-left":"0px","padding-right":"0px","padding-top":"5px"}}],"container":{"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true},"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat","color":"#000000","width":"500px"}},"locked":false,"metadata":{"category":"My Saved Rows","dateCreated":"2020-02-03T20:45:00.981413Z","dateModified":"2020-02-04T18:49:02.090513Z","description":"Test Description","idParent":null,"name":"RJ Signature","slug":"rj-signature","uuid":"e8a58dca-0dee-4127-8415-6b6dec8b7f67"},"type":"row-1-columns-12"},{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"style":{"padding-bottom":"30px","padding-left":"30px","padding-right":"30px","padding-top":"30px"},"text":{"computedStyle":{"linkColor":"#111"},"html":"<div class='txtTinyMce-wrapper' style='line-height: 18px; font-size: 12px;' data-mce-style='line-height: 18px; font-size: 12px;'><p style='line-height: 18px; word-break: break-word;' data-mce-style='line-height: 18px; word-break: break-word;'>[disclosure]</p></div>","style":{"color":"#ffffff","font-family":"'Lato', Tahoma, Verdana, Segoe, sans-serif","line-height":"150%"}}},"locked":false,"type":"mailup-bee-newsletter-modules-text"}],"style":{"background-color":"transparent","border-bottom":"1px solid #494949","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"0px","padding-left":"0px","padding-right":"0px","padding-top":"0px"}}],"container":{"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true},"style":{"background-color":"#002949","background-image":"none","background-position":"top left","background-repeat":"no-repeat","color":"#000000","width":"640px"}},"locked":false,"metadata":{"category":"My Saved Rows","dateCreated":"2020-02-03T19:36:54.193908Z","dateModified":"2020-02-04T18:48:57.785731Z","description":"Test Description","idParent":null,"name":"RJ Disclosure","slug":"rj-disclosure","uuid":"1669fa2c-a25e-47ce-9eb7-3bf0c22f9084"},"type":"row-1-columns-12"},{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"html":{"html":"<p style='color:#ffffff; font-size:12px;'>Click here to <a href='{unsubscribe_url}' target='_blank'>Unsubscribe</a> from this email communication</p>"},"style":{"padding-bottom":"0px","padding-left":"0px","padding-right":"0px","padding-top":"0px"}},"locked":false,"type":"mailup-bee-newsletter-modules-html"}],"style":{"background-color":"transparent","border-bottom":"1px solid #494949","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"15px","padding-left":"15px","padding-right":"15px","padding-top":"15px"}}],"container":{"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true},"style":{"background-color":"#002949","background-image":"none","background-position":"top left","background-repeat":"no-repeat","color":"#000000","width":"640px"}},"locked":false,"metadata":{"category":"My Saved Rows","dateCreated":"2020-02-04T19:33:02.702443Z","dateModified":"2020-02-04T20:58:05.336768Z","description":"Test Description","idParent":null,"name":"RJ Unsubscribe","slug":"rj-unsubscribe","uuid":"95256140-f64a-42eb-8066-a5e953b50cab"},"type":"row-1-columns-12"}],"template":{"name":"template-base","type":"basic","version":"2.0.0"},"title":""}}`,
                        status: "active",
                        type: "article"
                    };
                    var formData = new FormData();
                    Object.keys(postObj).forEach(function (key) {
                        formData.append(key, postObj[key]);
                    });
                    doUpsertECommunicationMessage(formData, true);
                }
            })
        }
    }
    _getEmailNotificationSettings() {
        const { systemEmails } = this.state;
        const {
            recommendNotify,
            achievementsNotify,
            welcomeNotify,
            readNotify,
            queueNotify,
            readPushNotify,
            queuePushNotify,
            firstCardPushNotify,
            errorPostingNotify,
            reportNotify,
            tokenErrorNotify,
        } = systemEmails;
        const options = [
            { value: "-1", label: "Disabled" },
            { value: "0", label: "Default to Off" },
            { value: "1", label: "Default to On" }
        ];
        const disabled = { disabled: !(this.props.user.isSuper || this.props.user.isSuperClientAdmin) };
        const permissions = [
            {
                recommendNotify: {
                    label: "Recommend Notification",
                    // description: "",
                    ...disabled,
                    value: recommendNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, recommendNotify: Number(value) } }),
                },
                achievementsNotify: {
                    label: "Achievements Notification",
                    // description: "",
                    ...disabled,
                    value: achievementsNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, achievementsNotify: Number(value) } }),
                },
                welcomeNotify: {
                    label: "Welcome Notification",
                    // description: "",
                    ...disabled,
                    value: welcomeNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, welcomeNotify: Number(value) } }),
                },
                readNotify: {
                    label: "Read Notification",
                    // description: "",
                    ...disabled,
                    value: readNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, readNotify: Number(value) } }),
                },
                queueNotify: {
                    label: "Queue Notification",
                    // description: "",
                    ...disabled,
                    value: queueNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, queueNotify: Number(value) } }),
                },
                readPushNotify: {
                    label: "Read Push Notification",
                    // description: "",
                    ...disabled,
                    value: readPushNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, readPushNotify: Number(value) } }),
                },
            },
            {
                queuePushNotify: {
                    label: "Queue Push Notification",
                    // description: "",
                    ...disabled,
                    value: queuePushNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, queuePushNotify: Number(value) } }),
                },
                firstCardPushNotify: {
                    label: "First Card Push Notification",
                    // description: "",
                    ...disabled,
                    value: firstCardPushNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, firstCardPushNotify: Number(value) } }),
                },
                errorPostingNotify: {
                    label: "Error Posting Notification",
                    // description: "",
                    ...disabled,
                    value: errorPostingNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, errorPostingNotify: Number(value) } }),
                },
                reportNotify: {
                    label: "Report Notification",
                    // description: "",
                    ...disabled,
                    value: reportNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, reportNotify: Number(value) } }),
                },
                tokenErrorNotify: {
                    label: "Token Error Notification",
                    // description: "",
                    ...disabled,
                    value: tokenErrorNotify.toString(),
                    type: "select",
                    values: options,
                    onChange: value => this.setState({ systemEmails: { ...systemEmails, tokenErrorNotify: Number(value) } }),
                }
            }
        ];
        return permissions;
    }
    _getConfigSettings() {
        let { configSettings, uploadedLogoURL, uploadedWeeklyEmailURL } = this.state;
        if (!configSettings) {
            configSettings = {};
        }
        return {
            allowCustomEmailConfig: {
                label: "Custom Email Data",
                value: this.state.allowCustomEmailConfig,
                description: "Allow client to set custom email data",
                dropdown: [
                    <div className="form__row">
                        <div className="form__group">
                            <label className="form__label">
                                Logo:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    The logo that will be used for all system generated emails, except the Weekly and Article Read emails. Must be a .png file that is 600px by 40px
                                </Tooltip>
                                <ArticleFileUpload
                                    uploadLinkStyle={{ color: "#152733", float: "right", fontWeight: "normal" }}
                                    title="Upload Image"
                                    onValidUpload={entries => {
                                        const { uploadedFile, fileUpload } = entries;
                                        if (fileUpload && fileUpload.length > 1) {
                                            fileUpload.splice(0, 1);
                                        }
                                        const imgUrl = fileUpload ? fileUpload[0].name : "";
                                        this.setState({
                                            uploadedFileLogo: uploadedFile,
                                            fileUploadLogo: fileUpload,
                                            uploadedLogoURL: imgUrl
                                        });
                                    }}
                                    singleImageOnly={true}
                                />
                            </label>
                            {this._getInputLogoDetails()}
                        </div>
                        <div className="form__group">
                            <label className="form__label">
                                Weekly Email Logo:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    The logo that will be used for the Weekly and Article Read emails. Must be a .png file that is 220px by 22px. We recommend that the logo be left aligned.
                                </Tooltip>
                                <ArticleFileUpload
                                    id={"imageUploadWeekly"}
                                    uploadLinkStyle={{ color: "#152733", float: "right", fontWeight: "normal" }}
                                    title="Upload Image"
                                    onValidUpload={entries => {
                                        const { uploadedFile, fileUpload } = entries;
                                        if (fileUpload && fileUpload.length > 1) {
                                            fileUpload.splice(0, 1);
                                        }
                                        const imgWeeklyUrl = fileUpload ? fileUpload[0].name : "";
                                        this.setState({
                                            uploadedFileWeeklyEmailLogo: uploadedFile,
                                            fileUploadWeeklyEmailLogo: fileUpload,
                                            uploadedWeeklyEmailURL: imgWeeklyUrl
                                        });

                                    }}
                                    singleImageOnly={true}
                                />
                            </label>
                            {this._getInputWeeklyLogoDetails()}
                        </div>
                        <div className="form__group">
                            <label htmlFor="companyAddress" className="form__label">Company Address:</label>
                            <input
                                id="companyAddress"
                                type="text"
                                className="form__value"
                                placeholder="LiveSocial, 26 Duncan St, Toronto, ON, M5V 2B9"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.companyAddress
                                        ? configSettings.customEmail.companyAddress
                                        : ""
                                }
                                onChange={event =>
                                    this._onFieldUpdate("configSettings.customEmail.companyAddress", event)
                                }
                            />
                        </div>
                    </div>,
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="linkedinHandle" className="form__label">
                                LinkedIn Handle:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This is used to redirect users to the appropriate social network page. This is
                                    appended with the footer.
                                </Tooltip>
                            </label>
                            <input
                                id="linkedinHandle"
                                type="text"
                                className="form__value"
                                placeholder="eg. https://www.linkedin.com/company/grapevine6"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.LIHandle
                                        ? configSettings.customEmail.LIHandle
                                        : ""
                                }
                                onChange={event => this._onFieldUpdate("configSettings.customEmail.LIHandle", event)}
                            />
                        </div>
                        <div className="form__group">
                            <label htmlFor="twitterHandle" className="form__label">
                                Twitter Handle:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This is used to redirect users to the appropriate social network page. This is
                                    appended with the footer.
                                </Tooltip>
                            </label>
                            <input
                                id="twitterHandle"
                                type="text"
                                className="form__value"
                                placeholder="eg. https://twitter.com/Grapevine_6"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.TWHandle
                                        ? configSettings.customEmail.TWHandle
                                        : ""
                                }
                                onChange={event => this._onFieldUpdate("configSettings.customEmail.TWHandle", event)}
                            />
                        </div>
                        <div className="form__group">
                            <label htmlFor="facebookHandle" className="form__label">
                                Facebook Handle:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This is used to redirect users to the appropriate social network page. This is
                                    appended with the footer.
                                </Tooltip>
                            </label>
                            <input
                                id="facebookHandle"
                                type="text"
                                className="form__value"
                                placeholder="eg. https://www.facebook.com/grapevine6"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.FBHandle
                                        ? configSettings.customEmail.FBHandle
                                        : ""
                                }
                                onChange={event => this._onFieldUpdate("configSettings.customEmail.FBHandle", event)}
                            />
                        </div>
                    </div>,
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="primaryColor" className="form__label">
                                Primary Color:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This field is for a specific color. Please use hex code for these fields. e.g. #57308a
                                </Tooltip>
                            </label>
                            <input
                                id="primaryColor"
                                type="text"
                                className="form__value"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.primaryColor
                                        ? configSettings.customEmail.primaryColor
                                        : ""
                                }
                                onChange={event => {
                                    if (event.target.value.charAt(0) != "#") {
                                        createAlert("Please use hex code for these fields. Colour must start with a '#' e.g. #57308a ", `error`);
                                        return;
                                    } else {
                                        this._onFieldUpdate("configSettings.customEmail.primaryColor", event)
                                    }
                                }}
                            />
                        </div>
                        <div className="form__group">
                            <label htmlFor="secondaryColor" className="form__label">
                                Secondary Color:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This field is for a specific color. Please use hex code for these fields. e.g. #57308a
                                </Tooltip>
                            </label>
                            <input
                                id="secondaryColor"
                                type="text"
                                className="form__value"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.secondaryColor
                                        ? configSettings.customEmail.secondaryColor
                                        : ""
                                }
                                onChange={event => {
                                    if (event.target.value.charAt(0) != "#") {
                                        createAlert("Please use hex code for these fields. Colour must start with a '#' e.g. #57308a ", `error`);
                                        return;
                                    } else {
                                        this._onFieldUpdate("configSettings.customEmail.secondaryColor", event)
                                    }
                                }}
                            />
                        </div>
                        <div className="form__group">
                            <label htmlFor="tertiaryColor" className="form__label">
                                Tertiary Color:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This field is for a specific color. Please use hex code for these fields. e.g. #57308a
                                </Tooltip>
                            </label>
                            <input
                                id="tertiaryColor"
                                type="text"
                                className="form__value"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.tertiaryColor
                                        ? configSettings.customEmail.tertiaryColor
                                        : ""
                                }
                                onChange={event => {
                                    if (event.target.value.charAt(0) != "#") {
                                        createAlert("Please use hex code for these fields. Colour must start with a '#' e.g. #57308a ", `error`);
                                        return;
                                    } else {
                                        this._onFieldUpdate("configSettings.customEmail.tertiaryColor", event)
                                    }
                                }}
                            />
                        </div>
                    </div>,
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="defaultImage" className="form__label">
                                Default Image:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This field is for an image. you must speak with a dev to place your desired images
                                    in the directory before you can use them. Once you’ve spoken to a dev and have
                                    gotten the necessary approval, enter in the filename with the extension.
                                </Tooltip>
                            </label>
                            <input
                                id="defaultImage"
                                type="text"
                                className="form__value"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.defaultImage
                                        ? configSettings.customEmail.defaultImage
                                        : "newspaper.jpg"
                                }
                                onChange={event =>
                                    this._onFieldUpdate("configSettings.customEmail.defaultImage", event)
                                }
                            />
                        </div>
                    </div>,
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="successManager" className="form__label">
                                Success Manager:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    This field is for the name and contact information of the Success Manager that users
                                    can contact. A best practice would be: [First Name] [Last Name] &lt;br/&gt;
                                    [Position] &lt;br/&gt; &lt;a href="mailto:[Email]"
                                    target="_blank"&gt;[Email]&lt;/a&gt;. Example: Mike Orr
                                    <br />
                                    Customer Success Manager
                                    <br />
                                    <a href="mailto:morr@seismic.com" target="_blank">
                                        morr@seismic.com
                                    </a>
                                </Tooltip>
                            </label>
                            <input
                                id="successManager"
                                type="text"
                                className="form__value"
                                placeholder="[First Name] [Last Name] <br/> [Position] <br/> <a href='mailto:[Email]' target='_blank'>[Email]</a>"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.successMgr
                                        ? configSettings.customEmail.successMgr
                                        : ""
                                }
                                onChange={event => this._onFieldUpdate("configSettings.customEmail.successMgr", event)}
                            />
                        </div>
                    </div>,
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="footerText" className="form__label">
                                Footer Text:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    Text in this field will be shown at the bottom of the email. Hyperlinks can be added
                                    to text by following this format: &lt;a href="[web link]"
                                    target="_blank"&gt;[hyperlinked term]&lt;/a&gt;
                                </Tooltip>
                            </label>
                            <input
                                id="footerText"
                                type="text"
                                className="form__value"
                                placeholder="Copyright [current_year] Seismic - All rights reserved. LiveSocial and the LiveSocial logo are registered trademarks of Seismic, and Seismic owns other registered and unregistered trademarks. Other names used herein may be trademarks of their respective owners"
                                value={
                                    configSettings.customEmail && configSettings.customEmail.footerTxt
                                        ? configSettings.customEmail.footerTxt
                                        : ""
                                }
                                onChange={event => this._onFieldUpdate("configSettings.customEmail.footerTxt", event)}
                            />
                        </div>
                    </div>
                ]
            },
            allowCustomContactConfig: {
                label: "Custom Contact Data",
                value: this.state.allowCustomContactConfig,
                description: "Allow client to set custom contact data",
                dropdown: [
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="contactNumber" className="form__label">Contact Number:</label>
                            <input
                                id="contactNumber"
                                type="text"
                                className="form__value"
                                placeholder=""
                                value={
                                    configSettings.customEmail && configSettings.contactInfo.contactNumber
                                        ? configSettings.contactInfo.contactNumber
                                        : ""
                                }
                                onChange={event =>
                                    this._onFieldUpdate("configSettings.contactInfo.contactNumber", event)
                                }
                            />
                        </div>
                        <div className="form__group">
                            <label htmlFor="contactName" className="form__label">Contact Name:</label>
                            <input
                                id="contactName"
                                type="text"
                                className="form__value"
                                placeholder=""
                                value={
                                    configSettings.contactInfo && configSettings.contactInfo.name
                                        ? configSettings.contactInfo.name
                                        : ""
                                }
                                onChange={event => this._onFieldUpdate("configSettings.contactInfo.name", event)}
                            />
                        </div>
                        <div className="form__group">
                            <label htmlFor="email" className="form__label">Email:</label>
                            <input
                                id="email"
                                type="text"
                                className="form__value"
                                placeholder=""
                                value={
                                    configSettings.contactInfo && configSettings.contactInfo.email
                                        ? configSettings.contactInfo.email
                                        : ""
                                }
                                onChange={event => this._onFieldUpdate("configSettings.contactInfo.email", event)}
                            />
                        </div>
                    </div>,
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="language" className="form__label">
                                Language:&nbsp;
                                <Tooltip className="tooltip__maxwidth">
                                    You must select a language before entering in help text. text per language is
                                    unique, and will not be overwritten if the language is changed. Hyperlinks can be
                                    added to text by following this format: &lt;a href="[web link]"
                                    target="_blank"&gt;[hyperlinked term]&lt;/a&gt;
                                </Tooltip>
                            </label>
                            <div className="select__wrapper">
                                <select
                                    id="language"
                                    onChange={e => this._onFieldUpdate("filterLang", e)}
                                    value={this.state.filterLang}
                                >
                                    <option value="">Please select a language</option>
                                    <option value="en">English</option>
                                    <option value="fr">French</option>
                                </select>
                            </div>
                        </div>
                    </div>,
                    <div className="form__row flex__row--center">
                        <div className="form__group">
                            <label htmlFor="helpText" className="form__label">Help Text:</label>
                            <input
                                id="helpText"
                                type="text"
                                className="form__value"
                                placeholder="Don’t see what you’re looking for, we’d love to help."
                                onChange={event =>
                                    this._onFieldUpdate(
                                        `configSettings.contactInfo.customHelp.${this.state.filterLang}`,
                                        event
                                    )
                                }
                                disabled={this.state.filterLang.length == 0}
                                value={
                                    configSettings.contactInfo &&
                                        configSettings.contactInfo.customHelp &&
                                        this.state.filterLang.length &&
                                        configSettings.contactInfo.customHelp[this.state.filterLang]
                                        ? configSettings.contactInfo.customHelp[this.state.filterLang]
                                        : ""
                                }
                            />
                        </div>
                    </div>
                ]
            }
        };
    }
    _getInputLogoDetails() {
        let { uploadedLogoURL, configSettings } = this.state;
        const { user } = this.props;
        let logoStyle = null;
        if (user.isClientAdmin) {
            logoStyle = {
                "pointer-events": "none",
                "opacity": "0.6"
            }
        }
        if (!uploadedLogoURL) {
            uploadedLogoURL = configSettings.customEmail.logo;
        }
        if (typeof uploadedLogoURL === "string" && uploadedLogoURL.includes("grapevinesix.s3")) {
            return (
                <div className="editable__input">
                    <Link style={logoStyle} href={stripGV6Query(uploadedLogoURL || "")} target="_blank">
                        {uploadedLogoURL}
                    </Link>
                </div>
            );
        } else {
            return (
                <input type="text" value={(uploadedLogoURL) || ""}
                    className="form__value"
                    placeholder="imagename.jpg"
                    disabled />
            );
        }

    }
    _getInputWeeklyLogoDetails() {
        let { uploadedWeeklyEmailURL, configSettings } = this.state;
        const { user } = this.props;
        let logoWeeklyStyle = null;
        if (user.isClientAdmin) {
            logoWeeklyStyle = {
                "pointer-events": "none",
                "opacity": "0.6"
            }
        }
        if (!uploadedWeeklyEmailURL) {
            uploadedWeeklyEmailURL = configSettings.customEmail.sideLogo;
        }
        if (typeof uploadedWeeklyEmailURL === "string" && uploadedWeeklyEmailURL.includes("grapevinesix.s3")) {
            return (
                <div className="editable__input">
                    <Link style={logoWeeklyStyle} href={stripGV6Query(uploadedWeeklyEmailURL || "")} target="_blank">
                        {uploadedWeeklyEmailURL}
                    </Link>
                </div>
            );
        } else {
            return (
                <input type="text" value={(uploadedWeeklyEmailURL) || ""}
                    className="form__value"
                    placeholder="imagename.jpg"
                    disabled />
            );
        }

    }
    _onCustomEmailUpdate(key, subkey, lang, event) {
        let customEmails = this.state.customEmails || {};
        if (!customEmails[key]) {
            customEmails[key] = {};
        }
        if (!customEmails[key][lang]) {
            customEmails[key][lang] = {};
        }
        customEmails[key][lang][subkey] = event.target.value;
        this._onFieldUpdate("customEmails", customEmails);
    }

    renderSharingNetworks() {
        return (
            <div className="col-sm-12 clientSocialNetwork__wrapper">
                <div className="clientSocialNetwork">
                    <span>
                        <h4 style={{ float: "left" }}>Social</h4>
                        <h4
                            style={{
                                float: "right"
                            }}
                        >
                            Max Daily Shares
                        </h4>
                    </span>
                    {["LinkedIn", "Twitter", "Facebook", "IG"].map(type => {
                        return (
                            <div className="permission">
                                <span className="permission__label">{type == "IG" ? "Instagram" : type === "Twitter" ? "X (Twitter)" : type} {type == "IG" ? <Tooltip>Facebook must be an allowed network to enable Instagram</Tooltip> : ""}</span>
                                <Toggle
                                    name="available"
                                    value={(this.state.socialNetworks[type] || { available: false }).available}
                                    onToggle={event => this._onSocialChange(type, "available")}
                                    aria-label={`${type} availability toggle`}
                                />
                                {type != "IG" ? <input
                                    type="number"
                                    min={1}
                                    max={25}
                                    style={{ width: "75px", marginLeft: "30px", marginRight: "25px" }}
                                    value={
                                        type == "LinkedIn"
                                            ? this.state.maxShareLimitLinkedIn
                                            : type == "Twitter"
                                            ? this.state.maxShareLimitTwitter
                                            : this.state.maxShareLimitFacebook
                                    }
                                    onChange={event => {
                                        if (Number(event.target.value) && Number(event.target.value) > 25) {
                                            event.target.value = 25;
                                        }
                                        this._onFieldUpdate(
                                            type == "LinkedIn"
                                                ? "maxShareLimitLinkedIn"
                                                : type == "Twitter"
                                                ? "maxShareLimitTwitter"
                                                : "maxShareLimitFacebook",
                                            Number(event.target.value) || 10
                                        );
                                    }}
                                    aria-label={`${type} max share limit`}
                                /> : <div style={{ marginLeft: "130px" }}></div>}
                            </div>
                        )
                    })}
                </div>
                <div style={{ flex: 1 }}>
                    <div className="clientSocialNetwork">
                        <h4>Email</h4>
                        <div className="permission">
                            <span className="permission__label">Device Email (Desktop) <Tooltip>Enables users to share content by email on the web version of LiveSocial. This will open the desktop’s default mail program via a mailto link.</Tooltip></span>
                            <Toggle
                                name="available"
                                value={(this.state.allowEmail)}
                                onToggle={() => this._onSharingSettingChange("allowEmail", !this.state.allowEmail)}
                            />
                        </div>
                        <div className="permission">
                            <span className="permission__label">Device Email (Mobile) <Tooltip>Enables users to share content by email on the app version of LiveSocial. This will open an app drawer where the user can choose from a list of apps to share to.</Tooltip></span>
                            <Toggle
                                name="available"
                                value={(this.state.allowAppEmail)}
                                onToggle={() => this._onSharingSettingChange("allowAppEmail", !this.state.allowAppEmail)}
                            />
                        </div>
                    </div>
                    <div className="clientSocialNetwork">
                        <h4>SMS</h4>
                        <div className="permission">
                            <span className="permission__label">Device SMS <Tooltip>Enables users to share content by SMS on the app version of LiveSocial. This will open the phone’s default SMS app. Not available on the web version of LiveSocial.</Tooltip></span>
                            <Toggle
                                name="available"
                                value={(this.state.allowAppSMS)}
                                onToggle={() => this._onSharingSettingChange("allowAppSMS", !this.state.allowAppSMS)}
                            />
                        </div>
                    </div>
                </div>
                <div className="clientSocialNetwork">
                    <h4>Extra Networks</h4>
                    <div className="permission">
                        <span className="permission__label">Allow Extra Networks</span>
                        <Toggle
                            name="available"
                            value={(this.state.hasExtraNetworks)}
                            onToggle={() => this._onFieldUpdate("hasExtraNetworks", !this.state.hasExtraNetworks)}
                        />
                    </div>
                    <div className="permission">
                        <span className="permission__label">Strict Extra Networks</span>
                        <Toggle
                            name="available"
                            value={(this.state.strictExtraNetworks)}
                            disabled={!this.state.hasExtraNetworks}
                            onToggle={() => this._onFieldUpdate("strictExtraNetworks", !this.state.strictExtraNetworks)}
                        />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "20px" }}>
                        <label htmlFor="copyLink" className="form__label">
                            Webshare Token: <Tooltip>Use this as the token for webshares</Tooltip>
                        </label>
                        <CopyLink textToCopy={this.state.code ? this.state.code : ""} />
                    </div>
                </div>
            </div>
        );
    }

    getCompanies() {
        const companies = Object.keys(this.props.companies).map(companyId => this.props.companies[companyId]);
        return companies
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(company => <option value={company.companyId}>{company.name}</option>);
    }

    __validateEmail(email) {
        const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(email);
    }

    async _sendEmail(emailType, emailAddress) {
        const { customEmails } = this.state;
        const lang = this.state[`__${emailType}-lang`] || "en";
        let body = customEmails[emailType][lang].body;
        let subject = customEmails[emailType][lang].subject;
        if (!body || !subject) {
            createAlert("Please enter a email subject and body ", `error`);
            return;
        }
        this._onFieldUpdate("previewModalOpen", false);
        body = body.replace(/\[name\]/g, "Johnny");
        body = body.replace(/\[delegate.firstName\]/g, "Johnny");
        body = body.replace(/\[firstName\]/g, "Johnny");
        body = body.replace(/\[delegate.lastName\]/g, "Delegate");
        body = body.replace(/\[advisor.firstName\]/g, "Jessica");
        body = body.replace(/\[advisor.lastName\]/g, "Advisor");
        body = body.replace(/\[delegate.code\]/g, "4ccdc3c0-c48b");
        body = body.replace(/\[delegate.email\]/g, "johnny.delegate@previewEmail.com");
        body = body.replace(/\[email\]/g, "johnny.activate@previewEmail.com");
        body = body.replace(/\[code\]/g, "4ccdc3c0-c48b");
        body = body.replace(/\[delegate.uuid\]/g, "12345678");
        body = body.replace(/\[permission\]/g, "content recommendations");
        body = body.replace(/\[contact\]/g, "Jessica Contact");
        body = body.replace(/\[website\]/gi, "www.emailPreview.org/");
        body = body.replace(/\[complianceLink\]/g, "https://sampleComplianceLink.org/install_patrol/INSTALL-fgwAGI");
        body = body.replace(/\[networks\]/g, "LinkedIn");

        try {
            await EmailActions.previewActivationEmail(this.state.cid || "", emailAddress, subject, body, lang);
            createAlert("Please check your inbox", "success");
        } catch { }
    }

    render() {
        const {
            name,
            actReminderEmail,
            tags,
            autoDomainType,
            regDomains,
            blockDomains,
            whiteLabels,
            configName,
            trackingCode,
            trackingCodeDomains,
            articleExpiryDefault,
            frontendSessionTimeout,
            consoleSessionTimeout,
            lang,
            origCard,
            fromEmail,
            brandName,
            brands,
            feedbackTo,
            linkedInCPClick,
            linkedInCPLike,
            linkedInCPComment,
            facebookCPClick,
            facebookCPLike,
            facebookCPComment,
            twitterCPClick,
            twitterCPLike,
            twitterCPComment,
            instagramCPLike,
            instagramCPComment,
            upContentChildClientAccountId,
            upContentChildClientFolderId,
            upContentChildClientFilterViewId,
            upContentChildClientContentPolicyId,
            upContentInterestSearchHierarchy
        } = this.state;

        if (this.props.readOnly) {
            (brands || []).push(brandName);
            (whiteLabels || []).push(configName);
        }

        let buttons = [];
        const tooltipText = `The name and/or email address that all automated LiveSocial emails will be sent from (e.g. Activation, Article Read, Weekly Social Report, etc). \n To set the name and email address, use the format "Name <Email>" E.g. "LiveSocial <notifications@livesocial.seismic.com>". \n If you would just like to set the email address without a name, no formatting is required E.g. “notifications@livesocial.seismic.com”`;
        if (this.props.user.isSuper) {
            buttons.push({
                title: "Back to client list",
                link: "/clients/"
            });
        }
        if (this.state.appSSO?.SEISMIC?.userSyncMethod === "managed") {
            buttons.push({
                title: "Sync Users",
                on_click: () => ClientActions.doSeismicUserSync(this.state.cid)
            });
        }
        return (
            <Wrapper id="editClient">
                <PageHeading title={`${this.props.readOnly ? "" : this.state.insert ? "Create " : "Edit "}Client${this.props.readOnly ? " Settings" : ""}`} buttons={buttons} />
                <form
                    className="wrapper wrapper-content"
                    onSubmit={event => this._onSubmit(event)}
                    onKeyPress={preventDefault}
                >
                    <fieldset disabled={!!this.props.readOnly}>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label htmlFor="name" className="form__label">Name:</label>
                                                <input
                                                    id="name"
                                                    type="text"
                                                    className="form__value"
                                                    ref={input => {
                                                        this.nameInput = input;
                                                    }}
                                                    onChange={event => this._onFieldUpdate("name", event)}
                                                    value={name ? name : ""}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="customBranding" className="form__label">Custom Branding:&nbsp;<Tooltip>Sets the branding colors in the app. If none is selected, the default Seismic branding will be used.</Tooltip></label>
                                                <div className="select__wrapper">
                                                    <select
                                                        id="customBranding"
                                                        onChange={event => this._onFieldUpdate("brandName", event)}
                                                        value={brandName}
                                                    >
                                                        <option value="">None</option>
                                                        {brands.map(function (brandName, index) {
                                                            return (<option key={brandName} value={brandName}>{brandName}</option>);
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className={`form__group`}>
                                                <label htmlFor="defaultLang" className="form__label">Default User Language:</label>
                                                <div className="select__wrapper">
                                                    <select
                                                        id="defaultLang"
                                                        value={lang}
                                                        onChange={event => this._onFieldUpdate("lang", event)}
                                                    >
                                                        <option value="en">English</option>
                                                        <option value="fr">French</option>
                                                        <option value="es">Spanish</option>
                                                        <option value="de">German</option>
                                                        <option value="pt">Portuguese</option>
                                                        <option value="it">Italian</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="defaultCompany" className="form__label">Default Company:</label>
                                                <div className="select__wrapper">
                                                    <select
                                                        id="defaultCompany"
                                                        value={this.state.defaultCompany}
                                                        onChange={event => this._onFieldUpdate("defaultCompany", event)}
                                                    >
                                                        <option value="">Please select a company</option>
                                                        {this.props.companies && this.getCompanies()}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className={`form__group`}>
                                                <label htmlFor="defaultCardStyle" className="form__label">Default Article Card Style:</label>
                                                <div className="select__wrapper">
                                                    <select
                                                        id="defaultCardStyle"
                                                        value={origCard}
                                                        onChange={event => this._onFieldUpdate("origCard", event)}
                                                    >
                                                        <option value="modern">Modern</option>
                                                        <option value="original">Original</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="defaultIndustry" className="form__label">Default User Industry:</label>
                                                <div className="select__wrapper">
                                                    <select
                                                        id="defaultIndustry"
                                                        value={this.state.defaultUserIndustry}
                                                        onChange={event =>
                                                            this._onFieldUpdate("defaultUserIndustry", event)
                                                        }
                                                    >
                                                        <option value="">Please select an industry</option>
                                                        {getIndustries().map(i => (
                                                            <option key={i.value} value={i.value}>
                                                                {i.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label htmlFor="advWLSettingsConfig" className="form__label">Advanced White Label Settings Config:&nbsp;<Tooltip>Set the configuration of the whitelabeled domain and other features as per the client’s config file.</Tooltip></label>
                                                <div className="select__wrapper">
                                                    <select
                                                        id="advWLSettingsConfig"
                                                        onChange={event => this._onFieldUpdate("configName", event)}
                                                        value={configName}
                                                    >
                                                        {whiteLabels &&
                                                            whiteLabels.length > 0 &&
                                                            whiteLabels.map(function (label, index) {
                                                                return (
                                                                    <option key={label} value={label}>
                                                                        {label}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form__group"></div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label">
                                                    Client Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getSettings(0)}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"0"}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label className="form__label">
                                                    &nbsp;
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getSettings(1)}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"1"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full" style={{ paddingBottom: "0px" }}>
                                                <label className="form__label">
                                                    Onboarding Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getOnboardingIntroSettings()}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"2"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">
                                                    Up Content Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getUpContentSettings()}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"2"}
                                                />
                                            </div>
                                        </div>
                                        {this.state.enableUpContent &&
                                            <div>
                                                <div className="form__row">
                                                    <div className="form__group form__group--full">
                                                        <h4 style={{ marginBottom: "15px", color: "#676a6c" }}>Client Configuration</h4>
                                                    </div>
                                                </div>
                                                <div className="form__row">
                                                    <div className="form__group">
                                                        <label className="form__label" htmlFor="upContentChildClientAccountId">Client Child Account ID:</label>
                                                        <input
                                                            id="upContentChildClientAccountId"
                                                            type="text"
                                                            className="form__value"
                                                            onChange={event => this._onFieldUpdate("upContentChildClientAccountId", event)}
                                                            value={upContentChildClientAccountId ? upContentChildClientAccountId : ""}
                                                        />
                                                        {/* Placeholder for validation icon */}
                                                        <span style={{marginLeft:8}}>{this.state.upContentChildClientAccountIdValid === true ? '✓' : this.state.upContentChildClientAccountIdValid === false ? '✗' : ''}</span>
                                                    </div>
                                                    <div className="form__group">
                                                        <label className="form__label" htmlFor="upContentChildClientFolderId">Client Child Folder ID:</label>
                                                        <select
                                                            id="upContentChildClientFolderId"
                                                            className="form__value"
                                                            onChange={event => this._onFieldUpdate("upContentChildClientFolderId", event)}
                                                            value={upContentChildClientFolderId ? upContentChildClientFolderId : ""}
                                                            disabled={!this.state.upContentChildClientAccountIdValid || this.state.upContentLoading}
                                                        >
                                                            <option value="">
                                                                {!this.state.upContentChildClientAccountIdValid
                                                                    ? "Enter valid Account ID first..."
                                                                    : this.state.upContentLoading
                                                                        ? "Loading folders..."
                                                                        : this.state.upContentFolderOptions.length === 0
                                                                            ? "No folders available"
                                                                            : "Select Folder..."}
                                                            </option>
                                                            {this.state.upContentFolderOptions.map(option => (
                                                                <option key={option.id} value={option.id}>
                                                                    {option.name || option.id}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <span style={{marginLeft:8}}>{this.state.upContentChildClientFolderIdValid === true ? '✓' : this.state.upContentChildClientFolderIdValid === false ? '✗' : ''}</span>
                                                    </div>
                                                </div>
                                                <div className="form__row">
                                                    <div className="form__group">
                                                        <label className="form__label" htmlFor="upContentChildClientFilterViewId">Client Child Filter View ID:</label>
                                                        <select
                                                            id="upContentChildClientFilterViewId"
                                                            className="form__value"
                                                            onChange={event => this._onFieldUpdate("upContentChildClientFilterViewId", event)}
                                                            value={upContentChildClientFilterViewId ? upContentChildClientFilterViewId : ""}
                                                            disabled={!this.state.upContentChildClientAccountIdValid || this.state.upContentLoading}
                                                        >
                                                            <option value="">
                                                                {!this.state.upContentChildClientAccountIdValid
                                                                    ? "Enter valid Account ID first..."
                                                                    : this.state.upContentLoading
                                                                        ? "Loading filter views..."
                                                                        : this.state.upContentFilterViewOptions.length === 0
                                                                            ? "No filter views available"
                                                                            : "Select Filter View..."}
                                                            </option>
                                                            {this.state.upContentFilterViewOptions.map(option => (
                                                                <option key={option.id} value={option.id}>
                                                                    {option.name || option.title || option.id}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <span style={{marginLeft:8}}>{this.state.upContentChildClientFilterViewIdValid === true ? '✓' : this.state.upContentChildClientFilterViewIdValid === false ? '✗' : ''}</span>
                                                    </div>
                                                    <div className="form__group">
                                                        <label className="form__label" htmlFor="upContentChildClientContentPolicyId">Client Child Content Policy ID:</label>
                                                        <select
                                                            id="upContentChildClientContentPolicyId"
                                                            className="form__value"
                                                            onChange={event => this._onFieldUpdate("upContentChildClientContentPolicyId", event)}
                                                            value={upContentChildClientContentPolicyId ? upContentChildClientContentPolicyId : ""}
                                                            disabled={!this.state.upContentChildClientAccountIdValid || this.state.upContentLoading}
                                                        >
                                                            <option value="">
                                                                {!this.state.upContentChildClientAccountIdValid
                                                                    ? "Enter valid Account ID first..."
                                                                    : this.state.upContentLoading
                                                                        ? "Loading content policies..."
                                                                        : this.state.upContentContentPolicyOptions.length === 0
                                                                            ? "No content policies available"
                                                                            : "Select Content Policy..."}
                                                            </option>
                                                            {this.state.upContentContentPolicyOptions.map(option => (
                                                                <option key={option.id} value={option.id}>
                                                                    {option.name || option.title || option.id}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <span style={{marginLeft:8}}>{this.state.upContentChildClientContentPolicyIdValid === true ? '✓' : this.state.upContentChildClientContentPolicyIdValid === false ? '✗' : ''}</span>
                                                    </div>
                                                </div>
                                                <div className="form__row">
                                                    <div className="form__group form__group--full">
                                                        <label className="form__label" htmlFor="upContentInterestSearchHierarchy">Interest Search Hierarchy:</label>
                                                        <select
                                                            id="upContentInterestSearchHierarchy"
                                                            className="form__value"
                                                            onChange={event => this._onFieldUpdate("upContentInterestSearchHierarchy", event)}
                                                            value={upContentInterestSearchHierarchy || "parentOnly"}
                                                            disabled={!this.state.upContentChildClientFolderIdValid}
                                                        >
                                                            <option value="parentOnly">Parent Only — search the global parent account only</option>
                                                            <option value="childOnly">Child Only — search the child account ({upContentChildClientAccountId || "not set"}) only</option>
                                                            <option value="parentThenChild">Parent then Child — search parent first, then child; keep parent on duplicate</option>
                                                            <option value="childThenParent">Child then Parent — search child first, then parent; keep child on duplicate</option>
                                                        </select>
                                                        <p style={{ fontSize: "11px", color: "#999", marginTop: "4px" }}>
                                                            {!this.state.upContentChildClientFolderIdValid
                                                                ? "Select a valid child account id above to enable hierarchy options."
                                                                : "Controls which UpContent folder(s) are searched when users pick interests from the dropdown."}
                                                        </p>
                                                    </div>
                                                </div>
                                                {/* UpContent Migration/Resync Area - moved below dropdowns */}
                                                <div className="form__row">
                                                    <div className="form__group form__group--full">
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                                            <span className="permission__label" style={{ fontSize: "14px", fontWeight: "600", margin: "0" }}>
                                                                UpContent Migration
                                                            </span>
                                                            {/* Action buttons always visible */}
                                                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                                <Button
                                                                    className="btn--sm"
                                                                    onClick={this._loadMigrationResults}
                                                                    style={{ marginBottom: "0" }}
                                                                >
                                                                    {this.state.migrationResultsLoading ? (
                                                                        <span><i className="fa fa-spin fa-spinner" /> Loading...</span>
                                                                    ) : (
                                                                        <span><i className="fa fa-eye" /> View Results</span>
                                                                    )}
                                                                </Button>
                                                                <Button
                                                                    className="btn--sm"
                                                                    onClick={this._downloadMigrationResultsCSV}
                                                                    style={{ marginBottom: "0" }}
                                                                >
                                                                    <span><i className="fa fa-download" /> Download CSV</span>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <p style={{ fontSize: "12px", color: "#666", marginBottom: "10px" }}>
                                                                Migrate existing user profile terms to UpContent. This process analyzes all user terms and creates corresponding interests in UpContent.
                                                                Click the button below to start the migration process.
                                                            </p>
                                                            {this.state.migrationInProgress && (
                                                                <div style={{ marginBottom: "15px" }}>
                                                                    <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                                                                        <div style={{
                                                                            width: "100%",
                                                                            height: "20px",
                                                                            backgroundColor: "#f0f0f0",
                                                                            borderRadius: "10px",
                                                                            overflow: "hidden",
                                                                            marginRight: "10px"
                                                                        }}>
                                                                            <div style={{
                                                                                width: `${this.state.migrationProgress}%`,
                                                                                height: "100%",
                                                                                backgroundColor: "#55059c",
                                                                                transition: "width 0.3s ease"
                                                                            }}></div>
                                                                        </div>
                                                                        <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                                                                            {this.state.migrationProgress}%
                                                                        </span>
                                                                    </div>
                                                                    <p style={{ fontSize: "11px", color: "#555", margin: "0" }}>
                                                                        {this.state.migrationStatus}
                                                                    </p>
                                                                </div>
                                                            )}
                                                            {!this.state.migrationInProgress && this.state.migrationStatus && (
                                                                <div style={{ marginBottom: "15px" }}>
                                                                    <p style={{ fontSize: "11px", color: "#555", margin: "0 0 10px 0" }}>
                                                                        {this.state.migrationStatus}
                                                                    </p>
                                                                </div>
                                                            )}
                                                            <Button
                                                                onClick={() => {
                                                                    this._triggerUpContentMigration();
                                                                }}
                                                                disabled={this.state.migrationInProgress || !this.state.upContentChildClientAccountId}
                                                                style={{
                                                                    backgroundColor: (this.state.migrationInProgress || !this.state.upContentChildClientAccountId) ? "#ccc" : "#55059c",
                                                                    color: "white",
                                                                    border: "none",
                                                                    padding: "8px 16px",
                                                                    borderRadius: "4px",
                                                                    cursor: (this.state.migrationInProgress || !this.state.upContentChildClientAccountId) ? "not-allowed" : "pointer",
                                                                    marginBottom: "0"
                                                                }}
                                                            >
                                                                {this.state.migrationInProgress ? "Migration in Progress..." : "Resync Profile Terms"}
                                                            </Button>
                                                            {/* Show detailed results if available */}
                                                            {this.state.migrationResults && (this.state.migrationResults.successfulTerms?.length > 0 || this.state.migrationResults.failedTerms?.length > 0) && (
                                                                <div style={{ marginTop: "15px" }}>
                                                                    <details style={{ fontSize: "11px", color: "#666", border: "1px solid #e0e0e0", borderRadius: "4px", padding: "10px" }}>
                                                                        <summary style={{ cursor: "pointer", fontWeight: "600", marginBottom: "5px" }}>
                                                                            View Detailed Results ({this.state.migrationResults.successfulTermsCount} succeeded, {this.state.migrationResults.failedTermsCount} failed)
                                                                        </summary>
                                                                        <div style={{ marginTop: "10px" }}>
                                                                            {this.state.migrationResults.successfulTerms?.length > 0 && (
                                                                                <div style={{ marginBottom: "10px" }}>
                                                                                    <strong style={{ color: "#28a745" }}>✓ Successful Terms ({this.state.migrationResults.successfulTerms.length}):</strong>
                                                                                    <ul style={{ marginTop: "5px", paddingLeft: "20px", maxHeight: "150px", overflowY: "auto" }}>
                                                                                        {this.state.migrationResults.successfulTerms.map((term, idx) => (
                                                                                            <li key={idx} style={{ marginBottom: "3px" }}>
                                                                                                {term.term} <span style={{ color: "#999" }}>({term.language}, {term.type})</span>
                                                                                                {term.usedFallback && term.alias && (
                                                                                                    <span style={{ color: "#007bff", fontSize: "10px", marginLeft: "5px", fontStyle: "italic" }}>
                                                                                                        [aliased from: {term.alias}]
                                                                                                    </span>
                                                                                                )}
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                            {this.state.migrationResults.failedTerms?.length > 0 && (
                                                                                <div>
                                                                                    <strong style={{ color: "#dc3545" }}>✗ Failed Terms ({this.state.migrationResults.failedTerms.length}):</strong>
                                                                                    <ul style={{ marginTop: "5px", paddingLeft: "20px", maxHeight: "150px", overflowY: "auto" }}>
                                                                                        {this.state.migrationResults.failedTerms.map((term, idx) => {
                                                                                            let errorMsg = term.error;
                                                                                            if (errorMsg && errorMsg.includes('404') && errorMsg.includes('requested collection does not exist')) {
                                                                                                errorMsg = 'Interest could not be migrated because it does not exist in UpContent.';
                                                                                            }
                                                                                            return (
                                                                                                <li key={idx} style={{ marginBottom: "3px" }}>
                                                                                                    {term.term} <span style={{ color: "#999" }}>({term.language}, {term.type})</span>
                                                                                                    <br />
                                                                                                    <span style={{ color: "#dc3545", fontSize: "10px" }}>Error: {errorMsg}</span>
                                                                                                </li>
                                                                                            );
                                                                                        })}
                                                                                    </ul>
                                                                                    {/* Show a generic comment if any failed term has a 404 error */}
                                                                                    {this.state.migrationResults.failedTerms.some(term => term.error && term.error.includes('404') && term.error.includes('requested collection does not exist')) && (
                                                                                        <div style={{ color: '#dc3545', fontSize: '11px', marginTop: '8px', fontStyle: 'italic' }}>
                                                                                            Some interests could not be migrated because they do not exist in UpContent.
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </details>
                                                                </div>
                                                            )}
                                                            {!this.state.upContentChildClientAccountId && (
                                                                <p style={{ fontSize: "11px", color: "#999", margin: "5px 0 0 0", fontStyle: "italic" }}>
                                                                    UpContent Account ID is required to run migration
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Row>
                        {(this.props.user.isSuper || this.props.user.isSuperClientAdmin) &&
                            <Row>
                                <div className="col-sm-12">
                                    <div className="ibox">
                                        <div className="ibox-content form">
                                            <div className="form__row">
                                                <div className="form__group form__group--full">
                                                    <label className="form__label">
                                                        Leads
                                                        <span
                                                            style={{
                                                                float: "right",
                                                                marginRight: "15px"
                                                            }}
                                                        >
                                                            Off/On
                                                        </span>
                                                    </label>
                                                    <PermissionSet
                                                        permissions={this._getSocialInteractionCaptureSettings()}
                                                        _onChange={this._onFieldUpdate}
                                                        setNumber={"3"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        }
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h5>Email Settings</h5>
                                    </div>
                                    <div className="ibox-content form">
                                        <div style={{ marginBottom: "10px" }}>
                                            <div
                                                className="select__wrapper"
                                                style={{
                                                    marginLeft: "auto",
                                                    minWidth: "150px",
                                                    maxWidth: "305px"
                                                }}
                                            >
                                                <select value={autoDomainType} onChange={event => this._onFieldUpdate("autoDomainType", event)} aria-label="Auto domain type selection">
                                                    <option value="regDomains">Auto - Registration Emails</option>
                                                    <option value="blockDomains">Auto - Block Consumer Activation Emails</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="reminderEmail">Reminder Email Address:</label>
                                                <input
                                                    id="reminderEmail"
                                                    type="text"
                                                    className="form__value"
                                                    onChange={event => this._onFieldUpdate("actReminderEmail", event)}
                                                    value={actReminderEmail ? actReminderEmail : ""}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label className="form__label">{autoDomainType == "regDomains" ? "Auto - Registration Emails:" : "Auto - Block Consumer Activation Emails:"}</label>
                                                <ul className="form__value form__value--centered">
                                                    {(autoDomainType == "regDomains" && regDomains || autoDomainType == "blockDomains" && blockDomains || []).map(
                                                        function (domain, index) {
                                                            return (
                                                                <li key={domain}>
                                                                    <input
                                                                        type="text"
                                                                        value={domain ? domain : ""}
                                                                        disabled={true}
                                                                    />
                                                                    <Button
                                                                        onClick={event =>
                                                                            this._removeAutoDomain(event, domain)
                                                                        }
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                </li>
                                                            );
                                                        }.bind(this)
                                                    )}
                                                    <li>
                                                        <input
                                                            type="text"
                                                            ref={input => {
                                                                this.regInput = input;
                                                            }}
                                                            onChange={event =>
                                                                this.setState({ addRegEmail: event.target.value })
                                                            }
                                                            placeholder={autoDomainType == "regDomains" ? "Add new auto registration domain" : "Add new block domain"}
                                                        />
                                                        <Button
                                                            onClick={event => this._onAutoDomainChange(this.regInput.value)}
                                                            disabled={
                                                                !this.state.addRegEmail || !this.state.addRegEmail.length
                                                            }
                                                        >
                                                            Add
                                                        </Button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="fromEmail">From Email Address:&nbsp;
                                                    <Tooltip> {tooltipText}</Tooltip>
                                                </label>
                                                <input
                                                    id="fromEmail"
                                                    type="text"
                                                    className="form__value"
                                                    onChange={event => this._onFieldUpdate("fromEmail", event)}
                                                    value={fromEmail}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="contactEmail">Contact Email Address:</label>
                                                <input
                                                    id="contactEmail"
                                                    type="text"
                                                    className="form__value"
                                                    onChange={event => this._onFieldUpdate("contactEmail", event)}
                                                    value={this.state.contactEmail ? this.state.contactEmail : ""}
                                                />
                                            </div>
                                        </div>
                                        {this.state.allowFeedback && <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label" htmlFor="feedbackTo">Feedback Emailed to:</label>
                                                <input
                                                    id="feedbackTo"
                                                    type="text"
                                                    className="form__value"
                                                    onChange={event => this._onFieldUpdate("feedbackTo", event)}
                                                    value={feedbackTo}
                                                />
                                            </div>
                                            <div className="form__group"></div>
                                        </div>}
                                        {this._renderEmailSection("activationEmail")}
                                        {this._renderEmailSection("ReengagementEmail")}
                                    </div>
                                </div>
                            </div>
                            {this.state.previewModalOpen && (
                                <ConfirmModal
                                    title={"Email Preview"}
                                    button={`Send`}
                                    force={false}
                                    open={true}
                                    onConfirm={() => {
                                        if (this.state.emailAddress) {
                                            if (!this.__validateEmail(this.state.emailAddress)) {
                                                createAlert(
                                                    "Sender Email format is invalid, please provide a proper email"
                                                );
                                                return;
                                            }
                                            if (
                                                !this.state.emailAddress ||
                                                !this.__validateEmail(this.state.emailAddress)
                                            ) {
                                                createAlert("Please provide a proper email");
                                                return;
                                            }
                                            this._sendEmail(this.state.emailType, this.state.emailAddress);
                                        } else {
                                            createAlert("Please enter sender email address", `error`);
                                        }
                                    }}
                                    onCancel={() => {
                                        this.setState({ previewModalOpen: false });
                                    }}
                                >
                                    <label className="form__label">
                                        A copy of this email will be sent to the following email address.
                                    </label>{" "}
                                    <br />
                                    <br />
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            marginLeft: "auto"
                                        }}
                                    >
                                        <span style={{ marginRight: "10px", fontSize: "15px", verticalAlign: "sub" }}>
                                            Email Address:{" "}
                                        </span>
                                        <input
                                            type="text"
                                            className="form__value"
                                            onChange={event => this._onFieldUpdate("emailAddress", event)}
                                            onFocus={event => event.target.select()}
                                            value={this.state.emailAddress}
                                            style={{ maxWidth: "80%" }}
                                        />
                                    </div>
                                </ConfirmModal>
                            )}
                            {this.state.allowContentAnalysisModal && (
                                <ConfirmModal
                                    title={`Warning`}
                                    button={`OK`}
                                    force={false}
                                    open={true}
                                    onConfirm={() => this.setState({ allowContentAnalysis: true, allowContentAnalysisModal: false })}
                                    onCancel={() => this.setState({ allowContentAnalysis: false, allowContentAnalysisModal: false })}
                                >
                                    Does this client use a white labeled domain?
                                    <br />
                                    <br />
                                    If so, please speak with a developer to ensure an Adobe PDF Domain key has been created for the client.
                                    <br />
                                    <br />
                                    <strong>If this is not done, the client will not have authorization to use the Adobe PDF Viewer and this feature will not work.</strong>
                                    <br />
                                </ConfirmModal>
                            )}
                            {this.state.enableTwitterSocialMetricsModal && (
                                <ConfirmModal
                                    title={`Warning`}
                                    button={`OK`}
                                    force={false}
                                    open={true}
                                    onConfirm={() => this.setState({ enableTwitterSocialMetrics: true, enableTwitterSocialMetricsModal: false })}
                                    onCancel={() => this.setState({ enableTwitterSocialMetrics: false, enableTwitterSocialMetricsModal: false })}
                                >
                                    X (Twitter) Metrics is a billable expense. Please ensure that the client is aware of this before enabling this feature.
                                    <br />
                                    <br />
                                    If so, please speak with Product Team to ensure X (Twitter) Usage is not exceeding our account limits.
                                    <br />
                                </ConfirmModal>
                            )}
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">
                                                    Sharing Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                {this.renderSharingNetworks()}
                                                <PermissionSet
                                                    permissions={this._getSharingSettings()}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"4"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">
                                                    Advanced Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getAdvancedSettings()}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"5"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">
                                                    SSO Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getSSOSettings()}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"50"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">
                                                    IP Address Restriction:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <div className="permission">
                                                    <span className="permission__label">
                                                        Enable IP Address Restriction for Access to App and Console
                                                    </span>
                                                    <Toggle
                                                        id="adminIPRestrictionEnabled"
                                                        name="adminIPRestrictionEnabled"
                                                        onToggle={event =>
                                                            this._onFieldUpdate(
                                                                "adminIPRestrictionEnabled",
                                                                !this.state.adminIPRestrictionEnabled
                                                            )
                                                        }
                                                        value={this.state.adminIPRestrictionEnabled}
                                                    />
                                                </div>
                                                <div style={{ marginTop: "10px", fontSize: "12px", color: "#666", marginLeft: "0px" }}>
                                                    When enabled, users and admins will only be able to access the applications from the specified IP addresses below.
                                                </div>
                                                {this.state.adminIPRestrictionEnabled && (
                                                    <div style={{ marginTop: "20px" }}>
                                                        <label htmlFor="adminAllowedIPs" className="form__label">
                                                            Allowed IP Addresses:
                                                        </label>
                                                        <textarea
                                                            id="adminAllowedIPs"
                                                            className="form__value"
                                                            placeholder="Enter IP addresses separated by commas (e.g., 192.168.1.100, 10.0.0.0/8, 172.16.*.*)"
                                                            rows="3"
                                                            value={Array.isArray(this.state.adminAllowedIPs)
                                                                ? this.state.adminAllowedIPs.join(", ")
                                                                : (this.state.adminAllowedIPs || "")}
                                                            onChange={event => {
                                                                this._onFieldUpdate("adminAllowedIPs", event);
                                                            }}
                                                            onBlur={event => {
                                                                const value = event.target.value;
                                                                // Convert comma-separated string to array on blur
                                                                const ipsArray = value
                                                                    .split(',')
                                                                    .map(ip => ip.trim())
                                                                    .filter(ip => ip.length > 0);
                                                                this._onFieldUpdate("adminAllowedIPs", { target: { value: ipsArray } });
                                                            }}
                                                            style={{ width: "100%", resize: "vertical" }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h5>Additional Settings</h5>
                                    </div>
                                    {/* for super-client-admin */}
                                    {
                                        this.props.user.isSuperClientAdmin &&
                                        <div className="ibox-content form">


                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label htmlFor="appTimeout" className="form__label">App Session Timeout:</label>
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            flexDirection: "row",
                                                            flexWrap: "wrap"
                                                        }}
                                                    >
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="appTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "frontendSessionTimeout",
                                                                        "day"
                                                                    )
                                                                }
                                                                value={Math.floor((frontendSessionTimeout * 60) / 86400)}
                                                                aria-label="Application timeout in days"
                                                            >
                                                                {getRange(0, 365).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} day${v != 1 ? "s" : ""}`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "frontendSessionTimeout",
                                                                        "hour"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    (((frontendSessionTimeout * 60) % 31536000) % 86400) / 3600
                                                                )}
                                                                aria-label="Application timeout in hours"
                                                            >
                                                                {getRange(0, 23).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} hour${v != 1 ? "s" : ""}`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "frontendSessionTimeout",
                                                                        "minute"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    ((((frontendSessionTimeout * 60) % 31536000) % 86400) %
                                                                        3600) /
                                                                    60
                                                                )}
                                                                aria-label="Application timeout in minutes"
                                                            >
                                                                {getRange(0, 59).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} minute${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="permission no-borders">
                                                        <span className="permission__label">
                                                            Non Persistent Token{" "}
                                                            <Tooltip>
                                                                Deletes the session token when the user closes the app/browser
                                                            </Tooltip>
                                                        </span>

                                                        <Toggle
                                                            name="frontendSessionNonPersistent"
                                                            value={this.state.frontendSessionNonPersistent}
                                                            onToggle={event =>
                                                                this._onFieldUpdate(
                                                                    "frontendSessionNonPersistent",
                                                                    !this.state.frontendSessionNonPersistent
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form__group">
                                                    <label htmlFor="consoleTimeout" className="form__label">Console Session Timeout:</label>
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            flexDirection: "row",
                                                            flexWrap: "wrap"
                                                        }}
                                                    >
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="consoleTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(event, "consoleSessionTimeout", "day")
                                                                }
                                                                value={Math.floor((consoleSessionTimeout * 60) / 86400)}
                                                                aria-label="Console session timeout in days"
                                                            >
                                                                {getRange(0, 365).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} day${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "consoleSessionTimeout",
                                                                        "hour"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    (((consoleSessionTimeout * 60) % 31536000) % 86400) / 3600
                                                                )}
                                                                aria-label="Console session timeout in hours"
                                                            >
                                                                {getRange(0, 23).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} hour${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "consoleSessionTimeout",
                                                                        "minute"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    ((((consoleSessionTimeout * 60) % 31536000) % 86400) %
                                                                        3600) /
                                                                    60
                                                                )}
                                                                aria-label="Console session timeout in minutes"

                                                            >
                                                                {getRange(0, 59).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} minute${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label htmlFor="trackingCode" className="form__label">
                                                        Tracking Code:&nbsp;
                                                        <Tooltip>
                                                            {"Tracking code can be appended to the end of the URL.\n\n" +
                                                                "The following are constant keys for article specific value substitution:\n\n" +
                                                                "[UserId] : The ID of the user who shared the article.\n\n" +
                                                                "[ArticleId] : The ID of the sharing article\n\n" +
                                                                "[mmddyy] : Date when the user shared the article in mmddyy format\n\n" +
                                                                "[yyyymmdd] : Date when the user shared the article in yyyymmdd format\n\n" +
                                                                "[StreamName] : Name of the stream the article was shared from"}
                                                        </Tooltip>
                                                    </label>
                                                    <input
                                                        id="trackingCode"
                                                        type="text"
                                                        className="form__value"
                                                        onChange={event => this._onFieldUpdate("trackingCode", event)}
                                                        value={trackingCode ? trackingCode : ""}
                                                    />
                                                </div>

                                                <div className="form__group">
                                                    <label htmlFor="trackingCodeDomain" className="form__label">Tracking Code Domain:</label>
                                                    <input
                                                        id="trackingCodeDomain"
                                                        type="text"
                                                        className="form__value"
                                                        onChange={event => this._onFieldUpdate("trackingCodeDomains", event)}
                                                        value={trackingCodeDomains ? trackingCodeDomains : ""}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label htmlFor="defaultArticleExpiry" className="form__label">Default Article Expiry (in days):</label>
                                                    <input
                                                        id="defaultArticleExpiry"
                                                        type="number"
                                                        min={1}
                                                        max={365 * 5}
                                                        value={articleExpiryDefault ? articleExpiryDefault : 1}
                                                        onChange={event => this._onFieldUpdate("articleExpiryDefault", Number(event.target.value))}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {/* for super-admin */}
                                    {
                                        this.props.user.isSuper &&
                                        <div className="ibox-content form">

                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label className="form__label">Content Tags:</label>
                                                    <ul id="ContentTags" className="form__value form__value--centered">
                                                        {Object.keys(tags).map(
                                                            function (tag, index) {
                                                                if (tag == 0) {
                                                                    return tags[tag].map(
                                                                        function (t, i) {
                                                                            return (
                                                                                <li key={t}>
                                                                                    <input
                                                                                        id={`tag-input-${t}`}
                                                                                        type="text"
                                                                                        value={t ? t : ""}
                                                                                        disabled={true}
                                                                                    />
                                                                                    <Button
                                                                                        id={`tag-remove-${t}`}
                                                                                        onClick={event =>
                                                                                            this._removeTag(
                                                                                                event.target.value,
                                                                                                0,
                                                                                                t
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Remove
                                                                                    </Button>
                                                                                </li>
                                                                            );
                                                                        }.bind(this)
                                                                    );
                                                                }
                                                                return (
                                                                    <li key={`tag-${index}`}>
                                                                        <input
                                                                            id={`tag-input-${tags[tag]}`}
                                                                            type="text"
                                                                            value={tags[tag] ? tags[tag] : ""}
                                                                            disabled={true}
                                                                        />{" "}
                                                                        {this.isOrphandedTag(tag) && (
                                                                            <i className="fa fa-help" />
                                                                        )}
                                                                        <Button
                                                                            id={`tag-remove-${tags[tag]}`}
                                                                            onClick={event =>
                                                                                this._removeTag(event.target.value, tag)
                                                                            }
                                                                        >
                                                                            Remove{" "}
                                                                            {this.isOrphandedTag(tag) && (
                                                                                <Tooltip
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        top: "-5px",
                                                                                        right: "-5px",
                                                                                        color: "red",
                                                                                        backgroundColor: "white",
                                                                                        borderRadius: "50%",
                                                                                        width: "20px",
                                                                                        height: "19.375px"
                                                                                    }}
                                                                                    icon="fa-exclamation-circle"
                                                                                >{`This tag is currently not associated to any streams`}</Tooltip>
                                                                            )}
                                                                        </Button>
                                                                    </li>
                                                                );
                                                            }.bind(this)
                                                        )}
                                                        <li>
                                                            <input
                                                                id="newtag-input"
                                                                type="text"
                                                                ref={input => {
                                                                    this.tagInput = input;
                                                                }}
                                                                onChange={event =>
                                                                    this.setState({ addTag: event.target.value })
                                                                }
                                                                placeholder="Add new tag"
                                                            />
                                                            <Button
                                                                id="newtag-btn"
                                                                onClick={event => this._onTagChange(this.tagInput.value, 0)}
                                                                disabled={!this.state.addTag || !this.state.addTag.length}
                                                            >
                                                                Add
                                                            </Button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="form__group">
                                                    <label htmlFor="defaultArticleExpiry" className="form__label">Default Article Expiry (in days):</label>
                                                    <input
                                                        id="defaultArticleExpiry"
                                                        type="number"
                                                        min={1}
                                                        max={365 * 5}
                                                        value={articleExpiryDefault ? articleExpiryDefault : 1}
                                                        onChange={event => this._onFieldUpdate("articleExpiryDefault", Number(event.target.value))}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label htmlFor="appTimeout" className="form__label">App Session Timeout:</label>
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            flexDirection: "row",
                                                            flexWrap: "wrap"
                                                        }}
                                                    >
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="appTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "frontendSessionTimeout",
                                                                        "day"
                                                                    )
                                                                }
                                                                value={Math.floor((frontendSessionTimeout * 60) / 86400)}
                                                            >
                                                                {getRange(0, 365).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} day${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="appTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "frontendSessionTimeout",
                                                                        "hour"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    (((frontendSessionTimeout * 60) % 31536000) % 86400) / 3600
                                                                )}
                                                            >
                                                                {getRange(0, 23).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} hour${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="appTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "frontendSessionTimeout",
                                                                        "minute"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    ((((frontendSessionTimeout * 60) % 31536000) % 86400) %
                                                                        3600) /
                                                                    60
                                                                )}
                                                            >
                                                                {getRange(0, 59).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} minute${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="permission no-borders">
                                                        <span className="permission__label">
                                                            Non Persistent Token{" "}
                                                            <Tooltip>
                                                                Deletes the session token when the user closes the app/browser
                                                            </Tooltip>
                                                        </span>

                                                        <Toggle
                                                            name="frontendSessionNonPersistent"
                                                            value={this.state.frontendSessionNonPersistent}
                                                            onToggle={event =>
                                                                this._onFieldUpdate(
                                                                    "frontendSessionNonPersistent",
                                                                    !this.state.frontendSessionNonPersistent
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form__group">
                                                    <label htmlFor="consoleTimeout" className="form__label">Console Session Timeout:</label>
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            flexDirection: "row",
                                                            flexWrap: "wrap"
                                                        }}
                                                    >
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="consoleTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(event, "consoleSessionTimeout", "day")
                                                                }
                                                                value={Math.floor((consoleSessionTimeout * 60) / 86400)}
                                                            >
                                                                {getRange(0, 365).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} day${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="consoleTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "consoleSessionTimeout",
                                                                        "hour"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    (((consoleSessionTimeout * 60) % 31536000) % 86400) / 3600
                                                                )}
                                                            >
                                                                {getRange(0, 23).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} hour${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="select__wrapper"
                                                            style={{
                                                                minWidth: "150px",
                                                                width: "33%"
                                                            }}
                                                        >
                                                            <select
                                                                id="consoleTimeout"
                                                                onChange={event =>
                                                                    this._onChangeTimeout(
                                                                        event,
                                                                        "consoleSessionTimeout",
                                                                        "minute"
                                                                    )
                                                                }
                                                                value={Math.floor(
                                                                    ((((consoleSessionTimeout * 60) % 31536000) % 86400) %
                                                                        3600) /
                                                                    60
                                                                )}
                                                            >
                                                                {getRange(0, 59).map((v, i) => {
                                                                    return (
                                                                        <option value={v} key={i}>{`${v} minute${v != 1 ? "s" : ""
                                                                            }`}</option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label htmlFor="trackingCode" className="form__label">
                                                        Tracking Code:&nbsp;
                                                        <Tooltip>
                                                            {"Tracking code can be appended to the end of the URL.\n\n" +
                                                                "The following are constant keys for article specific value substitution:\n\n" +
                                                                "[UserId] : The ID of the user who shared the article.\n\n" +
                                                                "[ArticleId] : The ID of the sharing article\n\n" +
                                                                "[mmddyy] : Date when the user shared the article in mmddyy format\n\n" +
                                                                "[yyyymmdd] : Date when the user shared the article in yyyymmdd format\n\n" +
                                                                "[StreamName] : Name of the stream the article was shared from"}
                                                        </Tooltip>
                                                    </label>
                                                    <input
                                                        id="trackingCode"
                                                        type="text"
                                                        className="form__value"
                                                        onChange={event => this._onFieldUpdate("trackingCode", event)}
                                                        value={trackingCode ? trackingCode : ""}
                                                    />
                                                </div>

                                                <div className="form__group">
                                                    <label htmlFor="trackingCodeDomain" className="form__label">Tracking Code Domain:</label>
                                                    <input
                                                        id="trackingCodeDomain"
                                                        type="text"
                                                        className="form__value"
                                                        onChange={event => this._onFieldUpdate("trackingCodeDomains", event)}
                                                        value={trackingCodeDomains ? trackingCodeDomains : ""}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    }

                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">
                                                    Custom Config Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getConfigSettings()}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"6"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">
                                                    e-Communication Settings:
                                                    <span
                                                        style={{
                                                            float: "right",
                                                            marginRight: "15px"
                                                        }}
                                                    >
                                                        Off/On
                                                    </span>
                                                </label>
                                                <PermissionSet
                                                    permissions={this._getECommunicationSettings()}
                                                    _onChange={this._onFieldUpdate}
                                                    setNumber={"7"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">LiveSocial Text Settings:</label>
                                                <PermissionSet
                                                    permissions={this._getSMSSettings()}
                                                    _onChange={this._onSharingSettingChange}
                                                    setNumber={"8"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form">
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label className="form__label">Email Notification Settings:</label>
                                                <PermissionSet
                                                    permissions={this._getEmailNotificationSettings()[0]}
                                                    _onChange={(key, value) =>
                                                        this.setState({ systemEmails: { ...this.state.systemEmails, [key]: value } })
                                                    }
                                                    setNumber={"9"}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label className="form__label">&nbsp;</label>
                                                <PermissionSet
                                                    permissions={this._getEmailNotificationSettings()[1]}
                                                    _onChange={(key, value) =>
                                                        this.setState({ systemEmails: { ...this.state.systemEmails, [key]: value } })
                                                    }
                                                    setNumber={"10"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        {/* Card for editing the default values for Earned Media Value (EMV) report */}
                        <Row>
                            <div className="col-sm-12">
                                <div className="ibox">
                                    <div className="ibox-content form" id="emv-inputs">
                                        <div className="form__row">
                                            <div className="form__group form__group--full">
                                                <label className="form__label">Earned Media Value:</label>
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center">
                                            <div className="form__group" style={{ padding: "0px", marginBottom: "16px", borderBottom: "solid 1px #ccc" }}>
                                                <label className="form__label">LinkedIn&nbsp;</label>
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center" style={{ padding: "15px 20px 0px" }}>
                                            <div className="form__group">
                                                <label htmlFor="linkedInCPClick" className="form__label">Cost Per Click:&nbsp;</label>
                                                <input
                                                    id="linkedInCPClick"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("linkedInCPClick", event)}
                                                    value={linkedInCPClick}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="linkedInCPLike" className="form__label">Cost Per Like:&nbsp;</label>
                                                <input
                                                    id="linkedInCPLike"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("linkedInCPLike", event)}
                                                    value={linkedInCPLike}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px 15px 20px" }}>
                                            <div className="form__group">
                                                <label htmlFor="linkedInCPComment" className="form__label">Cost Per Comment:&nbsp;</label>
                                                <input
                                                    id="linkedInCPComment"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("linkedInCPComment", event)}
                                                    value={linkedInCPComment}
                                                />
                                            </div>
                                            <div className="form__group"></div>
                                        </div>
                                        <div className="form__row flex__row--center">
                                            <div className="form__group" style={{ padding: "0px", marginBottom: "16px", borderBottom: "solid 1px #ccc" }}>
                                                <label className="form__label">Facebook&nbsp;</label>
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center" style={{ padding: "15px 20px 0px" }}>
                                            <div className="form__group">
                                                <label htmlFor="facebookCPClick" className="form__label">Cost Per Click:&nbsp;</label>
                                                <input
                                                    id="facebookCPClick"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("facebookCPClick", event)}
                                                    value={facebookCPClick}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="facebookCPLike" className="form__label">Cost Per Like:&nbsp;</label>
                                                <input
                                                    id="facebookCPLike"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("facebookCPLike", event)}
                                                    value={facebookCPLike}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px 15px 20px" }}>
                                            <div className="form__group">
                                                <label htmlFor="facebookCPComment" className="form__label">Cost Per Comment:&nbsp;</label>
                                                <input
                                                    id="facebookCPComment"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("facebookCPComment", event)}
                                                    value={facebookCPComment}
                                                />
                                            </div>
                                            <div className="form__group">
                                                {/* Commented out since it may be required in the future */}
                                                {/* <label htmlFor="" className="form__label">Cost Per Video View:&nbsp;
                                                    <Tooltip>
                                                        Cost Per Video View information is not available for Facebook.
                                                    </Tooltip>
                                                </span>
                                                <input
                                                    type="text"
                                                    value={0}
                                                    disabled
                                                /> */}
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center">
                                            <div className="form__group" style={{ padding: "0px", marginBottom: "16px", borderBottom: "solid 1px #ccc" }}>
                                                <label className="form__label">X (Twitter)&nbsp;</label>
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center" style={{ padding: "15px 20px 0px" }}>
                                            <div className="form__group">
                                                <label htmlFor="twitterCPClick" className="form__label">Cost Per Click:&nbsp;</label>
                                                <input
                                                    id="twitterCPClick"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("twitterCPClick", event)}
                                                    value={twitterCPClick}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="twitterCPLike" className="form__label">Cost Per Like:&nbsp;</label>
                                                <input
                                                    id="twitterCPLike"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("twitterCPLike", event)}
                                                    value={twitterCPLike}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px 15px 20px" }}>
                                            <div className="form__group">
                                                <label htmlFor="twitterCPComment" className="form__label">Cost Per Comment:&nbsp;</label>
                                                <input
                                                    id="twitterCPComment"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("twitterCPComment", event)}
                                                    value={twitterCPComment}
                                                />
                                            </div>
                                            <div className="form__group">
                                                {/* Commented out since it may be required in the future */}
                                                {/* <label htmlFor="" className="form__label">Cost Per Video View:&nbsp;
                                                    <Tooltip>
                                                        Cost Per Video View information is not available for Twitter.
                                                    </Tooltip>
                                                </span>
                                                <input
                                                    type="text"
                                                    value={0}
                                                    disabled
                                                /> */}
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center">
                                            <div className="form__group" style={{ padding: "0px", marginBottom: "16px", borderBottom: "solid 1px #ccc" }}>
                                                <label className="form__label">Instagram&nbsp;</label>
                                            </div>
                                        </div>
                                        <div className="form__row flex__row--center" style={{ padding: "15px 20px 0px" }}>
                                            <div className="form__group">
                                                <label htmlFor="instagramCPLike" className="form__label">Cost Per Like:&nbsp;</label>
                                                <input
                                                    id="instagramCPLike"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("instagramCPLike", event)}
                                                    value={instagramCPLike}
                                                />
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="instagramCPComment" className="form__label">Cost Per Comment:&nbsp;</label>
                                                <input
                                                    id="instagramCPComment"
                                                    type="text"
                                                    onChange={event => this._onFieldUpdate("instagramCPComment", event)}
                                                    value={instagramCPComment}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__row" style={{ padding: "0px 20px 15px 20px" }}>
                                            <div className="form__group">
                                                {/* Commented out since it may be required in the future */}
                                                {/* <label htmlFor="" className="form__label">Cost Per Click:&nbsp;
                                                    <Tooltip>
                                                        Cost Per Click information is not available for Instagram.
                                                    </Tooltip>
                                                </span>
                                                <input
                                                    type="text"
                                                    value={0}
                                                    disabled
                                                /> */}
                                            </div>
                                            <div className="form__group">
                                                {/* Commented out since it may be required in the future */}
                                                {/* <label htmlFor="" className="form__label">Cost Per Video View:&nbsp;
                                                    <Tooltip>
                                                        Cost Per Video View information is not available for Instagram.
                                                    </Tooltip>
                                                </span>
                                                <input
                                                    type="text"
                                                    value={0}
                                                    disabled
                                                /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </fieldset>
                </form>
                {this.state.showSharingPermissionsModal &&
                    (<Modal show={this.state.showSharingPermissionsModal} onHide={() => this._closeModal()} aria-labelledby="ModalHeader">
                        <Modal.Header closeButton={true}>
                            <Modal.Title id='ModalHeader'>Disabled Sharing Permissions</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <div>
                                    <p>By disabling "Allow Content Specific Sharing Permissions," read-only content and notifications will no longer be available.
                                        Please choose how you would like to handle your existing read-only content:</p>
                                </div>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "top",
                                    flexWrap: "wrap"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: "45%",
                                        marginRight: "10px"
                                    }}>
                                        <Button onClick={(event) => this._handleReadOnlyContent(event, "keep")}>Keep content</Button>
                                        <p>Your read-only content and notifications will be kept, but it will now be sharable. Please ensure stream names are updated accordingly.</p>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: "45%",
                                        marginLeft: "10px"
                                    }}>
                                        <Button onClick={(event) => this._handleReadOnlyContent(event, "delete")}>Delete content</Button>
                                        <p>Your read-only content and notifications will be deleted from the library and no longer visible to users</p>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>)}
            </Wrapper>
        );
    }
    _handleReadOnlyContent(event, action) {
        this.setState({ showSharingPermissionsModal: false, skipModal: true }, () => {
            if (action === "delete") {
                ClientActions.doRemoveReadOnlyContent(this.state.cid);
                this._onSubmit(event, false, true);
            } else if (action === "keep") {
                this._onSubmit(event);
            }
        });
    }
    _closeModal() {
        this.setState({
            allowContentSpecificPermissions: true,
            showSharingPermissionsModal: false
        });
    }
    _renderCode() {
        const { code } = this.state;
        if (this.state.insert) {
            return;
        }
        return (
            <div className="form__row">
                <div className="form__group">
                    <label htmlFor="code" className="form__label">Code:</label>
                    <input id="code" type="text" className="form__value" value={code ? code : ""} disabled="true" />
                </div>
                <div className="form__group" />
            </div>
        );
    }
    _renderEmailSection(emailType) {
        if (!this.state || !this.state.customEmails) {
            return;
        }
        if (!this.state.customEmails[emailType]) {
            const client = Client();
            if (client.customEmails[emailType]) {
                this.setState({
                    customEmails: { ...this.state.customEmails, [emailType]: client.customEmails[emailType] }
                });
            }
            return;
        }
        const lang = this.state[`__${emailType}-lang`] || "en";
        if (emailType != "ReengagementEmail") {
            return (
                <div className="form__row">
                    <div className="form__group form__group--full">
                        <span
                            className="form__label"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                textTransform: "capitalize"
                            }}
                        >
                            {emailType.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase()}:{" "}
                            <a
                                className="btn brandPrimary--bg  btn--sm"
                                style={{ marginLeft: "5px" }}
                                href="/siteTemplates/img/emailGuideInternalV2.pdf"
                                target="_blank">
                                {" "}
                                <i className="fa fa-question-circle" /> Instructions
                            </a>
                            <div
                                className="select__wrapper"
                                style={{
                                    marginLeft: "auto",
                                    minWidth: "150px",
                                    maxWidth: "150px"
                                }}
                            >
                                <select value={lang} onChange={event => this._onEmailLangUpdate(emailType, event)} aria-label={lang}>
                                    <option value="en">English</option>
                                    <option value="fr">French</option>
                                    {/* <option value="es">Spanish</option>
                                    <option value="de">German</option>
                                    <option value="pt">Portuguese</option>
                                    <option value="it">Italian</option> */}
                                </select>
                            </div>
                        </span>
                        <input
                            type="text"
                            placeholder="Email Subject"
                            className="form__value"
                            onChange={event => this._onCustomEmailUpdate(emailType, "subject", lang, event)}
                            value={
                                this.state.customEmails[emailType][lang]
                                    ? this.state.customEmails[emailType][lang]["subject"]
                                    : ""
                            }
                        />
                        <br />
                        <textarea
                            placeholder="Email Body"
                            className="form__value"
                            onChange={event => this._onCustomEmailUpdate(emailType, "body", lang, event)}
                            style={{ minHeight: "250px" }}
                            value={
                                this.state.customEmails[emailType][lang]
                                    ? this.state.customEmails[emailType][lang]["body"]
                                    : ""
                            }
                        />
                        <Button
                            className="btn brandPrimary--bg  btn--sm"
                            style={{ width: "8%", marginTop: "5px" }}
                            disabled={(this.state.customEmails[emailType][lang]["subject"] == "") || (this.state.customEmails[emailType][lang]["body"] == "")}
                            onClick={e => {
                                (this.state.customEmails[emailType][lang] &&
                                    !this.state.customEmails[emailType][lang]["body"]) ||
                                    !this.state.customEmails[emailType][lang]["subject"]
                                    ? e.preventDefault()
                                    : this.setState({ previewModalOpen: true, emailType: emailType });
                            }}>
                            <i className={`fa fa-eye`} /> Preview</Button>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="form__row">
                    <div className="form__group form__group--full">
                        <span
                            className="form__label"
                            style={{
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            Re-engagement Email:&nbsp;
                            <Tooltip> This email can be triggered from the Users page and will be sent to all users that have shared before, <br />
                                but have not published a share within the past 30 days.</Tooltip>
                            <div
                                className="select__wrapper"
                                style={{
                                    marginLeft: "auto",
                                    minWidth: "150px",
                                    maxWidth: "150px"
                                }}
                            >
                                <select value={lang} onChange={event => this._onEmailLangUpdate(emailType, event)} aria-label={lang}>
                                    <option value="en">English</option>
                                    <option value="fr">French</option>
                                    {/* <option value="es">Spanish</option>
                                    <option value="de">German</option>
                                    <option value="pt">Portuguese</option>
                                    <option value="it">Italian</option> */}
                                </select>
                            </div>
                        </span>
                        <input
                            type="text"
                            placeholder="Email Subject"
                            className="form__value"
                            onChange={event => this._onCustomEmailUpdate(emailType, "subject", lang, event)}
                            value={
                                this.state.customEmails[emailType][lang]
                                    ? this.state.customEmails[emailType][lang]["subject"]
                                    : ""
                            }
                        />
                        <br />
                        <textarea
                            placeholder="Email Body"
                            className="form__value"
                            onChange={event => this._onCustomEmailUpdate(emailType, "body", lang, event)}
                            style={{ minHeight: "250px" }}
                            value={
                                this.state.customEmails[emailType][lang]
                                    ? this.state.customEmails[emailType][lang]["body"]
                                    : ""
                            }
                        />
                        <Button
                            className="btn brandPrimary--bg  btn--sm"
                            style={{ width: "8%", marginTop: "5px" }}
                            disabled={(this.state.customEmails[emailType][lang]["subject"] == "") || (this.state.customEmails[emailType][lang]["body"] == "")}
                            onClick={e => {
                                (this.state.customEmails[emailType][lang] &&
                                    !this.state.customEmails[emailType][lang]["body"]) ||
                                    !this.state.customEmails[emailType][lang]["subject"]
                                    ? e.preventDefault()
                                    : this.setState({ previewModalOpen: true, emailType: emailType });
                            }}>
                            <i className={`fa fa-eye`} /> Preview</Button>
                    </div>
                </div>
            );
        }

    }
}
CreateClient.allowSuper = true;
CreateClient.allowApiAdmin = false;
CreateClient.allowSuperClientAdmin = true;
CreateClient.allowClientAdmin = true;
CreateClient.allowAdmin = false;
CreateClient.allowCurator = false;
CreateClient.allowReports = false;
const mapStateToProps = state => ({
    admins: state.lists.admins,
    companies: state.lists.companies,
    clients: state.lists.clients,
    user: state.session.admin
});

export default connect(mapStateToProps)(CreateClient);
